(function () {
    'use strict';

    angular
        .module('UNIFYPortal', [
            'ngStorage',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            'angular-loading-bar',
            'toastr',
            'isteven-multi-select',
            'ngBootbox'
        ])
        .config(['toastrConfig', '$ngBootboxConfigProvider', config])
        .run(run);

    run.$inject = ['stateHandler', 'translationHandler'];

    config.$inject = ['toastrConfig', 'ngBootboxConfigProvider'];


    function run(stateHandler, translationHandler) {
        stateHandler.initialize();
        translationHandler.initialize();
    }

    function config(toastrConfig, $ngBootboxConfigProvider) {
        // $ngBootboxConfigProvider.setDefaultLocale('zh_CN');
    }

})();

(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .factory('UploadFileService', UploadFileService);

    UploadFileService.$inject = ['toastr', '$translate', '$q', 'UploadService'];

    function UploadFileService(toastr, $translate, $q, UploadService) {
        /**
         * @param {*} file  上传的文件
         * @param {*} limitFileType 文件类型限制
         * @param {*} size 尺寸
         */
        function uploadFile(file,limitFileType,size) {
            if (file == null) {
                return;
            }
            var limitFileType = limitFileType || [];
            
            var fileType = file.name.substring(file.name.lastIndexOf('.') + 1, file.name.length); //类型
            if (limitFileType.length !== 0 && limitFileType.indexOf(fileType.toLowerCase()) === -1) {
                toastr.warning($translate.instant('toastr.upload.pleaseup') + $translate.instant('toastr.upload.correctType'));
                return;
            }
            var filesize = file.size;
            var maxfilesize = (size || 10) * 1024 * 1024;
            if (filesize > maxfilesize) {
                toastr.warning($translate.instant('global.error.fileBig'));
                return;
            }
            var fileId;
            var defer = $q.defer();
            var promise = UploadService.uploadFile(file);
            promise.success(function (data) {
                toastr.success($translate.instant('toastr.uploadSuccess'));
                defer.resolve(data);
            }).error(function (error) {
                // console.log(error);
                // toastr.error($translate.instant('toastr.optFail'));
                defer.reject(error);
            });
            return defer.promise;
        }
        return uploadFile
    }
})();
(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .factory('UploadService', UploadService);

    UploadService.$inject = ['HttpService', 'RESTHOST', 'RESTURIS', 'Upload', '$http'];

    function UploadService(HttpService , RESTHOST, RESTURIS, Upload, $http) {
        var service = {
           uploadFile:uploadFile,
           downLoadFile:downLoadFile,
           getFileUrl:getFileUrl
        };
        return service;
         //上传文档
        function uploadFile(file) {
            return Upload.upload({
                url: RESTHOST.DATA_HOST + RESTURIS.UPLOAD.UPLOADFILE,
                file: file
            })
        }
        //下载文档
        function downLoadFile(params) {
            var fileId = params.fileId;
            window.open(getFileUrl(fileId));
        }

        function getFileUrl(fileId){
           return RESTHOST.DATA_HOST + RESTURIS.UPLOAD.DOWNLOADFILE + "/" + fileId;
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('UNIFYPortal')
        .factory('ModalService', ModalService);
    
    ModalService.$inject = ['$uibModal'];

    function ModalService($uibModal) {
        var modalInstance = {};
        var modalSymbolArr = [];
        var modalSymbol;
        var _callback;

        var service = {
            modalInstance: modalInstance,
            modalSymbolArr:modalSymbolArr,
            showModal: showModal,
            closeModal: closeModal,
            dismissModal: dismissModal,
            getLastModalId: getLastModalId,
            dismissAllModal: dismissAllModal 
        };

        return service;

        function dismissAllModal() {
            // $uibModal.dismissAll();
            modalSymbolArr.length = 0;
            for (var key in modalInstance) {
                dismissModal(key);
            }
        }

        function showModal(params) {
            if (params.callback) {
                _callback = params.callback;
            }

            var modalParams = {};

            modalParams.templateUrl = params.templateUrl;
            modalParams.controller = params.controller;
            if (params.controllerAs) {
                modalParams.controllerAs = params.controllerAs;
            }

            modalParams.size = params.size || 'lg';
            // modalParams.backdrop = params.backdrop || 'static';
            if (params.backdrop) {
                modalParams.backdrop = params.backdrop;
            }
            if (params.resolve) {
                modalParams.resolve = params.resolve;
            }

            // if (!_.includes(modalSymbolArr, params.modalId)) {
            //     modalSymbolArr.push(params.modalId);
            // }

            if (modalSymbolArr.indexOf(params.modalId)==-1) {
                modalSymbolArr.push(params.modalId);
            }

            modalInstance[params.modalId] = $uibModal.open(modalParams);
            return modalInstance[params.modalId];
        }

        function closeModal(key, data) {
            clearImgPreview();
            if (data) {
                modalInstance[key].close(data);
            } else {
                modalInstance[key].close();
            }

            delete modalInstance[key];
            modalSymbolArr.pop(key);
            if (typeof(_callback) === 'function') {
                _callback();
            }
        }

        function dismissModal(key) {
            clearImgPreview();
            modalInstance[key].dismiss();
            delete modalInstance[key];
            modalSymbolArr.pop(key);
            if (typeof(_callback) === "function") {
                _callback();
            }
        }

        function getLastModalId() {
            var modalId = '';

            if (modalSymbolArr) {
                modalId = modalSymbolArr[modalSymbolArr.length - 1];
            }

            return modalId;
        }

        function clearImgPreview() {
            while(modalSymbolArr[modalSymbolArr.length-1]==='previewdoc') {
                // modalInstance['previewdoc'].close();
                // delete modalInstance['previewdoc'];
                modalSymbolArr.pop('previewdoc');
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .factory('HttpService', HttpService);

    HttpService.$inject = ['$rootScope', '$http', '$q', '$log', '$window', 'showMsgService', '$state', '$translate', 'ErrorCode'];

    function HttpService($rootScope, $http, $q, $log, $window, showMsgService, $state, $translate, ErrorCode) {
        var _config, _send, _timeout, _serviceUrl;
        _timeout = 60000;
        _config = function (method, url, options) {
            var c;
            c = {
                method: method,
                url: url,
                timeout: _timeout,
                params: options
            };
            if (method === 'POST' || method === 'PUT' || method === 'PATCH') {
                c = {
                    method: method,
                    url: _serviceUrl,
                    timeout: _timeout,
                    data: options
                };
            }
            if (method === 'DELETE') {
                c = {
                    method: method,
                    url: _serviceUrl,
                    timeout: _timeout
                };
                return angular.extend({}, c);
            }
            return angular.extend({}, c, options);
        };
        _send = function (verb, url, options) {
            options = options || {};
            return $http(_config(verb, url, options));
        };

        return {
            request: function (txType, txCode, reqParams, methodCode, loading) {
                var loadimg = loading === false ? false : true;
                if (angular.isUndefined(reqParams)) {
                    reqParams = {};
                }

                var paramsTemp = angular.toJson(reqParams);
                var params = {
                    data: paramsTemp
                };

                var defer = $q.defer();

                _serviceUrl = txType + txCode;

                if (methodCode === "GET") {
                    params = reqParams;
                }
                if (loadimg) {
                    showMsgService.wait_submit();
                }

                _send(methodCode, _serviceUrl, params).then(function (response) {
                    showMsgService.close_wait_submit();
                    $rootScope = response.data;
                    defer.resolve(response.data);

                }, function (err) {

                    if (err.headers('X-RC-API-Response-Status')) {

                        var code = err.headers('X-RC-API-Response-Status');
                        var msg = $translate.instant('errorMsg.' + code);

                        // compatible down with old error message config.
                        if (msg.indexOf('errorMsg.') > -1) {
                            msg = err.headers('X-RC-API-Response-Message');
                        }

                        showMsgService.close_wait_submit();

                        // showMsgService.showMsg(2, $translate.instant('global.error.errorCode') + code,  msg ? msg : code);
                        ErrorCode.findError(code);
                    }
                    else {

                        if (err.data && err.data.code) {
                            ErrorCode.findError(err.data.code);
                        }
                        else {
                            showMsgService.close_wait_submit();
                            showMsgService.showMsg(2, $translate.instant('global.error.networkError'));
                            $rootScope.data = err;
                            $log.log(err);
                        }
                    }

                    defer.reject(err);

                    //showMsgService.close_wait_submit();
                    //$rootScope = errorMsg;
                    //console.log(errorMsg);
                    //defer.reject(errorMsg);
                });

                return defer.promise;
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .factory('CommonService', CommonService);

    CommonService.$inject = ['$http', '$sessionStorage', '$q', 'RESTHOST', 'RESTURIS','$filter'];

    function CommonService($http, $sessionStorage, $q, RESTHOST, RESTURIS,$filter) {
        var service = {
            queryBankList: queryBankList,
            transferProps: transferProps,
            upcase: upcase,
            filterCreditlist:filterCreditlist,
            transferPropsObj:transferPropsObj,
            isEmptyObject:isEmptyObject,
            toStdAmount:toStdAmount,
            getCurrentTimezone:getCurrentTimezone
        };

        return service;

        /**
         * 获取所有下拉列表
         * @param {object} param {orgRole:roleId,bl:BL of the role}
         */
        function queryBankList(param) {
            var deferred = $q.defer();
            var promise = $http.get(RESTHOST.DATA_HOST + RESTURIS.COMMON.ORGINFOS + '?orgRole=' + param.orgRole);
            promise.then(function (data) {
                if (data) {
                    deferred.resolve(data);
                }
            }).catch(function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        };

        //Org转bank
        function transferProps(banklist) {
            var result = [];
            angular.forEach(banklist.content,function(item){
                var tmp = {};
                tmp.id = item.id;
                tmp.name = item.orgName;
                tmp.nameEn=item.orgNameEn;
                tmp.code = item.orgCode;
                tmp.address = item.orgAddress;
                tmp.faxNum = item.faxNum;
                tmp.postCode = item.orgPostNo;
                tmp.phoneNum = item.managerPhone;
                result.push(tmp);
            });
            
            return result;
        }
        
        function transferPropsObj(item) {
            if (!item) {
                return;
            }
            var tmp = {};
            tmp.id = item.id;
            tmp.name = item.orgName;
            tmp.code = item.orgCode;
            tmp.address = item.orgAddress;
            tmp.faxNum = item.faxNum;
            tmp.postCode = item.orgPostNo;
            tmp.phoneNum = item.managerPhone;
            return tmp;
        }

        function upcase(sum) {
            var sum1 = '';
            if (sum !== null && sum !== "" && !angular.isUndefined(sum)) {
                if (!isNaN(sum)) {
                    sum = sum.toString();
                }
                sum = sum.replace(/[^0-9.]/g, "");
                if (sum) {
                    var tmp = sum.toString().split(',').join('');
                    sum1 = $filter('moneyUpcase')(tmp);
                }
            } else {
                sum1 = null;
            }
            return sum1;
        }

        function filterCreditlist(creditlist) {
            var newcreditlist = [];
            var orgId = sessionStorage.getItem('orgId');
            angular.forEach(creditlist,function(item){
                if (item.establishBank.id === orgId) {
                    newcreditlist.push(item);
                }
            });
            return newcreditlist;
        }

        function isEmptyObject(e) {
            var t;
            for (t in e) 
                return !1;
            return !0;
        }

        /**
         * 去掉数值千分符
         * @param {*} sAmount 
         */
        function toStdAmount(sAmount) {
            var sComma = /\,/gi;
            if (!sAmount) {
                return;
            }

            var sResult = sAmount.replace(sComma,"");
            var iDotIndex = sResult.indexOf('.');
            var iLength = sResult.length;
            var toMatchNaNum = /\D/;
            if ((iDotIndex !=-1 && (iLength - iDotIndex >3 || toMatchNaNum.test(sResult.slice(0,iDotIndex)))) || toMatchNaNum.test(sResult.slice(iDotIndex + 1, iLength))) {
                return 1;   //小数点后大于2位数，或含有非法字符
            } else {
                //将金额处理为######.##形式
                if (iDotIndex === -1) {
                    sResult = sResult + '.00';
                } else if (iDotIndex ===0) {
                    if (iLength - iDotIndex === 1) sResult = '0' + sResult + '00';
                    if (iLength - iDotIndex === 2) sResult = '0' + sResult + '0';
                    if (iLength - iDotIndex === 3) sResult = '0' + sResult;
                } else {
                    if (iLength - iDotIndex === 2) sResult = sResult + '0';
                    if (iLength - iDotIndex === 1) sResult = sResult + '00';
                }

                //处理金额非前面的零
                var sTemp = "";
                sTemp = sResult.slice(0, iDotIndex);
                sTemp = sTemp.split('.')[0];
                if (sTemp.length > 16) {
                    flag = false;
                    return 2;   //位数过长
                }
                iDotIndex = sResult.indexOf('.');
                sResult = sTemp + sResult.slice(iDotIndex); //返回####.##的形式
                return sResult;
            }
        }

        /**
         * 获取当前时区的时差，负值为东区，以分钟为单位
         */
        function getCurrentTimezone() {
            var rst = '';
            var tztime = new Date().getTimezoneOffset();
            if (tztime > 0) {
                rst = '-';
            } else if (tztime < 0 ) {
                rst = '+';
            }
            var tzminute = Math.abs(tztime / 60);
            tzminute = tzminute < 10 ? '0' + tzminute + ':00' : tzminute + ':00';
            return 'GMT' + rst + tzminute;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .factory('ArrayOptService', ArrayOptService);

    ArrayOptService.$inject =['Upload', '$http'];

    function ArrayOptService(Upload, $http) {
        var service = {
           removeRepeat:removeRepeat
        };
        return service;

        function removeRepeat(array){
            var result=[];
            for(var i=0;i<array.length;i++){
                var flag=true;
                var tmp=array[i];
                for(var j=0;j<result.length;j++){
                    if(tmp===result[j]){
                        flag=false;
                        break;
                    }
                }
                if(flag){
                    result.push(tmp);
                }
            }
            return result;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .directive('zeroForm',zeroForm);

        zeroForm.$inject = ['$filter','$parse'];
        function zeroForm($filter,$parse) {
            return {
                restrict:"A",
                require:"ngModel",
                link:function(scope, element, attrs, ctrl){
                    ctrl.$formatters.push(function(modelValue){
                        if(modelValue ==0){
                            return '';
                        } else {
                            return modelValue;
                        }
                    })
                }
            };
        }
})();

(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .factory('ValidationService', ValidationService);

    ValidationService.$inject = [];

    function ValidationService () {       
        var service = {
            validatePattern: validatePattern,
            validatePhoneNumber: validatePhoneNumber,
            containSpecial:containSpecial,
            validateCode:validateCode,
            isObject:isObject
        };
        return service;

        function validatePattern(key,value) {           
            var isValid = false;
            switch (key) {
                case 'phone':
                    isValid = validatePhoneNumber(value);
                    break;
                case 'code':
                    isValid = !containSpecial(value);
                    break;
                case 'number':
                    isValid = validateNumber(value);
                    break;
                case 'chineseOrCode':
                    isValid = !containSpecial(value) && !containChinese(value);
                    break;
                case 'numAndCode':
                    isValid = validateCode(value);
                    break;
                case 'codeNotChinese':  //不包含特殊字符和汉字
                    isValid = !containSpecial(value) && !containChinese(value);
                    break;
                case 'chinese':
                    isValid = !containChinese(value);
                    break;
                case 'object':
                    isValid = isObject(value);
                    break;
                case 'login':
                    isValid = isLogin(value);
                    break;
                case 'url':
                    isValid =checkWebsite(value);
                    break;
                default:
                    isValid = false;
                    break;
            }
            return isValid;
        }

        function validatePhoneNumber(value) {
            var regex = /^0?1[3|4|5|8|7][0-9]\d{8}$/;
            var regexp = /^(0[0-9]{2,3}-?)?([2-9][0-9]{6,7})(-[0-9]{1,4})?$/;
            return regex.test(value) || regexp.test(value);
        }

        /**
         * 是否包含特殊字符
         * @param {*} value 
         */
        function containSpecial(value) {
            // var isIntChar = RegExp(/^[a-zA-Z0-9]+$/);
            var containSpecial = RegExp(/[\ \~\!\@\#\$\￥\%\^\&\*\+\=\[\]\{\}\|\\\;\:\'\"\,\.\/\<\>\?]+/);
            // var containSpecial = RegExp(/[\ \~\!\@\#\$\%\^\&\*\_\+\=\[\]\{\}\|\\\;\:\'\"\,\.\/\<\>\?]+/);
            return (containSpecial.test(value));
        }

        function validateNumber(value) {
            var isInteger = RegExp(/^[0-9]+$/);
            return (isInteger.test(value));
        }

        function containChinese(value) {
            // var isChinese = RegExp(/^[\u4e00-\u9fa5]+$/);    //是否纯中文
            var isChinese = RegExp(/[\u4e00-\u9fa5\uf900-\uFA2D]/);
            return (isChinese.test(value));
        }

        /**
         * 必须是数字、字母和限定特殊字符的组合
         * @param {*} value 
         */
        function validateCode(value) {            
            //  必须是数字、大小写字母字母和特殊字符的组合,特殊字符只能是限定的特殊字符 ~!@#$%^&*_-=+()<>|;:'",.?·`/
             // var isValidateCode = RegExp(/^(?=.*[0-9].*)(?=.*[a-z].*)(?=.*[A-Z].*)(?=.*[~!@#$%^&*_\-=+()<>|;:'",.?·`/].*).{8,}$/);
             var isValidateCode = RegExp(/^(?![A-Za-z0-9]+$)(?![a-z0-9~!@#$%^&*_\-=+()<>|;:'",.?·`/]+$)(?![A-Za-z~!@#$%^&*_\-=+()<>|;:'",.?·`/]+$)(?![A-Z0-9~!@#$%^&*_\-=+()<>|;:'",.?·`/]+$)[a-zA-Z0-9~!@#$%^&*_\-=+()<>|;:'",.?·`/]{8,}$/);
             return isValidateCode.test(value);
        } 

        /**
         * 登录名是否合法
         * @param {*} value 
         */
        function isLogin(value){
            var isLogin = RegExp(/^[_'.@A-Za-z0-9-]*$/);
            return isLogin.test(value);
        }       

        /**
         * 判断是否是对象
         * @param {*} value 
         */
        function isObject(value) {
            if (value && value instanceof Object) {
                return true;
            } else {
                return false;
            }
        }

        /**
         * 验证网站域名
         * @param  {[String]} url [description]
         * @return true   [description]
         */
        function checkWebsite(url) {
            var reg = /^([hH][tT]{2}[pP]:\/\/|[hH][tT]{2}[pP][sS]:\/\/)(\d{1,3}\.){3}\d{1,3}:\d{1,5}$/;
            return reg.test(url);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .factory('SSOService', SSOService);

    SSOService.$inject = ['HttpService', 'RESTHOST', 'RESTURIS', '$q', '$http'];

    function SSOService(HttpService, RESTHOST, RESTURIS, $q, $http) {
        var service = {
            getSSOJwt: getSSOJwt
        };

        return service;

        function getSSOJwt(item) {
            var url = "http://" + item.ip + ":" + item.port;
            return $http.get(RESTHOST.DATA_HOST + RESTURIS.ACCOUNT.GETSSOJWT).then(function (data) {
                var param = {
                    keyFile: data.data.keyFile,
                    jwt: data.data.sso_token
                };
                return $http.post(url+ RESTURIS.ACCOUNT.SSO, param);
            });
        }

      
    }
})();
(function () {
    'use strict';
    angular
        .module('UNIFYPortal')
        .factory('showMsgService', showMsgService);
    showMsgService.$inject = ['$rootScope', 'toastr'];
    //提示框
    function showMsgService($rootScope, toastr) {
        var service = {
            showMsg: showMsg,             //提示框
            confirm: confirm,            //确认框
            time1000: time1000,         //日期转换
            wait_submit: wait_submit,    //锁屏
            close_wait_submit: close_wait_submit, //解锁
            showMenu: showMenu
        };
        return service;


        function time1000(createtime) {
            var tep = new Date(createtime * 1000);
            return tep;
        }

        //构建排序函数,已angularjs自带排序方法替代
        function compare(property) {
            return function (a, b) {
                var value1 = a[property];
                var value2 = b[property];
                return value2 - value1;
            }
        }



        /**
         * 参数：msg 提示信息
         * 参数：reside 需要提示类型 0-成功,1-警告,2-失败
         * 参数：msgTitle 提示框的title信息，默认为空
         */
        function showMsg(reside, msg, msgTitle) {
            reside = reside.toString();
            if (angular.isUndefined(msgTitle) || msgTitle === null) {
                msgTitle = "";
            }
            if (reside === "0") {
                toastr.success(msg, msgTitle);
            }
            if (reside === "1") {
                toastr.warning(msg, msgTitle);
            }
            if (reside === "2") {
                toastr.error(msg, msgTitle);
            }
        }
        /**
         * 参数：statename 路由名称
         */
        function showMenu(statename) {
            $rootScope.isHome = '';
            $rootScope.isImporter = '';
            $rootScope.isExporter = '';
            $rootScope.isBuyer = '';
            $rootScope.isSeller = '';
            $rootScope.isImporterSend = '';
            $rootScope.isImporterRec = '';
            $rootScope.isExporterSend = '';
            $rootScope.isExporterRec = '';
            $rootScope.isSellerRec = '';
            $rootScope.isSellerSend = '';
            $rootScope.isBuyerRec = '';
            $rootScope.isBuyerSend = '';
            $rootScope.isExporterDraftBox = '';
            $rootScope.isImporterDraftBox = '';
            $rootScope.isCExporter = '';
            $rootScope.isCImporter = '';
            switch (statename) {
                case '0':
                    $rootScope.isHome = 'active';
                    break;
                case '1':
                    $rootScope.isExporter = 'active';
                    $rootScope.isExporterSend = 'active';
                    break;
                case '2':
                    $rootScope.isExporter = 'active';
                    $rootScope.isExporterRec = 'active';
                    break;
                case '3':
                    $rootScope.isImporter = 'active';
                    $rootScope.isImporterSend = 'active';
                    break;
                case '4':
                    $rootScope.isImporter = 'active';
                    $rootScope.isImporterRec = 'active';
                    break;
                case '5':
                    $rootScope.isSeller = 'active';
                    $rootScope.isSellerRec = 'active';
                    break;
                case '6':
                    $rootScope.isBuyer = 'active';
                    $rootScope.isBuyerRec = 'active';
                    break;
                case '7':
                    $rootScope.isExporterDraftBox = 'active';
                    break;
                case '8':
                    $rootScope.isImporterDraftBox = 'active';
                    break;
                case '9':
                    $rootScope.isCExporter = 'active';
                    break;
                case '10':
                    $rootScope.isCImporter = 'active';
                    break;
                case '12':
                    $rootScope.isBuyer = 'active';
                    $rootScope.isBuyerSend = 'active';
                    break;
                case '13':
                    $rootScope.isSeller = 'active';
                    $rootScope.isSellerSend = 'active';
                    break;
            }
        }
        function confirm(confirmParm, backUrl) {
            sweetAlert({
                title: confirmParm.title,//"Are you sure?"
                text: confirmParm.text,//"You will not be able to recover this imaginary file!"
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: confirmParm.confirmButtonText,//"Yes, delete it!"
                closeOnConfirm: true,
                cancelButtonText: "取消"
            }, function () {
                $rootScope.$broadcast(backUrl, confirmParm);
            });
        }

        function wait_submit(messageInfo) {
            if ($("body", window.top.document).find('#pageOverlay_wait_submit').length === 0) {
                var whtml = '<div id="pageOverlay_wait_submit" style="display:none;"></div>' +
                    '<div class="waitBox" style="display:none;" id="waitBox"><img src="/content/images/loading.gif"/><span class="messageInfo">' + '加载中，请稍候' + '</span></div>';
                $("body", window.top.document).append(whtml);
                $("#waitBox", window.top.document).show();
                $("#pageOverlay_wait_submit", window.top.document).show();
            }
        }

        function close_wait_submit() {
            $("#waitBox", window.top.document).remove();
            $("#pageOverlay_wait_submit", window.top.document).remove();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();

(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .factory('Principal', Principal);

    Principal.$inject = ['FilterIgnoreConstant', '$q', 'Account', '$rootScope'];

    function Principal(FilterIgnoreConstant, $q, Account, $rootScope) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate(identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority(authoritie) {

            var userFlag = false;
            // var orgFlag = false;
            // var authorities = {
            //     user: [],
            //     org: []
            // };
            var authorities = [];
            // if (!(authoritie instanceof Object)) {
            //     authorities.user = authoritie.split(',')[0].split('-');
            //     if (authoritie.split(',')[1]) {
            //         authorities.org = authoritie.split(',')[1].split('-');
            //     } else {
            //         orgFlag = true;
            //     }
            // }
            if (!(authoritie instanceof Object)) {
                authorities = authoritie.split('-');
            }

            var urlList = FilterIgnoreConstant.url;
            // console.log(urlList);
            for (var i = 0; i < authorities.length; i++) {
                if (urlList.indexOf(authorities[i]) > -1) {
                    // userFlag = true;
                    // return userFlag;
                    return true;
                }
            }
            
            if (_identity) {
                for (i = 0; i < _identity.authorities.length; i++) {
                    for (var j = 0; j < _identity.authorities[i].functions.length; j++) {
                        //console.log(_identity.authorities[i].functions[j].url);
                        for (var k = 0; k < authorities.length; k++) {
                            if (_identity.authorities[i].functions[j].url === authorities[k]) {
                                userFlag = true;
                                break;
                            }
                        }

                    }
                }
            }


    
            // return true;
            return userFlag;
        }

        function hasAuthority(authority) {
            // if (!_authenticated) {
            //     return $q.when(false);
            // }

            // return this.identity().then(function(_id) {
            //     return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            // }, function(){
            //     return false;
            // });

            $rootScope.direction = sessionStorage.getItem('direction');
            var userFlag = false;
            var urlList = FilterIgnoreConstant.url;
            if (urlList.indexOf(authority) > -1) {
                // userFlag = true;
                // return userFlag;
                return true;
            }


            //根据session存的一级菜单的value,来获取对应菜单的权限数组;
            if ($rootScope.direction) {
                var modelOrgRole = {};
                //取得对应的角色菜单赋给用于判断角色的当前curRole数组对象中
                switch ($rootScope.direction) {
                    case "exporter": _identity.authorities.curRole = _identity.authorities.ouRole.exporter; break;
                    case "seller": _identity.authorities.curRole = _identity.authorities.ouRole.seller; break;
                    case "buyer": _identity.authorities.curRole = _identity.authorities.ouRole.buyer; break;
                    case "importer": _identity.authorities.curRole = _identity.authorities.ouRole.importer; break;
                    case "home": _identity.authorities.curRole = _identity.authorities.ouRole.home; break;
                }

                for (var j = 0; j < _identity.authorities.curRole.length; j++) {
                    if (_identity.authorities.curRole[j].url === authority) {
                        userFlag = true;
                        break;
                    }
                }
            }

            // if (_identity) {
            //     for (var i = 0; i < _identity.authorities.user.length; i++) {
            //         for (var j = 0; j < _identity.authorities.user[i].functions.length; j++) {
            //             // console.log(_identity.authorities[i].functions[j].url);
            //             if (_identity.authorities.user[i].functions[j].url === authority) {
            //                 userFlag = true;
            //                 break;
            //             }
            //         }
            //     }
            // }


            return userFlag;

        }

        function identity(force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen(account) {
                // _identity=account.userDTO.roles;


                _identity = account.data;
                account = _identity.userDTO;
                _identity.authorities = account.roles;
                

             

              
                _authenticated = true;
                deferred.resolve(_identity);
            }

            function getAccountCatch() {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated() {
            return _authenticated;
        }

        function isIdentityResolved() {
            return angular.isDefined(_identity);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .directive('percent',percent);

        percent.$inject = ['$filter','$parse','toastr'];
        function percent($filter,$parse,toastr) {
            var directive = {
                require: 'ngModel',
                restrict: 'A',
                link: linkFunc
            };
            return directive;

            function linkFunc(scope, element, attrs, ctrl) {
                var txt = '';
                // element.bind('keyup',function (event){
                //     if (!element[0].value) {
                //         return;
                //     }
                //     var txt = element[0].value.replace(/[^\d{1,}\.\d{1,}|\d{1,}]/g,'');
                //     $parse(attrs['ngModel']).assign(scope, txt);
                //     attrs.$$element[0].value = txt;
                // });

                element.bind('blur',function (event){
                    if (!element[0].value) {
                        return;
                    }
                    var txt = element[0].value;
                    var reg = /^\d+(\.\d{1,2})?$/;
                    if (!reg.test(txt)&&txt.indexOf('.')>0) {
                        var arra = txt.split('.');
                        arra[1] = arra[1].slice(0,2);
                        var newValue = Number(arra.join('.'));
                        $parse(attrs['ngModel']).assign(scope, newValue);
                        attrs.$$element[0].value = newValue;
                    }
                });
            }
            
        }
})();

(function() {
    'use strict';

    angular
        .module('UNIFYPortal')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset_password/init', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('UNIFYPortal')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset_password/finish', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('UNIFYPortal')
        .factory('Password', Password);

    Password.$inject = ['$resource','RESTHOST','RESTURIS'];

    function Password($resource,RESTHOST,RESTURIS) {
        var resourcePaht = RESTHOST.DATA_HOST+RESTURIS.USERMANAGE.CHANGEPW;
        var service = $resource(resourcePaht, {}, {});

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .directive('moneyFormat', moneyFormat);

    moneyFormat.$inject = ['$filter', '$parse', 'toastr'];
    function moneyFormat($filter, $parse, toastr) {
        var directive = {
            require: 'ngModel',
            restrict: 'A',
            link: linkFunc
        };
        return directive;

        function linkFunc(scope, element, attrs, ctrl) {
            var txt = '';
            element.bind('blur', function (event) {
                var value = element[0].value.replace(/\,/g, '');
                // var flag = /(^\d{0,13}$)|(^$\d{0,16}\.\d{1,2}$)/.test(value);
                // if (!flag) {
                //     toastr.warning('只能输入整数或最多两位小数');
                //     return false;
                // }
                txt = value === "" ? "" : $filter('number')(value, 2);
                $parse(attrs['ngModel']).assign(scope, txt);
                attrs.$$element[0].value = txt;
            })

            element.bind('change', function () {
                var value = element[0].value.replace(/\,/g, '');
                txt = $filter('number')(value, 2);
                $parse(attrs['ngModel']).assign(scope, txt);
                // attrs.$$element[0].value = txt;
            })
            //控制输入框只能输入数字和小数点
            function limit() {
                var limitV = element[0].value;
                limitV = limitV.replace(/[^0-9.]/g, "");
                //console.log(limitV);
                if (attrs.moneyMax) {
                    limitV = limitV * 1 > attrs.moneyMax ? attrs.moneyMax * 1 : limitV;
                }
                element[0].value = limitV;
                $parse(attrs['ngModel']).assign(scope, limitV);
                format();
            }

            //对输入数字的整数部分插入千位分隔符
            function format() {
                var formatV = element[0].value;
                var array = new Array();
                array = formatV.split(".");
                var re = /(-?\d+)(\d{3})/;
                while (re.test(array[0])) {
                    array[0] = array[0].replace(re, "$1,$2")
                }
                var returnV = array[0];
                for (var i = 1; i < array.length; i++) {
                    returnV += "." + array[i];
                }
                element[0].value = returnV;
            }

            scope.$watch(attrs.ngModel, function () {
                limit();
            })
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .directive('integer',integer);

        integer.$inject = ['$filter','$parse','toastr'];
        function integer($filter,$parse,toastr) {
            var directive = {
                require: 'ngModel',
                restrict: 'A',
                link: linkFunc
            };
            return directive;

            function linkFunc(scope, element, attrs, ctrl) {
                var txt = '';
                element.bind('keyup',function (event){
                    //只能输入数字和小数点
                    var txt = element[0].value.replace(/\D/g,'');
                    $parse(attrs['ngModel']).assign(scope, txt);
                    attrs.$$element[0].value = txt;
                });
            }
            
        }
})();

(function() {
    'use strict';

    angular
        .module('UNIFYPortal')
        .directive('hasNoAuthority', hasNoAuthority);

    hasNoAuthority.$inject = ['Principal'];

    function hasNoAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasNoAuthority.replace(/\s+/g, '');
            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = !Principal.hasAnyAuthority(authorities);
                    // console.log(result);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('UNIFYPortal')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
           
            // var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '');
            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.remove();
                    // element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }
                    var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '');
                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function () {
                    return Principal.isAuthenticated();
                }, function () {
                    defineVisibility(true);
                });
                attrs.$observe("hasAnyAuthority", function () {
                    defineVisibility(true);
                });
            }

        }
    }
})();
(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .directive('errSrc',errSrc);

        function errSrc() {           
            var directive = {
                restrict: 'A',
                link: linkFunc
            };
            return directive;

            function linkFunc(scope,element,attrs) {
                element.bind('error',function(){
                    if (attrs.src != attrs.errSrc) {
                        attrs.$set('src',attrs.errSrc);
                    }
                });
            }
        }
})();

(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .service('ErrorCode', ErrorCode);

    ErrorCode.$inject = ['$translate', 'showMsgService', 'errorCodeConstant'];

    function ErrorCode($translate, showMsgService, errorCodeConstant) {
        this.findError = function (code) {
            var flag = false;
            for (var key in errorCodeConstant) {
                if (key === code) {
                    // showMsgService.showMsg(2, $translate.instant('global.error.errorCode') + key, $translate.instant('global.error.' + errorCodeConstant[key]));
                    showMsgService.showMsg(2, $translate.instant('global.error.' + errorCodeConstant[key]));

                    flag = true;
                    break;
                }
            }
            if (!flag) {
                showMsgService.showMsg(2, $translate.instant('global.error.systemError'));
            }
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .directive('customPattern',customPattern);

        customPattern.$inject = ['ValidationService'];
        function customPattern(ValidationService) {           
            var directive = {
                require: 'ngModel',
                restrict: 'A',
                link: linkFunc
            };
            return directive;

            function linkFunc(scope, el, attr, ctrl) {
                if (!ctrl) return;
                var key;
                attr.$observe('customPattern',function(value) {
                    key = value;
                    ctrl.$validate();
                });

                ctrl.$validators.customPattern = function(modelValue, viewValue) {
                    if (ctrl.$isEmpty(viewValue)) return true;
                    return !ctrl.$isEmpty(viewValue) && ValidationService.validatePattern(key,viewValue);
                };
            }
        }
})();

(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .factory('Auth', Auth);

    Auth.$inject = ['$window', '$location', '$rootScope', '$state', '$sessionStorage', '$q', '$translate', 'Principal', 'AuthServerProvider', 'Account', 'LoginService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish', 'HttpService', 'RESTHOST', 'RESTURIS'];

    function Auth($window, $location, $rootScope, $state, $sessionStorage, $q, $translate, Principal, AuthServerProvider, Account, LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish, httpService, RESTHOST, RESTURIS) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            loginWithToken: loginWithToken,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount,
            sendSm: sendSm,
            sendResetPwdSm: sendResetPwdSm,
            resetPwd: resetPwd
        };

        return service;

        function activateAccount(key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize(force, event) {
            // console.log($location);
            if ($location.search().logoutFrom) {
                logout();
                $window.location.href = "http://" + $window.location.host;
                return;
            }
            if (sessionStorage.getItem('judgeLogin')) {
                var authReturn = Principal.identity(force).then(authThen);
                return authReturn;
            } else {
                authThen();
            }

            function authThen() {
                var isAuthenticated = Principal.isAuthenticated();
                // var orgStr='';
                if (!isAuthenticated && $rootScope.toState.name !== 'apply' && $rootScope.toState.name !== 'allOrg' && $rootScope.toState.name !== 'createCa' && $rootScope.toState.name !== 'caApply' && $rootScope.toState.name !== 'login') {
                    event && event.preventDefault();
                    $state.go('login');
                }

                if (isAuthenticated && ($rootScope.toState.name === 'login')) {
                    event && event.preventDefault();
                    $state.go('login-welcome');
                }

                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                // if($rootScope.toState.data.authorities){
                // console.log($rootScope.toState.authorities);
                //orgStr= $rootScope.toState.data.authorities.join('-');
                // }

                // console.log($rootScope.toState.name+','+orgStr);
                // if ($rootScope.toState.name && !Principal.hasAnyAuthority($rootScope.toState.name)) {

                //     if (isAuthenticated) {
                //         $state.go('accessdenied');
                //     }
                //     else {
                //         storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                //         $state.go('accessdenied').then(function() {
                //             LoginService.open();
                //         });
                //     }
                // }
            }
        }

        function changePassword(data, callback) {
            var cb = callback || angular.noop;

            return Password.save(data, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount(account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function sendSm(loginName) {
            var data = {
                loginName: loginName
            };

            return httpService.request(RESTHOST.DATA_HOST, RESTURIS.COMMON.VERIFY_CODE_SM, data, 'POST');
        }

        /**忘记密码时发送短信验证码 */
        function sendResetPwdSm(loginName, phone) {
            var data = {
                loginName: loginName,
                phone: phone
            };

            return httpService.request(RESTHOST.DATA_HOST, RESTURIS.COMMON.FORGET_PWD_VERIFY_CODE_SM, data, 'POST');
        }

        /**重置密码 */
        function resetPwd(myParams) {
            return httpService.request(RESTHOST.DATA_HOST, RESTURIS.COMMON.RESET_PWD, myParams, 'POST');
        }


        function login(credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();
            //var publicKey = null;
            // AuthServerProvider.getPubKey().then(function (resq){
            //     publicKey = resq.pubKey;

            // }).catch(function (error){

            // });

            return AuthServerProvider.login(credentials);
            //.then(loginThen)
            // .catch(function (err) {
            //     // logout();
            //     deferred.reject(err);
            //     return cb(err);
            // }.bind(this));


            function loginThen(data) {
                Principal.identity(true).then(function (account) {

                    deferred.resolve(data);
                });
                return cb();
            }

            //return deferred.promise;
        }

        function loginWithToken(jwt, rememberMe) {
            return AuthServerProvider.loginWithToken(jwt, rememberMe);
        }

        function logout() {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish(keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit(mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount(account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('UNIFYPortal')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http','$rootScope', '$localStorage', '$sessionStorage', '$q','RESTHOST','RESTURIS','Base64', 'HttpService'];

    function AuthServerProvider ($http,$rootScope, $localStorage, $sessionStorage, $q,RESTHOST,RESTURIS,Base64,httpService) {
        var service = {
            getToken: getToken,
            login: login,
            loginWithToken: loginWithToken,
            storeAuthenticationToken: storeAuthenticationToken,
            logout: logout,
            getPubKey: getPubKey
        };

        return service;

        function getToken () {
            return $localStorage.authenticationToken || $sessionStorage.authenticationToken;
        }

        function login (credentials) {
            var data = {
                username: credentials.username,
                password: credentials.password,
                verifyCode: credentials.verifyCode
            };
            
            //return $http.post(RESTHOST.DATA_HOST+RESTURIS.ACCOUNT.AUTH, data);
            return httpService.request(RESTHOST.DATA_HOST, RESTURIS.ACCOUNT.AUTH, data, 'POST');

            //.success(authenticateSuccess);
            
            function authenticateSuccess (data, status, headers) {
                
                // var bearerToken = headers('Authorization');
                
                // if(!bearerToken)
                //     bearerToken ='Bearer '+ data.access_token;
                
                //     // console.log("===========bearerToken========="+angular.isDefined(bearerToken) && bearerToken.slice(0, 7) === 'Bearer ');
                // if (angular.isDefined(bearerToken) && bearerToken.slice(0, 7) === 'Bearer ') {
                //     var jwt = bearerToken.slice(7, bearerToken.length);
                //     service.storeAuthenticationToken(jwt, credentials.rememberMe);
                //     // console.log("save done");
                //     return jwt;
                // }
            }
            
        }

        function getPubKey(){
            return httpService.request(RESTHOST.DATA_HOST,RESTURIS.ACCOUNT.PUBLICKEY, null, 'POST');
        }

        function loginWithToken(jwt, rememberMe) {
            var deferred = $q.defer();

            if (angular.isDefined(jwt)) {
                this.storeAuthenticationToken(jwt, rememberMe);
                deferred.resolve(jwt);
            } else {
                deferred.reject();
            }

            return deferred.promise;
        }

        function storeAuthenticationToken(jwt, rememberMe) {
            if(rememberMe){
                $localStorage.authenticationToken = jwt;
            } else {
                $sessionStorage.authenticationToken = jwt;
            }
        }

        function logout () {
            var token;
            //获取本地缓存中的token
            if($localStorage.authenticationToken){
                token = $localStorage.authenticationToken;
            } else {
                token = $sessionStorage.authenticationToken;
            }
            if(token !== null){
                var params = {
                    token: token,
                    access_token: token
                };
                //清除应用中存储的token
                httpService.request(RESTHOST.DATA_HOST,RESTURIS.ACCOUNT.LOGINOUT, params, 'GET');
            }
            
            delete $localStorage.authenticationToken;
            delete $sessionStorage.authenticationToken;
            sessionStorage.clear();
            //localStorage.clear();
            $rootScope.isLogin = false;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('UNIFYPortal')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('UNIFYPortal')
        .factory('Account', Account);

    Account.$inject = ['$resource','RESTHOST','RESTURIS'];

    function Account ($resource,RESTHOST,RESTURIS) {
        var service = $resource(RESTHOST.DATA_HOST+RESTURIS.ACCOUNT.RESOURCE, {}, {
            'get': { method: 'GET', params: {'pageSize':'10','pageIndex':'1'}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .controller('ForgetPwdController', ForgetPwdController);

    ForgetPwdController.$inject = ['RESTHOST', 'RESTURIS', 'Base64', '$rootScope', '$state', '$timeout', 'Auth', 'showMsgService', '$translate', 'ModalService', 'homeService', 'LFConstant', 'Principal', 'ArrayOptService', 'errorCodeConstant', '$document'];

    function ForgetPwdController(RESTHOST, RESTURIS, Base64, $rootScope, $state, $timeout, Auth, showMsgService, $translate, ModalService, homeService, LFConstant, Principal, ArrayOptService, errorCodeConstant, $document) {
        var vm = this;
        // 按钮样式
        vm.myBtnStyle = {
            'background-color': RESTHOST.PRIMARY_COLOR,
            'border-color': RESTHOST.PRIMARY_COLOR,
            'margin-top': '20px',
            'font-size': '16px',
            'outline': 'none'
        };
        vm.credentials = {};
        vm.hanldeSave = hanldeSave;
        vm.password = null;
        vm.rememberMe = true;
        vm.username = null;
        vm.loginfailed = {};
        $rootScope.myDirection = 'login';
        $rootScope.currentState = 'login';
        vm.passwordshow = false;
        vm.errorMsg = '';
        // 提示验证码已发送
        vm.showSmTip = false;
        vm.cancel = cancel;


        function cancel() {
            var modalId = ModalService.getLastModalId();
            ModalService.dismissModal(modalId);
        }

        vm.sendSm = function () {

            if (!vm.username) {
                showMsgService.showMsg(1, '请输入登录名');
                return;
            }
            if (!vm.phone) {
                showMsgService.showMsg(1, '请输入手机号');
                return;
            }

            Auth.sendResetPwdSm(vm.username, vm.phone)
                .then(function (data) {
                    console.log(data);

                    if (data.code === "ok") {
                        vm.showSmTip = true;

                        var countdown = 60; // 初始化倒计时变量
                        var smsButton = document.getElementById("sendSmVerifyCodeBtn");
                        smsButton.disabled = true; // 设置按钮不可点击状态
                        var verifyCodeTimer = setInterval(function () {
                            if (countdown <= 0) {
                                clearInterval(verifyCodeTimer); // 清除定时器

                                smsButton.value = "获取手机验证码"; // 修改按钮文本内容
                                smsButton.disabled = false; // 设置按钮可点击状态
                            } else {
                                smsButton.value = countdown + '秒后重新获取'; // 更新按钮显示的剩余时间

                                countdown--; // 每次循环减少1秒
                            }
                        }, 1000); // 每隔1秒执行一次
                    }
                    else {
                        vm.showSmTip = false;
                        showMsgService.showMsg(2, $translate.instant("global.error." + errorCodeConstant[data.code]));
                    }
                },
                    function (error) {
                        vm.verifyCode = '';
                    })
                .catch(function (error) {
                    vm.verifyCode = '';
                });
        }

        function hanldeSave(event) {
            event.preventDefault();

            if (vm.myform.$invalid) {
                showMsgService.showMsg(1, '请检查表单内容是否填写正确');
                return;
            }

            if (!vm.username) {
                showMsgService.showMsg(1, '请输入登录名');
                return;
            }
            if (!vm.phone) {
                showMsgService.showMsg(1, '请输入手机号');
                return;
            }

            if (!vm.verifyCode) {
                showMsgService.showMsg(1, '请输入验证码');
                return;
            }

            if (!vm.password) {
                showMsgService.showMsg(1, '请输入密码');
                return;
            }

            var pwdPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$%*&?!_])[A-Za-z\d@#$%*&?!_]{8,20}$/;
            if (!pwdPattern.test(vm.password)) {
                showMsgService.showMsg(1, '密码格式不正确');
                return;
            }

            if (!vm.passwordRepeat) {
                showMsgService.showMsg(1, '请输入确认密码');
                return;
            }

            if (vm.passwordRepeat !== vm.password) {
                showMsgService.showMsg(1, '两次输入的密码不一致');
                return;
            }

            vm.errorMsg = ''
            Auth.resetPwd({
                loginName: vm.username,
                pwd: sha512(vm.password),
                verifyCode: vm.verifyCode
            }).then(function (data) {
                if (data.code === "ok") {
                    showMsgService.showMsg(0, '密码重置成功！');
                    vm.cancel();
                } else {
                    showMsgService.showMsg(2, $translate.instant("global.error." + errorCodeConstant[data.code]));
                }

            }, function (error) {

            }).catch(function (error) {

            });
        }



    }
})();
(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .controller('ActivateController', ActivateController);

    ActivateController.$inject = ['$timeout', '$translate', '$http', 'HttpService', '$state', '$rootScope', '$scope', 'showMsgService', '$interval', 'homeService', 'HOMECONFIG', 'RESTHOST', 'Upload', '$log', 'Base64', 'OrgService', 'CommonService', '$stateParams', 'params', 'LoginWelcomeService', 'ModalService'];


    function ActivateController($timeout, $translate, $http, HttpService, $state, $rootScope, $scope, showMsgService, $interval, homeService, HOMECONFIG, RESTHOST, Upload, $log, Base64, OrgService, CommonService, $stateParams, $params, LoginWelcomeService, ModalService) {
        console.log($params);
        var vm = this;
        vm.cancel = cancel;
        vm.activeApp = {}; //传给后台的数据
        vm.checkList = []; //用户勾选角色的model列表
        vm.roleSelectStaLength = 0; //用户勾选了几个角色
        vm.flagDisable = null; //用户勾选角色 disable
        vm.downLicenceFlag = false;
        vm.downLicence = downLicence; //下载Licence
        vm.checkRole = checkRole;
        vm.queryLocalOrgList = queryLocalOrgList;
        vm.createuser = createuser;
        vm.uninstallApp = uninstallApp;
        vm.deleteEndorseOrg = deleteEndorseOrg;
        vm.roleList = []; //角色列表渲染
        vm.contact = RESTHOST.CONTACT;
        
        vm.type = 4;
        $rootScope.myDirection = 'apply';

        vm.languageFlag = sessionStorage.getItem('LA');

        init();

        function init() {
            var myparams = {
                moduleId: $params.moduleId,
                bl: $params.bl,
                subBl: $params.subBl,
                price: $params.price
            };
            var promise = LoginWelcomeService.activate(myparams);
            promise.then(function (respdata) {
                console.log(respdata);
                vm.type = respdata.type;
                vm.roleList = respdata.roleList;
                vm.activeApp = respdata.app;
                if (vm.type !== 3) {
                    vm.activeApp.orgRole = []; //选择的角色
                    // 锁死角色选择，当为福费廷，代开证，进口证
                    if (vm.activeApp.subBl === 'FFT' || vm.activeApp.subBl === 'ilc' || vm.activeApp.subBl === 'elc') {
                        vm.specialFlag = true;
                        angular.forEach(vm.roleList, function (item) {
                            if (item.roleCode === '8') {
                                item.selected = true;
                                vm.activeApp.orgRole.push('8');
                            } else if (item.roleCode === '9') {
                                item.selected = true;
                                vm.activeApp.orgRole.push('9');
                            }
                            vm.showBankNumber = true;

                        });
                    }
                    if (vm.languageFlag === 'en') {
                        vm.endorseOrgObj = respdata.app.blExtendAttributes.endorseOrgNameEn;
                    } else {
                        vm.endorseOrgObj = respdata.app.blExtendAttributes.endorseOrgName;
                    }
                }
                vm.activeApp.from = $params.from;//从哪个页面跳转来的，欢迎页或者生态圈（生态圈不可以卸载应用）
            }).catch(function (error) {
                // if (error.code === "3014") {
                //     showMsgService.showMsg(2, $translate.instant('activate.error.orgToken'));
                //     return;
                // } else {
                //     showMsgService.showMsg(2, $translate.instant('activate.error.systemError'));
                //     return;
                // }
            });
        }
        //接入点
        function queryLocalOrgList(orgName) {
            var param = {
                orgName: orgName,
                page: 0,
                size: 20,
                bl: $params.bl,
                langFlag: vm.languageFlag
            };
            return OrgService.queryLocalOrg(param).then(function (data) {
                return data.content;
            }).catch(function (error) {
                // showMsgService.showMsg(2, $translate.instant('activate.error.systemError'));
            });
        }

        //下载Licence
        function downLicence() {

            var params = {
                bl: vm.activeApp.bl,
                subBl: vm.activeApp.subBl
            };

            var promise = LoginWelcomeService.subscription(params); //调用 订阅 同样service
            promise.then(function (respdata) {
                vm.downLicenceFlag = true;
                console.log(respdata);
                if (!respdata) {
                    showMsgService.showMsg(2, $translate.instant('activate.error.trialExpire'));
                    return;
                }
                var blob = new Blob([respdata], {
                    type: "application/octet-stream"
                });
                var fileName = 'temporayToken.txt';
                if ('msSaveOrOpenBlob' in navigator) {
                    window.navigator.msSaveOrOpenBlob(blob, fileName);
                } else {
                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.download = fileName;
                    a.href = URL.createObjectURL(blob);
                    a.target = '_blank';
                    a.click();
                }

            }).catch(function (error) {
                // showMsgService.showMsg(2, $translate.instant('activate.error.systemError'));
                return;
            });
        }

        function deleteEndorseOrg() {
            delete vm.activeApp.blExtendAttributes.endorseOrg;
        }

        //关闭弹窗
        function cancel() {
            var modalId = ModalService.getLastModalId();
            ModalService.dismissModal(modalId);
        }


        vm.modelOptions = {
            debounce: {
                default: 500,
                blur: 250
            },
            getterSetter: true
        };

        //角色只能选择一类，例如 选择了出口商，就不能选择出口保理商
        //记录用户选择角色的属于A还是B类，当全不选时，disable释放。
        function checkRole(event, roleSelectSta) {
            console.log(roleSelectSta);
            vm.showBankNumber = roleSelectSta === 'A';
            if (event.target.checked) {
                vm.flagDisable = roleSelectSta;
                vm.roleSelectStaLength += 1;
            } else {
                vm.roleSelectStaLength -= 1;
                if (vm.roleSelectStaLength <= 0) {
                    vm.flagDisable = null;
                }
            }
        }

        //激活申请
        function createuser() {
            var params = {
                bl: $params.bl,
                subBl: $params.subBl,
                apiToken: vm.privateKey,
                price: $params.price
            };
            if (vm.type === 3) {
                // 再次激活
                LoginWelcomeService.reActiveApp(params)
                    .then(function (respdata) {
                        console.log(respdata);
                        swal($translate.instant('activate.reAcitveSuccess'), $translate.instant('activate.accoutInApp'), "success");
                        cancel();
                    });
            } else {
                // 首次激活
                if (vm.type === 1) {
                    if (vm.endorseOrgObj instanceof Object) {
                        vm.activeApp.blExtendAttributes.endorseOrg = vm.endorseOrgObj.id;
                    } else if (!vm.activeApp.blExtendAttributes.endorseOrg) {
                        showMsgService.showMsg(2, $translate.instant('activate.APorg'));
                        return;
                    }
                }
                angular.extend(vm.activeApp, params);

                console.log(vm.checkList);
                angular.forEach(vm.checkList, function (value, key) {
                    if (value) {
                        angular.forEach(vm.roleList, function (roleValue) {
                            if (key === roleValue.id) {
                                var roleArr = roleValue.roleCode.split(",");
                                vm.activeApp.orgRole = vm.activeApp.orgRole.concat(roleArr);
                            }
                        });


                    }
                });
                if (vm.activeApp.orgRole.length === 0) {
                    showMsgService.showMsg(2, $translate.instant('activate.nullRole'));
                    return;
                }
                console.log(vm.activeApp);
                LoginWelcomeService.activeApp(vm.activeApp)
                    .then(function (respdata) {
                        console.log(respdata);
                        swal($translate.instant('activate.acitveSuccess'), $translate.instant('activate.accoutInApp'), "success");
                        cancel();
                    });
            }
           
        }
        //卸载应用
        function uninstallApp() {
            $rootScope.$broadcast('unInstallAPP', $params.target);
            // return;
            var params = {
                bl: $params.bl,
                subBl: $params.subBl,
                moduleId: $params.moduleId
            };
            LoginWelcomeService.uninstallApp(params)
                .then(function (respdata) {
                    console.log(respdata);

                    swal($translate.instant('activate.tip'), $translate.instant('activate.uninstallAppSuccess'), "success");
                    cancel();


                }).catch(function (err) {
                    // showMsgService.showMsg(2, $translate.instant('activate.error.systemError'));
                    return;
                });
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('login', {
            parent: 'app',
            url: '/',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/pages/login/login.html',
                    controller: 'UgmLoginController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('login');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('common');

                    return $translate.refresh();
                }]
            }
        });

    }
})();

(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .controller('UgmLoginController', UgmLoginController);

    UgmLoginController.$inject = ['RESTHOST', 'RESTURIS', 'Base64', '$rootScope', '$state', '$timeout', 'Auth', 'showMsgService', '$translate', 'ModalService', 'homeService', 'LFConstant', 'Principal', 'ArrayOptService', 'errorCodeConstant'];

    function UgmLoginController(RESTHOST, RESTURIS, Base64, $rootScope, $state, $timeout, Auth, showMsgService, $translate, ModalService, homeService, LFConstant, Principal, ArrayOptService, errorCodeConstant) {
        var vm = this;
        // 登录按钮样式
        vm.myBtnStyle = {
            'background-color': RESTHOST.PRIMARY_COLOR,
            'border-color': RESTHOST.PRIMARY_COLOR,
            'outline': 'none'
        };
        // a链接样式
        vm.myLinkStyle = {
            'color': RESTHOST.PRIMARY_COLOR
        };
        vm.ICP = RESTHOST.ICP; // 备案号
        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.checksys = checksys;
        vm.showModel = showModel;
        vm.password = null;
        vm.rememberMe = true;
        vm.username = null;
        vm.loginfailed = {};
        $rootScope.myDirection = 'login';
        $rootScope.currentState = 'login';
        // vm.checksys();

        vm.downloadSrc = RESTHOST.DATA_HOST + RESTURIS.UPLOAD.DOWNLOADFILE + "/";
        vm.verifyCodeSrc = RESTHOST.DATA_HOST + RESTURIS.COMMON.VERIFY_CODE;
        // 提示验证码已发送
        vm.showSmTip = false;

        // vm.refreshVerifyCode = function () {
        //     document.getElementById("verifyCodeId").src = vm.verifyCodeSrc;
        // }

        vm.sendSm = function () {
            if (!vm.username) {
                showMsgService.showMsg(1, $translate.instant('login.showMsg.userAccount'));
                return;
            }

            Auth.sendSm(vm.username)
                .then(function (data) {
                    console.log(data);

                    if (data.code === "ok") {
                        vm.showSmTip = true;

                        var countdown = 60; // 初始化倒计时变量
                        var smsButton = document.getElementById("sendSmVerifyCodeBtn");
                        smsButton.disabled = true; // 设置按钮不可点击状态
                        var verifyCodeTimer = setInterval(function () {
                            if (countdown <= 0) {
                                clearInterval(verifyCodeTimer); // 清除定时器

                                smsButton.value = "获取手机验证码"; // 修改按钮文本内容
                                smsButton.disabled = false; // 设置按钮可点击状态
                            } else {
                                smsButton.value = countdown + '秒后重新获取'; // 更新按钮显示的剩余时间

                                countdown--; // 每次循环减少1秒
                            }
                        }, 1000); // 每隔1秒执行一次
                    }
                    else {
                        vm.showSmTip = false;
                        showMsgService.showMsg(2, $translate.instant("global.error." + errorCodeConstant[data.code]));
                    }
                },
                    function (error) {
                        vm.verifyCode = '';
                    })
                .catch(function (error) {
                    vm.verifyCode = '';
                });
        }

        // init();

        // function init() {
        //     var param = {
        //         type: '0,1,2'
        //     };
        //     homeService.getImage(param).then(function (data) {
        //         // console.log(data);
        //         if (data) {
        //             for (var i = 0, l = data.length; i < l; i++) {
        //                 if (data[i].type === '0') {
        //                     $rootScope.logo = data[i].arrayFileIds[0];
        //                 } else if (data[i].type === '1') {
        //                     vm.carousel = data[i].arrayFileIds;
        //                     angular.element("#myCarouselInstallAPP").carousel();
        //                 } else if (data[i].type === '2') {
        //                     vm.organizations = data[i].arrayFileIds;
        //                 }
        //             }
        //         }
        //     }).catch(function () {

        //     });
        //     homeService.getModules().then(function (data) {
        //         // console.log(data);
        //         vm.usableApp = data;
        //     }).catch(function (error) {
        //         // showMsgService.showMsg(2, error.message);
        //     });


        // }



        $timeout(function () {
            angular.element('#username').focus();
        });

        function cancel() {
            vm.credentials = {
                username: null,
                password: null,
                keyfile: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            // $uibModalInstance.dismiss('cancel');
        }
        var stateChangeStart = $rootScope.$on('authenticationSuccess', function () {
            sessionStorage.removeItem('wallet');
            // getAccount();
        });

        $rootScope.$on('$destroy', function () {
            stateChangeStart();
        });

        function checksys() {
            homeService.showModel().then(function (respdata) {
                vm.isCheckCa = '';
                vm.result = respdata;
                if (vm.result === null || vm.result === "") {
                    vm.showModel();
                }
            }).catch();
        }

        function showModel() {
            ModalService.showModal({
                templateUrl: 'app/home/modalPage/createca.html',
                size: 'md',
                controller: 'CreateCaController as vm',
                modalTitle: '系统设置',
                modalId: 'createCa',
                backdrop: 'static',
                keyboard: true,
                resolve: {
                    params: {}
                },
                callback: {}
            }).result.then(function (data) { });
        }

        function login(event) {

            vm.rememberMe = false;

            event.preventDefault();

            if (!vm.username) {
                showMsgService.showMsg(1, $translate.instant('login.showMsg.userAccount'));
                return;
            }

            if (!vm.password) {
                showMsgService.showMsg(1, $translate.instant('login.showMsg.userPassword'));
                return;
            }

            if (!vm.verifyCode) {
                showMsgService.showMsg(1, $translate.instant('login.showMsg.verifyCodeErr'));
                return;
            }

            // if (!sessionStorage.getItem(LFConstant.SESSION.WALLET)) {
            //     showMsgService.showMsg(1, $translate.instant('login.showMsg.userKeyFile'));
            //     //toastr.warning('请选择秘钥文件');
            //     return;
            // }

            sessionStorage.setItem("pwd", Base64.encode(vm.password));

            Auth.login({
                username: vm.username,
                password: sha512(vm.password),
                verifyCode: vm.verifyCode
                //keyfile: sessionStorage.getItem(LFConstant.SESSION.WALLET),
                //先默认为同业金融
                //channelName: "tyjr",
                //rememberMe: vm.rememberMe
            }).then(function (data) {
                vm.authenticationError = false;
                //$rootScope.$broadcast('authenticationSuccess');
                //$state.go('login-welcome');
                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is succesful, go to stored previousState and clear previousState
                // if (Auth.getPreviousState()) {
                //     var previousState = Auth.getPreviousState();
                //     Auth.resetPreviousState();
                //     $state.go(previousState.name, previousState.params);
                // }
            }, function (error) {
                vm.verifyCode = '';
                // vm.refreshVerifyCode();
            }).catch(function (error) {
                // vm.refreshVerifyCode();
                //vm.authenticationError = true;
                if (error) {
                    if (!error.data.code && error.status === 401) {
                        vm.loginfailed.type = '8';
                        // showMsgService.showMsg(2, '证书或用户名错误');
                    } else if (error.data.code === '1401') {
                        vm.loginfailed.type = '1';
                        // showMsgService.showMsg(2, '用户名或密码错误，你还有'+vm.loginfailed.times+'次机会');
                    } else if (error.data.code === '1402') {
                        vm.loginfailed.type = '2';
                        // showMsgService.showMsg(2, '账号被锁定，请在'+vm.loginfailed.time+'后登录');
                    } else if (error.data.code === '1403') {
                        vm.loginfailed.type = '3';
                        // showMsgService.showMsg(2, '账户已被删除');
                    } else if (error.data.code === '1405') {
                        vm.loginfailed.type = '4';
                        // showMsgService.showMsg(2, '账户已被禁用');
                    } else if (error.data.code === '1406') {
                        vm.loginfailed.type = '5';
                        // showMsgService.showMsg(2, '用户证书被吊销');
                    } else if (error.data.code === '1400') {
                        vm.loginfailed.type = '6';
                        // showMsgService.showMsg(2, '账户未绑定证书');
                    } else if (error.data.code === '1407') {
                        vm.loginfailed.type = '7';
                        // showMsgService.showMsg(2, '账户未未激活');
                    }
                    vm.privateKey = null;
                    sessionStorage.removeItem(LFConstant.SESSION.WALLET);

                    // vm.closeModal();

                }
            });
        }

        function getAccount() {

            var promise = Principal.identity();
            promise.then(function (data) {

                vm.account = data.userDTO;
                vm.userOrg = data.orgInfoDTO;
                vm.isAuthenticated = Principal.isAuthenticated;
                //
                vm.tmp = [];
                vm.roleList = data.userDTO.roles;
                for (var i = 0; i < vm.roleList.length; i++) {
                    vm.tmp.push(vm.roleList[i].name);
                }
                vm.rolename = ArrayOptService.removeRepeat(vm.tmp).join(',');
                sessionStorage.setItem('uRole', vm.rolename);
                vm.orgroleList = data.orgInfoDTO.orgRole;
                // console.log(vm.orgroleList);
                sessionStorage.setItem('orgId', data.orgInfoDTO.id);
                sessionStorage.setItem('orgCode', data.orgInfoDTO.orgCode);
                sessionStorage.setItem('orgName', data.orgInfoDTO.orgName);
                if (!data.orgInfoDTO.orgNameEn) {
                    sessionStorage.setItem('orgNameEn', data.orgInfoDTO.orgName);
                } else {
                    sessionStorage.setItem('orgNameEn', data.orgInfoDTO.orgNameEn);
                }
                sessionStorage.setItem('uName', data.userDTO.userName);

                $rootScope.roo_uname = sessionStorage.getItem('uName');
                $rootScope.root_orgname = sessionStorage.getItem('orgName');


            }).catch(function (error) {

            });

        }



        vm.showContent = function ($fileContent) {
            vm.content = $fileContent;
            sessionStorage.setItem(LFConstant.SESSION.WALLET, vm.content);
        };

        vm.usableAppDetail = function (item) {
            ModalService.showModal({
                templateUrl: 'app/pages/modalPage/installAPP.html',
                size: 'mlg',
                controller: 'installAPPController as vm',
                modalTitle: '安装应用',
                modalId: 'installAPP',
                backdrop: 'true',
                keyboard: true,
                resolve: {
                    params: {
                        appId: item.id,
                        type: 'detail'
                    },

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('loginWelcome');
                        return $translate.refresh();
                    }]

                },
                callback: {}
            }).closed.then(function (data) {

            });
        };

        /**点击忘记密码打开重置密码弹框 */
        vm.showResetPwdModal = function () {
            ModalService.showModal({
                templateUrl: 'app/pages/modalPage/forgetPwd.html',
                size: 'md',
                windowClass: 'forgetPwd-container',
                controller: 'ForgetPwdController as vm',
                controllerAs: 'vm',
                modalId: 'forgetPwd',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                },
                backdrop: 'static',
                callback: {}
            }).result.then(function (data) {

            });
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('UNIFYPortal')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app',
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('account');
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';
    angular
        .module('UNIFYPortal')
        .directive('accountMenu', accountMenu);

    /**
     * cfooter指令
     * @memberof sfcsFrontApp
     * @function cfooter指令
     */
    function accountMenu() {
        var directive = {
            restrict: 'AE',
            replace: true,
            templateUrl: 'app/pages/account/account.html',
            scope: {
                menu: "=",
                isLevel1: "@ngIf"
            },
            link: linkFunc
        };
        return directive;
    }

    function linkFunc(scope, element, attrs) {
        var orgLevel = sessionStorage.getItem("orgLevel");
        scope.isLevel1 = (orgLevel === 'level1');
    }
})();
(function () {
    'use strict';
    angular
        .module('UNIFYPortal')
        .constant('RoleMapConstant', {
            'menuType': [
                {
                    'value': "0",
                    'name': '按钮'
                },
                {
                    'value': "1",
                    'name': '菜单'
                }
            ],
            'stateFlag':[
                {
                    'value': true,
                    'name': '展示'
                },
                {
                    'value': false,
                    'name': '隐藏'
                },
                {
                    'value': undefined,
                    'name': '隐藏'
                }
            ]
        });
})();

(function () {
    'use strict';
    angular
        .module('UNIFYPortal')
        .constant('LFConstant', {
            'PAGE_SIZE':10,
            'SESSION': {
                'CURRENT_USER': 'CURRENT_USER',
                'WALLET': 'wallet',
                'CURRENT_COMPANY': 'CURRENT_COMPANY'
            },
            'blSelect': [{
                'value': 'FAC',
                'name': '保理'
            }, {
                'value': 'FFT',
                'name': '福费廷'
            }, {
                'value': 'XYZ',
                'name': '信用证'
            }]
        });
})();

(function () {
    'use strict';
    angular
        .module('UNIFYPortal')
        .constant('FilterIgnoreConstant', {
            'url': ['caApply','allOrg','moreNotice','apply','accessdenied','error','home', 'login','login-welcome','cardManagement','groupManagement','configManagement']
        });
})();

(function () {
    'use strict';
    angular
        .module('UNIFYPortal')
        .constant('errorCodeConstant', {
            //加入联盟链
            '00271409': 'missingParams',
            '00221410': 'accountAlreadyExists',
            '00211411': 'caKeyNotMatch',
            '00211412': 'certNotUpload',
            '00221420': 'emailexists',
            '00211422': 'resourceAddressNetworkException',
            '00231429': 'userCAPause',
            '00221432': 'telExist',
            // '11470':'certificateNetworkException',
            '00211471': 'certificateResolutionFailed',
            '00281472': 'queryCertificateIssurerFailed',
            '00211473': 'certificateVerificationSignatureFailed',
            '00211475': 'userCAPause',
            '00213006': 'certificateBusinessCategoryError',
            '00212477': 'certNotMatch',
            '00212478': 'superOrgNotFound',
            //激活
            '00211404': 'ugm.account.not.exits.or.status.illegal',
            '00221407': 'activedError',
            '00283006': 'userUnBindCA',
            '00213001': 'twicePwdError',
            '00213002': 'pwdIllegal',
            '00283003': 'bindCertQueryError',
            //登录
            '00211401': 'authentication',
            '00211402': 'userlocked',
            '00211403': 'auth.account.auth.faild',
            '00271405': 'auth.account.disabled',
            '00211406': 'auth.account.not.bind.to.any.cert',
            '00214000': 'auth.user.not.actived',
            //密码修改
            '00213004': 'pwdError5',
            '00213005': 'ugm.account.new.password.equ.old',
            '00213007': 'ugm.account.password.insufficient.length',
            '00213008': 'ugm.account.password.not.standard',
            //用户管理
            '00211419': 'loginNameExists',
            '00214001': 'pcRole',
            '00210004': 'business.card.upload.img.format.illegal',
            '00211418': 'existUser',
            '00210005': 'ugm.org.upload.logo.format.illegal',
            '00272010': 'missingParams',
            //项目内部
            '01993014': 'orgToken',
            '01993015': 'notOnline',
            '01910002': 'protal.must.agreement.not.signed',
            /**
             * 审核入圈，该圈子已经被删除
             */
            "01910008": "portal.zone.has.been.deleted",
            /**
             * 该圈子禁止加入
             */
            "01910009": "portal.zone.not.allow.apply",
            /**
             * 人数最大值
             */
            "01910010": "portal.zone.number.reached.maximum",

            "01910011": "portal.zone.not.authority.up.user.leve",

            "01910012": "portal.zone.current.has.been.del",
            //激活应用错误提示
            "01903007": "param",
            "01903009": "orgId",
            "01903010": "bl",
            "01903011": "expired",
            "01903012": "licence",
            "01910013": "portal.zone.user.has.applyed",
            "01910014": "portal.zone.user.has.voted",
            "01910015": "portal.repository.temp.not.null",
            "01910018": "portal.zone.candidate.in.voting",
            "01910019": "portal.zone.drop.out.fail.have.voting.data",
            "01910020": "portal.zone.not.allow.to.do.because.kickout.invoting",
            "01910021": "portal.zone.user.has.the.authority.of.operation",
            "01910022": "portal.zone.delete.zone.in.voting",
            "01910023": "portal.zone.has.message.in.voting",
            "01910024": "portal.zone.member.nums.gt.scale",

            "01980207": "zone.card.not.found",
            "01980208": "zone.current.org.not.owner",
            "01980209": "zone.has.no.authority.nickname",
            "01980210": "zone.current.org.has.joined.zone",

            "00208001": "platform.service.security.login.invalid",
            "00208003": "platform.service.security.password.noequal",
            "00208004": "platform.service.security.user.noexists",
            "00208005": "platform.service.security.user.notactive",
            "00208006": "platform.service.security.org.noexists",
            "00208002": "platform.service.security.param.error",
            "00208007": "platform.service.security.authenticationCode.notverify",
            "00208008": "platform.service.security.user.failed.times.exceed",
            "00208009": "platform.service.security.user.not.enabled",
            "00208010": "org.status.error",
            "00208011": "platform.service.security.system.permission.denied",
            "00208012": "platform.service.security.authenticationCode.code.expired",
            "00000001": "request.sm.verifyCode.error",
            "00202008": "platform.service.security.user.noexists",
            "00220107": "request.usePhone.error",
            "00220110": "request.sm.verifyCode.times.exceed",
            "00220111": "request.resetPwd.error",
            "00220108": "verifyCode.error",
            "00201601": "request.sm.service.config.error",
            "00201602": "request.sm.service.error"
        });
})();

(function () {
    'use strict';
    angular
        .module('UNIFYPortal')
        .constant('Ecurrency', {
            'currencyType':[{
                'value':0,
                'name':'人民币'
            },{
                'value':1,
                'name':'美元'
            },{
                'value':2,
                'name':'奥地利先令'
            },{
                'value':3,
                'name':'澳大利亚元'
            },{
                'value':4,
                'name':'比利时法郎'
            },{
                'value':5,
                'name':'加拿大元'
            },{
                'value':6,
                'name':'瑞士法郎'
            },{
                'value':7,
                'name':'西德马克'
            },{
                'value':8,
                'name':'丹麦克郎'
            },{
                'value':9,
                'name':'阿尔及利亚第纳尔'
            },{
                'value':10,
                'name':'芬兰马克'
            },{
                'value':11,
                'name':'法国法郎'
            },{
                'value':12,
                'name':'英镑'
            },{
                'value':13,
                'name':'加纳塞地'
            },{
                'value':14,
                'name':'几内亚西里'
            },{
                'value':15,
                'name':'港币'
            },{
                'value':16,
                'name':'伊拉克第纳尔'
            },{
                'value':17,
                'name':'伊朗里亚尔'
            },{
                'value':18,
                'name':'意大利里拉'
            },{
                'value':19,
                'name':'约旦第纳尔'
            },{
                'value':20,
                'name':'日元'
            },{
                'value':21,
                'name':'科威特第纳尔'
            },{
                'value':22,
                'name':'澳门元'
            },{
                'value':23,
                'name':'马来西亚元'
            },{
                'value':24,
                'name':'荷兰盾'
            },{
                'value':25,
                'name':'挪威克郎'
            },{
                'value':26,
                'name':'尼泊尔卢比'
            },{
                'value':27,
                'name':'新西兰元'
            },{
                'value':28,
                'name':'菲律宾比索'
            },{
                'value':29,
                'name':'巴基斯坦卢比'
            },{
                'value':30,
                'name':'瑞典克郎'
            },{
                'value':31,
                'name':'新加坡元'
            },{
                'value':32,
                'name':'塞拉利昂利昂'
            },{
                'value':33,
                'name':'卢布'
            },{
                'value':34,
                'name':'泰国株'
            },{
                'value':35,
                'name':'坦桑尼亚先令'
            },{
                'value':36,
                'name':'折美元'
            },{
                'value':37,
                'name':'欧元'
            }],
            'transfCurrencyType':[{
                'value':0,
                'name':'EC_RMB'
            },{
                'value':1,
                'name':'EC_USD'
            },{
                'value':2,
                'name':'EC_ATS'
            },{
                'value':3,
                'name':'EC_AUD'
            },{
                'value':4,
                'name':'EC_BEF'
            },{
                'value':5,
                'name':'EC_CAD'
            },{
                'value':6,
                'name':'EC_CHF'
            },{
                'value':7,
                'name':'EC_DEM'
            },{
                'value':8,
                'name':'EC_DKK'
            },{
                'value':9,
                'name':'EC_DZD'
            },{
                'value':10,
                'name':'EC_FIM'
            },{
                'value':11,
                'name':'EC_FRF'
            },{
                'value':12,
                'name':'EC_GBP'
            },{
                'value':13,
                'name':'EC_GHC'
            },{
                'value':14,
                'name':'EC_GNS'
            },{
                'value':15,
                'name':'EC_HKD'
            },{
                'value':16,
                'name':'EC_IQD'
            },{
                'value':17,
                'name':'EC_IRR'
            },{
                'value':18,
                'name':'EC_ITL'
            },{
                'value':19,
                'name':'EC_JOD'
            },{
                'value':20,
                'name':'EC_JPY'
            },{
                'value':21,
                'name':'EC_KWD'
            },{
                'value':22,
                'name':'EC_MOP'
            },{
                'value':23,
                'name':'EC_MYR'
            },{
                'value':24,
                'name':'EC_NLG'
            },{
                'value':25,
                'name':'EC_NOK'
            },{
                'value':26,
                'name':'EC_NPR'
            },{
                'value':27,
                'name':'EC_NZD'
            },{
                'value':28,
                'name':'EC_PHP'
            },{
                'value':29,
                'name':'EC_PKR'
            },{
                'value':30,
                'name':'EC_SEK'
            },{
                'value':31,
                'name':'EC_SGD'
            },{
                'value':32,
                'name':'EC_SLL'
            },{
                'value':33,
                'name':'EC_SUR'
            },{
                'value':34,
                'name':'EC_THB'
            },{
                'value':35,
                'name':'EC_TZS'
            },{
                'value':36,
                'name':'EC_ZMY'
            },{
                'value':37,
                'name':'EC_EUR'
            }],
            'currencyShowType':[{
                'value':'EC_RMB',
                'name':'人民币'
            },{
                'value':'EC_USD',
                'name':'美元'
            }],
            'currencyShowEnType':[{
                'value':'EC_RMB',
                'name':'CNY'
            },{
                'value':'EC_USD',
                'name':'USD'
            }],
            'mapBoolean': [{
                'value': true,
                'name': '是'
            },
            {
                'value': false,
                'name': '否'
            }],
            'sendStatus':{
                '0':'已发送',
                '1':'待发送'
            }
        });
        
})();

(function () {
    'use strict';
    angular
        .module('UNIFYPortal')
        .constant('AddrConstant', {
            'orgSelf': [{key:"myself",name:"地址管理"},{key:"others",name:"地址查看"}],
            "orgSelfEn":[{key:"myself",name:"Address Manager"},{key:"others",name:"Search Address"}],
            'orgType':[{key:"",name:"全部"},{key:"11",name:"买方"},{key:"10",name:"卖方"},{key:"4",name:"银行保理商（进口）"},{key:"5",name:"银行保理商（出口）"},{key:"17",name:"商业保理公司"}],
            'orgTypeEn':[{key:"",name:"All"},{key:"11",name:"Buyer"},{key:"10",name:"Seller"},{key:"4",name:"Importer"},{key:"5",name:"Exporter"},{key:"17",name:"Factor Company"}]
        });
})();

(function () {
    'use strict';

    angular.module('UNIFYPortal').factory('NavbarService', NavbarService);
    NavbarService.$inject = ['$resource', 'RESTHOST', 'RESTURIS', '$http'];
    function NavbarService($resource, RESTHOST, RESTURIS, $http) {


        return {
            devEnv: devEnv,
            create: create,
            active: active
        };
        function devEnv() {
            return $http.get(RESTHOST.DATA_HOST +  RESTURIS.COMMON.DEVENV);
        }
        function create(application) {
            return $http.post(RESTHOST.DATA_HOST + '/api/orginfos', application);
        }
        function active(application) {
            return $http.post(RESTHOST.DATA_HOST + '/api/login/active', application);
        }
        
    }
})();
(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$ngBootbox', '$state', 'Auth', 'Principal', 'RESTHOST', 'RESTURIS', 'Base64', 'NavbarService', 'toastr', '$rootScope', 'ModalService', 'tmhDynamicLocale', '$translate', '$q', 'ArrayOptService', 'homeService','AuthServerProvider'];

    function NavbarController($ngBootbox,  $state, Auth, Principal, RESTHOST, RESTURIS, Base64, NavbarService, toastr, $rootScope, ModalService, tmhDynamicLocale, $translate, $q, ArrayOptService, homeService, AuthServerProvider) {
        var vm = this;
        
        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.$state = $state;
        vm.adduser = adduser;
        vm.activate = activate; //弹出激活
        vm.activate1 = activate1; //下一步
        vm.goLogin = goLogin;
        vm.goWelcome = goWelcome;
        vm.direction = direction;
        vm.goPurchaseCredit = goPurchaseCredit;
        vm.goForrelaseinfo = goForrelaseinfo;
        vm.languageKey = $rootScope.languageKey ? $rootScope.languageKey : 'zh-cn';
        var orgCode = sessionStorage.getItem('orgCode');
        // vm.bl = sessionStorage.getItem('bl');
        vm.currentState = $state.current.name;
        //用户级别
        //oper/checker/super

        vm.setStatus = setStatus;
        vm.islevel1 = false;
        vm.env = 'prod';

        vm.init = init;
        // $rootScope.myDirection = 'login';
        vm.languageKey = $rootScope.languageKey ? $rootScope.languageKey : 'zh-cn';

        vm.downloadSrc = RESTHOST.DATA_HOST + RESTURIS.UPLOAD.DOWNLOADFILE + "/";
        //语言切换确认框
        if (vm.languageKey === 'en') {
            $ngBootbox.setLocale('en');
        } else {
            $ngBootbox.setLocale('zh_CN');
        }

        if (vm.isAuthenticated && orgCode) {
            //create websocket client
            /**var sockjs = new SockJS(RESTHOST.DATA_HOST + '/websocket/messages' + '?orgCode=' + orgCode);
            sockjs.onopen = function () {
                console.log('websocket is open');
                sockjs.send('test');
            }
            sockjs.onclose = function () {
                console.log('websocket is closed');
            }
            sockjs.onmessage = function (e) {
                console.log("message : " + e.data);
            }*/
        }
        var detailTitle = $rootScope.$on('detailTitle', function (event, data) {
            $rootScope.selectStatus = '3';
        });
        var isNoticeTitle = $rootScope.$on('isNoticeTitle', function (event, data) {
            vm.isNoticeTitle = 'true';
        });

        var isBeneficiaTitle = $rootScope.$on('isBeneficiaTitle', function (event, data) {
            vm.isBeneficiaTitle = 'true';
        });

        var isAccreditTitle = $rootScope.$on('isAccreditTitle', function (event, data) {
            vm.isAccreditTitle = 'true';
        });

        var authorizeFailed = $rootScope.$on('authorizeFailed', function (event, data) {
            vm.logout();
        });

        var stateChange = $rootScope.$on('stateChange', function (event, data) {
            vm.currentState = data;
            $rootScope.currentState = data;
        });
        // $rootScope.$on('globallanguagechange',function(event,data){
        //     vm.languageKey = data;
        // });

        vm.languageFlag = sessionStorage.getItem('LA');
        var stateChangeStart = $rootScope.$on('globallanguagechange', function (event, data) {
            vm.languageKey = data;
            $rootScope.languageKey = data;
            vm.languageFlag = data;
        });
        $rootScope.$on('$destroy', function () {
            stateChangeStart();
        });

        init();

        //物理节点加盟弹窗
        function showModel() {
            ModalService.showModal({
                templateUrl: 'app/home/modalPage/createca.html',
                size: 'lg',
                controller: 'CreateCaController as vm',
                modalTitle: '系统设置',
                modalId: 'createCa',
                backdrop: 'static',
                keyboard: true,
                resolve: {
                    params: {}
                },
                callback: {}
            }).result.then(function (data) {});
        }

        //加入联盟链
        function adduser() {
            homeService.showModel().then(function (respdata) {
                vm.isCheckCa = '';
                vm.result = respdata;
                if (vm.result === null || vm.result === "") {
                    showModel();
                } else {
                    // 代理加盟
                    $state.go('apply', {
                        physicalId: vm.result.value,
                        bl: vm.result.bl
                    });
                    // showModel();
                }
            }).catch();



        }

        function init() {
            $rootScope.isLogin = Principal.isAuthenticated();
            $rootScope.orgName = sessionStorage.getItem('orgName');
            $rootScope.orgNameEn = sessionStorage.getItem('orgNameEn');
            $rootScope.uRole = sessionStorage.getItem('uRole');
            $rootScope.uName = sessionStorage.getItem('uName');
            $rootScope.login = sessionStorage.getItem('login');
            $rootScope.isPhysical = sessionStorage.getItem('isPhysical') === 'true' ? true : false;
            $rootScope.myDirection = sessionStorage.getItem('mydirection') ||'login-welcome';
            angular.element(document).ready(function () {
                angular.element(".flip").mouseover(function () {
                    angular.element(".flip").next("div").slideDown(100);
                });
                angular.element(".setting").mouseleave(function () {
                    angular.element(".setting").children("div").slideUp(100);
                });
            });
            // devEnv();
            
            // homeService.getImage({
            //     type: '0'
            // }).then(function (data) {
            //     // console.log(data);
            //     vm.logo = data[0];
            // }).catch(function () {

            // });
        }

        function devEnv() {
            var promise = NavbarService.devEnv();
            promise.then(function (respdata) {
                // console.log(respdata);
                var env = respdata.data.env;
                if (env.indexOf('dev') > -1) {
                    vm.env = 'dev';
                } else if (env.indexOf('prod') > -1) {
                    vm.env = 'prod';
                } else if (env.indexOf('pre') > -1) {
                    vm.env = 'pre';
                }
            }).catch(function (error) {

            });
        }



        function logout() {
            vm.bl = '';
            Auth.logout();
            sessionStorage.setItem('LA', $rootScope.languageKey);
            ModalService.dismissAllModal();
            if ($state.current.name !== 'login') {
                $state.go('login');
                // $rootScope.myDirection = 'login';
            }
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }


        function setStatus(status) {
            $rootScope.selectStatus = status;
        }




        //跳转到激活界面
        function activate() {
            vm.firstAccount = "";
            vm.firstPassward = "";
            vm.confirmPassword = "";
            vm.password = "";
            angular.element('#myModalLogin').modal('toggle');
        }


        //激活界面，读取首次账号密码并判断
        function activate1() {

            vm.params1 = {
                firstAccount: vm.firstAccount,
                activeKey: vm.firstPassward
            };
            var password = vm.password;
            var confirmPassword = vm.confirmPassword;

            if (confirmPassword !== password) {
                toastr.warning($translate.instant('global.messages.error.dontmatch'));
            } else {

                AuthServerProvider.getPubKey().then(function (resq) {
                    var publicKey = resq.pubKey;
                    var encrypt = new JSEncrypt();
                    encrypt.setPublicKey(publicKey);
                    var params = {
                        login: vm.firstAccount,
                        activationKey: encrypt.encrypt(vm.firstPassward),
                        //password: Base64.encode(vm.firstAccount + vm.passward)
                        password: encrypt.encrypt(vm.password),
                        userName: publicKey
                    };

                    doActivate(params);
                });

                // var params = {
                //     login: vm.firstAccount,
                //     activationKey: vm.firstPassward,
                //     password: Base64.encode(vm.firstAccount + vm.password)
                // };

                // var promise = NavbarService.active(params);

                // promise.then(function (respdata) {
                //     toastr.success($translate.instant('toastr.optSuccess'));
                //     $state.go('login');
                //     $rootScope.$broadcast('QueryHomeList');
                //     angular.element('#myModalLogin').modal('toggle');
                // }).catch(function (error) {
                //     // if (error.code === '1404') {
                //     //     //vm.unbind = true;
                //     //     toastr.error($translate.instant('global.error.userError'));
                //     // } else if (error.code === '1407') {
                //     //     toastr.error($translate.instant('toastr.error.alreadyActive'));
                //     // } else if (error.code === '1406') {
                //     //     toastr.error($translate.instant('toastr.pleaseCheckCA'));
                //     // }
                //     // toastr.error($translate.instant('toastr.error.checkActiveKey'));
                // });
                
            }
        }

        function doActivate(params) {
            var promise = NavbarService.active(params);

            promise.then(function (respdata) {
                toastr.success($translate.instant('toastr.optSuccess'));
                $state.go('login');
                $rootScope.$broadcast('QueryHomeList');
                angular.element('#myModalLogin').modal('toggle');
            }).catch(function (error) {
            });
        }


        if (vm.isNoticeTitle === 'true') {
            $rootScope.selectStatus = 'established';
        } else if (vm.isBeneficiaTitle === 'true') {
            $rootScope.selectStatus = 'notified';
        } else if (vm.isAccreditTitle === 'true') {
            $rootScope.selectStatus = 'applied';
        } else {
            $rootScope.selectStatus = 'application-left';
        }

        // var sessionTimeout = $rootScope.$on('sessionTimeout', function () {
        //     if(ModalService.modalSymbolArr.indexOf('forceOffline') > -1) return;
        //     ModalService.showModal({
        //         templateUrl: 'app/pages/modalPage/forceOffline.html',
        //         size: 'md',
        //         controller: 'ForceOfflineController as vm',
        //         modalTitle: '登录超时',
        //         modalId: 'forceOffline',
        //         resolve: {
        //             params: {

        //             }
        //         },
        //         backdrop: 'static',
        //         callback: {}
        //     }).result.then(function (data) {
        //         vm.logout();
        //     });
        // });

        var otherLogin = $rootScope.$on('otherLogin', function () {
            if(ModalService.modalSymbolArr.indexOf('otherLogin') > -1) return;
            ModalService.showModal({
                templateUrl: 'app/pages/modalPage/otherLogin.html',
                size: 'md',
                controller: 'OtherLoginController as vm',
                modalTitle: '',
                modalId: 'otherLogin',
                resolve: {
                    params: {

                    }
                },
                backdrop: 'static',
                callback: {}
            }).result.then(function (data) {
                vm.logout();
            });
        });

        function goPurchaseCredit() {
            // if (Principal.hasAnyAuthority('quote,transactionhall.purchablecredits')) {
            //     $state.go('transactionhall.purchablecredits');
            // } else {
            //     $state.go('transactionhall.fordealcredits');
            // }

        }

        function goForrelaseinfo() {
            $state.go('releasehall.forreleaseinfo');
        }

        var authenticationSuccess = $rootScope.$on('authenticationSuccess', function () {
            $rootScope.isLogin = true;
            $rootScope.myDirection = 'login-welcome';
            sessionStorage.removeItem('wallet');
            getAccount().then(function (data) {
                sessionStorage.setItem("judgeLogin", true);
                vm.init();
            });
        });



        function getAccount() {
            var defer = $q.defer();
            var promise = Principal.identity();
            promise.then(function (data) {
                vm.account = data.userDTO;
                vm.userOrg = data.orgInfoDTO;
                vm.isAuthenticated = Principal.isAuthenticated;
                console.log(vm.login);
                vm.tmp = [];
                vm.roleList = data.userDTO.roles;
                for (var i = 0; i < vm.roleList.length; i++) {
                    vm.tmp.push(vm.roleList[i].name);
                }
                vm.rolename = ArrayOptService.removeRepeat(vm.tmp).join(',');
                if (!vm.rolename || angular.isUndefined(vm.rolename)) {
                    vm.rolename = "";
                }
                sessionStorage.setItem('uRole', vm.rolename);
                sessionStorage.setItem('orgId', data.orgInfoDTO.id);
                sessionStorage.setItem('orgCode', data.orgInfoDTO.orgCode);
                sessionStorage.setItem('orgLevel', data.orgInfoDTO.orgLevel);
                sessionStorage.setItem('isPhysical', data.orgInfoDTO.physical);
                sessionStorage.setItem('isSuperUser', data.userDTO.superUser);
                $rootScope.isPhysical = sessionStorage.getItem('isPhysical') === 'true' ? true : false;
                vm.islevel1 = (sessionStorage.getItem('orgLevel') === 'level1');
                sessionStorage.setItem('orgName', data.orgInfoDTO.orgName);
                if (!data.orgInfoDTO.orgNameEn) {
                    sessionStorage.setItem('orgNameEn', data.orgInfoDTO.orgName);
                } else {
                    sessionStorage.setItem('orgNameEn', data.orgInfoDTO.orgNameEn);
                }
                sessionStorage.setItem('login', data.userDTO.login);
                sessionStorage.setItem('uName', data.userDTO.userName);
                $rootScope.roo_uname = sessionStorage.getItem('uName');
                $rootScope.root_orgname = sessionStorage.getItem('orgName');
                defer.resolve('ok');
            }).catch(function (error) {
                defer.reject();
            });
            return defer.promise;
        }

        function goLogin() {
            // $rootScope.myDirection = 'login';
            $state.go('login');
        }

        function goWelcome() {
            $rootScope.myDirection = 'login-welcome';

            if (sessionStorage.getItem('bl')) {
                sessionStorage.removeItem('bl');
            }
            $state.go('login-welcome');
        }
          /**
         * 一级菜单跳转
         * @param {*} dir 
         */
        function direction(dir) {
            console.log(dir);
            sessionStorage.setItem('mydirection', dir);
            $rootScope.myDirection = dir;
            if(dir === 'ecosphere'){
                $state.go('ecosphere.contact.default');
            }else{
                $state.go(dir);
            }

        }
        vm.islevel1 = (sessionStorage.getItem('orgLevel') === 'level1');

        $rootScope.$on('$destroy', function () {
            if (angular.isDefined(detailTitle) && detailTitle !== null) {
                detailTitle();
            }
            if (angular.isDefined(isNoticeTitle) && isNoticeTitle !== null) {
                isNoticeTitle();
            }
            if (angular.isDefined(isBeneficiaTitle) && isBeneficiaTitle !== null) {
                isBeneficiaTitle();
            }
            if (angular.isDefined(isAccreditTitle) && isAccreditTitle !== null) {
                isAccreditTitle();
            }
            if (angular.isDefined(authorizeFailed) && authorizeFailed !== null) {
                authorizeFailed();
            }
            if (angular.isDefined(stateChange) && stateChange !== null) {
                stateChange();
            }
            if (angular.isDefined(authenticationSuccess) && authenticationSuccess !== null) {
                authenticationSuccess();
            }
            if (angular.isDefined(otherLogin) && otherLogin !== null) {
                otherLogin();
            }
            if (angular.isDefined(sessionTimeout) && sessionTimeout !== null) {
                sessionTimeout();
            }
        });

        vm.showInstallModal = function showInstallModal(item) {
            ModalService.showModal({
                templateUrl: 'app/pages/modalPage/installAPP.html',
                size: 'lg',
                controller: 'installAPPController as vm',
                modalTitle: '激活',
                modalId: 'installAPP',
                backdrop: 'static',
                keyboard: true,
                resolve: {
                    params: {
                        moduleId: 1,
                        bl: 'LC',
                        subBl: 'FFT'
                    },
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('loginWelcome');
                            return $translate.refresh();
                        }]
                    }
                },
                callback: {}
            });
        };
        vm.showBlSelectModal = function showBlSelectModal(event) {
            try{
                $state.go(angular.element(event.target).attr("id"));
            }catch(e){
            //   console.log(e);
            }
        };

    }
})();
(function() {
    'use strict';

    angular
        .module('UNIFYPortal')
        .directive('activeMenu', activeMenu);

    activeMenu.$inject = ['$translate', '$locale', 'tmhDynamicLocale'];

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function() {
                return $translate.use();
            }, function(selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('UNIFYPortal')
        .directive('activeLink', activeLink);

    function activeLink() {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var clazz = attrs.activeLink;
            var path = attrs.href;
            path = path.substring(1); //hack because path does bot return including hashbang
            scope.location = location;
            scope.$watch('location.path()', function(newPath) {
                if (path === newPath) {
                    element.addClass(clazz);
                } else {
                    element.removeClass(clazz);
                }
            });
        }
    }
})();

(function () {
	'use strict';
	angular
		.module('UNIFYPortal')
		.directive('cfooter', cfooter);

	/**
	 * cfooter指令
	 * @memberof sfcsFrontApp
	 * @function cfooter指令
	 */
	function cfooter() {
		var directive = {
			restrict: 'AE',
			replace: false,
			templateUrl: 'app/layouts/footer/footer.html',
			controller: 'FooterController',
			controllerAs: 'vm'
		};
		return directive;
	}
})();
(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .controller('FooterController', FooterController);

    FooterController.$inject = ['homeService', 'RESTHOST'];

    function FooterController(homeService, RESTHOST) {

        var vm = this;    
        vm.init = init;

        vm.init();
        function init() {
            vm.version = '';
            homeService.getVersion('').then(function (resp) {
                vm.version = resp.version;
            }).catch(function (error) {
                console.log(error)
            });
            vm.ICP = RESTHOST.ICP;
            vm.PUBLICSECURITYRECORDNUMBER = RESTHOST.PUBLICSECURITYRECORDNUMBER;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('UNIFYPortal')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();

/**
 * Created by ying_xiaolei on 2017/4/6.
 */
(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .factory('homeService', homeService);

    homeService.$inject = ['HttpService', 'RESTHOST', 'RESTURIS', 'HOMECONFIG'];

    //home界面service
    function homeService(HttpService, RESTHOST, RESTURIS, HOMECONFIG) {
        var service = {
            showModel: showModel,
            checkCA: checkCA,
            getCADownload: getCADownload,
            getCompany: getCompany,
            getOrgByLevel: getOrgByLevel,
            updateSysInfo: updateSysInfo,
            findCompanyFromSystem: findCompanyFromSystem,
            getVersion: getVersion,
            sendOrgInfo: sendOrgInfo,
            queryCountryLikeName: queryCountryLikeName,
            queryCountryByCode: queryCountryByCode,
            dealTime: dealTime,
            resolveTime: resolveTime,
            sendAsPost: sendAsPost,  //post
            sendAsPut: sendAsPut,    //put
            getByGet: getByGet,       //get
            deleteAsDelete: deleteAsDelete,
            getModules:getModules,
            getImage: getImage
        };
        return service;

        function sendAsPost(txtUrl, params) {
            return HttpService.request(RESTHOST.DATA_HOST, txtUrl, params, 'POST');
        }
        function deleteAsDelete(txtUrl, params) {
            return HttpService.request(RESTHOST.DATA_HOST, txtUrl, params, 'DELETE');
        }
        function sendAsPut(txtUrl, params) {
            return HttpService.request(RESTHOST.DATA_HOST, txtUrl, params, 'PUT');
        }
        function getByGet(txtUrl, params) {
            return HttpService.request(RESTHOST.DATA_HOST, txtUrl, params, 'GET');
        }
        function findCompanyFromSystem(params) {
            return HttpService.request(RESTHOST.DATA_HOST, HOMECONFIG.URL['findCompanyFromSystem'], params, 'GET');
        }

        function createModify(params) {
            return HttpService.request(RESTHOST.DATA_HOST, HOMECONFIG.URL['createModify'], params, 'POST');
        }

        function showModel(params) {
            return HttpService.request(RESTHOST.DATA_HOST, HOMECONFIG.URL['showModel'], params, 'GET');
        }

        //
        function checkCA(params) {
            return HttpService.request(RESTHOST.DATA_HOST, HOMECONFIG.URL['checkCA'], params, 'POST');
        }
        //
        function getCADownload(params) {
            return HttpService.request(RESTHOST.DATA_HOST, HOMECONFIG.URL['getCADownload'], params, 'POST');
        }
        //
        function getCompany(params) {
            return HttpService.request(RESTHOST.DATA_HOST, HOMECONFIG.URL['getCompany'], params, 'GET');
        }
        //
        function getOrgByLevel(params) {
            return HttpService.request(RESTHOST.DATA_HOST, HOMECONFIG.URL['getOrgByLevel'], params, 'GET');
        }

        function updateSysInfo(params) {
            return HttpService.request(RESTHOST.DATA_HOST, HOMECONFIG.URL['updateSysInfo'], params, 'POST');
        }

        function getVersion(params) {
            return HttpService.request(RESTHOST.DATA_HOST, HOMECONFIG.URL['getVersion'], params, 'GET');
        }

        function sendOrgInfo(params) {
            return HttpService.request(RESTHOST.DATA_HOST, HOMECONFIG.URL['sendOrgInfo'], params, 'POST');
        }

        function queryCountryLikeName(params) {
            return HttpService.request(RESTHOST.DATA_HOST, RESTURIS.COMMON.COUNTRYLIKE, params, 'GET');
        }

        function queryCountryByCode(params) {
            return HttpService.request(RESTHOST.DATA_HOST, RESTURIS.COMMON.COUNTRYCODE, params, 'GET');
        }

        function getModules(params) {
            return HttpService.request(RESTHOST.DATA_HOST, RESTURIS.COMMON.MODULES, params, 'GET');
        }

        function getImage(params) { 
            return HttpService.request(RESTHOST.DATA_HOST, RESTURIS.COMMON.GETIMAGE, params, 'GET');
        }
    
        function dealTime(date) {
            if (angular.isDefined(date)) {
                if (angular.isDate(date)) {
                    date = parseInt(date.getTime() / 1000);
                    return date;
                }
            }
            return date;
        }
        function resolveTime(date) {
            if (date === null || date === '') {
                return '';
            }else{
                return new Date(date * 1000);
            }
        }
    }
})();

/**
 * Created by ying_xiaolei on 2017/4/6.
 */
(function() {
    'use strict';

    angular
        .module('UNIFYPortal')
        .constant('HOMECONFIG', {
            URL:{
                createUser:'/user',         //预注册用户
                getBankUsers:'/api/orginfos/getAll',        //按角色获取用户列表
                getbanks:'/api/orginfos',//获取银行列表 
                showModel:'/api/isHasSystemConfFromPortal',        //判断是否需要显示首页模态框   
                showModel2:'/api/getSystemConfig',        //判断是否需要显示首页模态框 旧的   
                updateSysInfo:'/api/joinInOrgOfPhysicalNode',  //物理加盟 门户
                fileup:'/api/upload',  //文件上传   
                getIndexOrg:'/api/orginfos/index',
                checkCA:'/api/checkCA',
                getCADownload:'/api/getCA',
                getCompany:'/api/findCompany',
                getOrgByLevel:'/api/getOrgByLevelFromPortal',
                findCompanyFromSystem: '/api/findCompanyFromSystemFromPortal',
                getVersion:'/api/app/info',
                sendOrgInfo:'/api/joinInOrgOfDelegateNode'
            }
        });
})();

/*
 * [js-sha512]{@link https://github.com/emn178/js-sha512}
 *
 * @version 0.8.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2014-2018
 * @license MIT
 */
!function(){"use strict";function h(h,t){t?(p[0]=p[1]=p[2]=p[3]=p[4]=p[5]=p[6]=p[7]=p[8]=p[9]=p[10]=p[11]=p[12]=p[13]=p[14]=p[15]=p[16]=p[17]=p[18]=p[19]=p[20]=p[21]=p[22]=p[23]=p[24]=p[25]=p[26]=p[27]=p[28]=p[29]=p[30]=p[31]=p[32]=0,this.blocks=p):this.blocks=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],384==h?(this.h0h=3418070365,this.h0l=3238371032,this.h1h=1654270250,this.h1l=914150663,this.h2h=2438529370,this.h2l=812702999,this.h3h=355462360,this.h3l=4144912697,this.h4h=1731405415,this.h4l=4290775857,this.h5h=2394180231,this.h5l=1750603025,this.h6h=3675008525,this.h6l=1694076839,this.h7h=1203062813,this.h7l=3204075428):256==h?(this.h0h=573645204,this.h0l=4230739756,this.h1h=2673172387,this.h1l=3360449730,this.h2h=596883563,this.h2l=1867755857,this.h3h=2520282905,this.h3l=1497426621,this.h4h=2519219938,this.h4l=2827943907,this.h5h=3193839141,this.h5l=1401305490,this.h6h=721525244,this.h6l=746961066,this.h7h=246885852,this.h7l=2177182882):224==h?(this.h0h=2352822216,this.h0l=424955298,this.h1h=1944164710,this.h1l=2312950998,this.h2h=502970286,this.h2l=855612546,this.h3h=1738396948,this.h3l=1479516111,this.h4h=258812777,this.h4l=2077511080,this.h5h=2011393907,this.h5l=79989058,this.h6h=1067287976,this.h6l=1780299464,this.h7h=286451373,this.h7l=2446758561):(this.h0h=1779033703,this.h0l=4089235720,this.h1h=3144134277,this.h1l=2227873595,this.h2h=1013904242,this.h2l=4271175723,this.h3h=2773480762,this.h3l=1595750129,this.h4h=1359893119,this.h4l=2917565137,this.h5h=2600822924,this.h5l=725511199,this.h6h=528734635,this.h6l=4215389547,this.h7h=1541459225,this.h7l=327033209),this.bits=h,this.block=this.start=this.bytes=this.hBytes=0,this.finalized=this.hashed=!1}function t(t,s,e){var r,n=typeof t;if("string"!==n){if("object"!==n)throw new Error(i);if(null===t)throw new Error(i);if(a&&t.constructor===ArrayBuffer)t=new Uint8Array(t);else if(!(Array.isArray(t)||a&&ArrayBuffer.isView(t)))throw new Error(i);r=!0}var o=t.length;if(!r){for(var l,f=[],c=(o=t.length,0),u=0;u<o;++u)(l=t.charCodeAt(u))<128?f[c++]=l:l<2048?(f[c++]=192|l>>6,f[c++]=128|63&l):l<55296||l>=57344?(f[c++]=224|l>>12,f[c++]=128|l>>6&63,f[c++]=128|63&l):(l=65536+((1023&l)<<10|1023&t.charCodeAt(++u)),f[c++]=240|l>>18,f[c++]=128|l>>12&63,f[c++]=128|l>>6&63,f[c++]=128|63&l);t=f}t.length>128&&(t=new h(s,!0).update(t).array());var y=[],p=[];for(u=0;u<128;++u){var d=t[u]||0;y[u]=92^d,p[u]=54^d}h.call(this,s,e),this.update(p),this.oKeyPad=y,this.inner=!0,this.sharedMemory=e}var i="input is invalid type",s="object"==typeof window,e=s?window:{};e.JS_SHA512_NO_WINDOW&&(s=!1);var r=!s&&"object"==typeof self;!e.JS_SHA512_NO_NODE_JS&&"object"==typeof process&&process.versions&&process.versions.node?e=global:r&&(e=self);var n=!e.JS_SHA512_NO_COMMON_JS&&"object"==typeof module&&module.exports,o="function"==typeof define&&define.amd,a=!e.JS_SHA512_NO_ARRAY_BUFFER&&"undefined"!=typeof ArrayBuffer,l="0123456789abcdef".split(""),f=[-2147483648,8388608,32768,128],c=[24,16,8,0],u=[1116352408,3609767458,1899447441,602891725,3049323471,3964484399,3921009573,2173295548,961987163,4081628472,1508970993,3053834265,2453635748,2937671579,2870763221,3664609560,3624381080,2734883394,310598401,1164996542,607225278,1323610764,1426881987,3590304994,1925078388,4068182383,2162078206,991336113,2614888103,633803317,3248222580,3479774868,3835390401,2666613458,4022224774,944711139,264347078,2341262773,604807628,2007800933,770255983,1495990901,1249150122,1856431235,1555081692,3175218132,1996064986,2198950837,2554220882,3999719339,2821834349,766784016,2952996808,2566594879,3210313671,3203337956,3336571891,1034457026,3584528711,2466948901,113926993,3758326383,338241895,168717936,666307205,1188179964,773529912,1546045734,1294757372,1522805485,1396182291,2643833823,1695183700,2343527390,1986661051,1014477480,2177026350,1206759142,2456956037,344077627,2730485921,1290863460,2820302411,3158454273,3259730800,3505952657,3345764771,106217008,3516065817,3606008344,3600352804,1432725776,4094571909,1467031594,275423344,851169720,430227734,3100823752,506948616,1363258195,659060556,3750685593,883997877,3785050280,958139571,3318307427,1322822218,3812723403,1537002063,2003034995,1747873779,3602036899,1955562222,1575990012,2024104815,1125592928,2227730452,2716904306,2361852424,442776044,2428436474,593698344,2756734187,3733110249,3204031479,2999351573,3329325298,3815920427,3391569614,3928383900,3515267271,566280711,3940187606,3454069534,4118630271,4000239992,116418474,1914138554,174292421,2731055270,289380356,3203993006,460393269,320620315,685471733,587496836,852142971,1086792851,1017036298,365543100,1126000580,2618297676,1288033470,3409855158,1501505948,4234509866,1607167915,987167468,1816402316,1246189591],y=["hex","array","digest","arrayBuffer"],p=[];!e.JS_SHA512_NO_NODE_JS&&Array.isArray||(Array.isArray=function(h){return"[object Array]"===Object.prototype.toString.call(h)}),!a||!e.JS_SHA512_NO_ARRAY_BUFFER_IS_VIEW&&ArrayBuffer.isView||(ArrayBuffer.isView=function(h){return"object"==typeof h&&h.buffer&&h.buffer.constructor===ArrayBuffer});var d=function(t,i){return function(s){return new h(i,!0).update(s)[t]()}},b=function(t){var i=d("hex",t);i.create=function(){return new h(t)},i.update=function(h){return i.create().update(h)};for(var s=0;s<y.length;++s){var e=y[s];i[e]=d(e,t)}return i},w=function(h,i){return function(s,e){return new t(s,i,!0).update(e)[h]()}},A=function(h){var i=w("hex",h);i.create=function(i){return new t(i,h)},i.update=function(h,t){return i.create(h).update(t)};for(var s=0;s<y.length;++s){var e=y[s];i[e]=w(e,h)}return i};h.prototype.update=function(h){if(this.finalized)throw new Error("finalize already called");var t,s=typeof h;if("string"!==s){if("object"!==s)throw new Error(i);if(null===h)throw new Error(i);if(a&&h.constructor===ArrayBuffer)h=new Uint8Array(h);else if(!(Array.isArray(h)||a&&ArrayBuffer.isView(h)))throw new Error(i);t=!0}for(var e,r,n=0,o=h.length,l=this.blocks;n<o;){if(this.hashed&&(this.hashed=!1,l[0]=this.block,l[1]=l[2]=l[3]=l[4]=l[5]=l[6]=l[7]=l[8]=l[9]=l[10]=l[11]=l[12]=l[13]=l[14]=l[15]=l[16]=l[17]=l[18]=l[19]=l[20]=l[21]=l[22]=l[23]=l[24]=l[25]=l[26]=l[27]=l[28]=l[29]=l[30]=l[31]=l[32]=0),t)for(r=this.start;n<o&&r<128;++n)l[r>>2]|=h[n]<<c[3&r++];else for(r=this.start;n<o&&r<128;++n)(e=h.charCodeAt(n))<128?l[r>>2]|=e<<c[3&r++]:e<2048?(l[r>>2]|=(192|e>>6)<<c[3&r++],l[r>>2]|=(128|63&e)<<c[3&r++]):e<55296||e>=57344?(l[r>>2]|=(224|e>>12)<<c[3&r++],l[r>>2]|=(128|e>>6&63)<<c[3&r++],l[r>>2]|=(128|63&e)<<c[3&r++]):(e=65536+((1023&e)<<10|1023&h.charCodeAt(++n)),l[r>>2]|=(240|e>>18)<<c[3&r++],l[r>>2]|=(128|e>>12&63)<<c[3&r++],l[r>>2]|=(128|e>>6&63)<<c[3&r++],l[r>>2]|=(128|63&e)<<c[3&r++]);this.lastByteIndex=r,this.bytes+=r-this.start,r>=128?(this.block=l[32],this.start=r-128,this.hash(),this.hashed=!0):this.start=r}return this.bytes>4294967295&&(this.hBytes+=this.bytes/4294967296<<0,this.bytes=this.bytes%4294967296),this},h.prototype.finalize=function(){if(!this.finalized){this.finalized=!0;var h=this.blocks,t=this.lastByteIndex;h[32]=this.block,h[t>>2]|=f[3&t],this.block=h[32],t>=112&&(this.hashed||this.hash(),h[0]=this.block,h[1]=h[2]=h[3]=h[4]=h[5]=h[6]=h[7]=h[8]=h[9]=h[10]=h[11]=h[12]=h[13]=h[14]=h[15]=h[16]=h[17]=h[18]=h[19]=h[20]=h[21]=h[22]=h[23]=h[24]=h[25]=h[26]=h[27]=h[28]=h[29]=h[30]=h[31]=h[32]=0),h[30]=this.hBytes<<3|this.bytes>>>29,h[31]=this.bytes<<3,this.hash()}},h.prototype.hash=function(){var h,t,i,s,e,r,n,o,a,l,f,c,y,p,d,b,w,A,_,v,B,U,S,g,k,z=this.h0h,E=this.h0l,O=this.h1h,m=this.h1l,x=this.h2h,N=this.h2l,j=this.h3h,J=this.h3l,H=this.h4h,I=this.h4l,R=this.h5h,V=this.h5l,C=this.h6h,K=this.h6l,P=this.h7h,D=this.h7l,F=this.blocks;for(h=32;h<160;h+=2)t=((v=F[h-30])>>>1|(B=F[h-29])<<31)^(v>>>8|B<<24)^v>>>7,i=(B>>>1|v<<31)^(B>>>8|v<<24)^(B>>>7|v<<25),s=((v=F[h-4])>>>19|(B=F[h-3])<<13)^(B>>>29|v<<3)^v>>>6,e=(B>>>19|v<<13)^(v>>>29|B<<3)^(B>>>6|v<<26),v=F[h-32],B=F[h-31],a=((U=F[h-14])>>>16)+(v>>>16)+(t>>>16)+(s>>>16)+((o=(65535&U)+(65535&v)+(65535&t)+(65535&s)+((n=((S=F[h-13])>>>16)+(B>>>16)+(i>>>16)+(e>>>16)+((r=(65535&S)+(65535&B)+(65535&i)+(65535&e))>>>16))>>>16))>>>16),F[h]=a<<16|65535&o,F[h+1]=n<<16|65535&r;var M=z,T=E,W=O,Y=m,q=x,G=N,L=j,Q=J,X=H,Z=I,$=R,hh=V,th=C,ih=K,sh=P,eh=D;for(b=W&q,w=Y&G,h=0;h<160;h+=8)t=(M>>>28|T<<4)^(T>>>2|M<<30)^(T>>>7|M<<25),i=(T>>>28|M<<4)^(M>>>2|T<<30)^(M>>>7|T<<25),s=(X>>>14|Z<<18)^(X>>>18|Z<<14)^(Z>>>9|X<<23),e=(Z>>>14|X<<18)^(Z>>>18|X<<14)^(X>>>9|Z<<23),A=(l=M&W)^M&q^b,_=(f=T&Y)^T&G^w,g=X&$^~X&th,k=Z&hh^~Z&ih,v=F[h],B=F[h+1],v=(a=((U=u[h])>>>16)+(v>>>16)+(g>>>16)+(s>>>16)+(sh>>>16)+((o=(65535&U)+(65535&v)+(65535&g)+(65535&s)+(65535&sh)+((n=((S=u[h+1])>>>16)+(B>>>16)+(k>>>16)+(e>>>16)+(eh>>>16)+((r=(65535&S)+(65535&B)+(65535&k)+(65535&e)+(65535&eh))>>>16))>>>16))>>>16))<<16|65535&o,B=n<<16|65535&r,U=(a=(A>>>16)+(t>>>16)+((o=(65535&A)+(65535&t)+((n=(_>>>16)+(i>>>16)+((r=(65535&_)+(65535&i))>>>16))>>>16))>>>16))<<16|65535&o,S=n<<16|65535&r,sh=(a=(L>>>16)+(v>>>16)+((o=(65535&L)+(65535&v)+((n=(Q>>>16)+(B>>>16)+((r=(65535&Q)+(65535&B))>>>16))>>>16))>>>16))<<16|65535&o,eh=n<<16|65535&r,t=((L=(a=(U>>>16)+(v>>>16)+((o=(65535&U)+(65535&v)+((n=(S>>>16)+(B>>>16)+((r=(65535&S)+(65535&B))>>>16))>>>16))>>>16))<<16|65535&o)>>>28|(Q=n<<16|65535&r)<<4)^(Q>>>2|L<<30)^(Q>>>7|L<<25),i=(Q>>>28|L<<4)^(L>>>2|Q<<30)^(L>>>7|Q<<25),s=(sh>>>14|eh<<18)^(sh>>>18|eh<<14)^(eh>>>9|sh<<23),e=(eh>>>14|sh<<18)^(eh>>>18|sh<<14)^(sh>>>9|eh<<23),A=(c=L&M)^L&W^l,_=(y=Q&T)^Q&Y^f,g=sh&X^~sh&$,k=eh&Z^~eh&hh,v=F[h+2],B=F[h+3],v=(a=((U=u[h+2])>>>16)+(v>>>16)+(g>>>16)+(s>>>16)+(th>>>16)+((o=(65535&U)+(65535&v)+(65535&g)+(65535&s)+(65535&th)+((n=((S=u[h+3])>>>16)+(B>>>16)+(k>>>16)+(e>>>16)+(ih>>>16)+((r=(65535&S)+(65535&B)+(65535&k)+(65535&e)+(65535&ih))>>>16))>>>16))>>>16))<<16|65535&o,B=n<<16|65535&r,U=(a=(A>>>16)+(t>>>16)+((o=(65535&A)+(65535&t)+((n=(_>>>16)+(i>>>16)+((r=(65535&_)+(65535&i))>>>16))>>>16))>>>16))<<16|65535&o,S=n<<16|65535&r,th=(a=(q>>>16)+(v>>>16)+((o=(65535&q)+(65535&v)+((n=(G>>>16)+(B>>>16)+((r=(65535&G)+(65535&B))>>>16))>>>16))>>>16))<<16|65535&o,ih=n<<16|65535&r,t=((q=(a=(U>>>16)+(v>>>16)+((o=(65535&U)+(65535&v)+((n=(S>>>16)+(B>>>16)+((r=(65535&S)+(65535&B))>>>16))>>>16))>>>16))<<16|65535&o)>>>28|(G=n<<16|65535&r)<<4)^(G>>>2|q<<30)^(G>>>7|q<<25),i=(G>>>28|q<<4)^(q>>>2|G<<30)^(q>>>7|G<<25),s=(th>>>14|ih<<18)^(th>>>18|ih<<14)^(ih>>>9|th<<23),e=(ih>>>14|th<<18)^(ih>>>18|th<<14)^(th>>>9|ih<<23),A=(p=q&L)^q&M^c,_=(d=G&Q)^G&T^y,g=th&sh^~th&X,k=ih&eh^~ih&Z,v=F[h+4],B=F[h+5],v=(a=((U=u[h+4])>>>16)+(v>>>16)+(g>>>16)+(s>>>16)+($>>>16)+((o=(65535&U)+(65535&v)+(65535&g)+(65535&s)+(65535&$)+((n=((S=u[h+5])>>>16)+(B>>>16)+(k>>>16)+(e>>>16)+(hh>>>16)+((r=(65535&S)+(65535&B)+(65535&k)+(65535&e)+(65535&hh))>>>16))>>>16))>>>16))<<16|65535&o,B=n<<16|65535&r,U=(a=(A>>>16)+(t>>>16)+((o=(65535&A)+(65535&t)+((n=(_>>>16)+(i>>>16)+((r=(65535&_)+(65535&i))>>>16))>>>16))>>>16))<<16|65535&o,S=n<<16|65535&r,$=(a=(W>>>16)+(v>>>16)+((o=(65535&W)+(65535&v)+((n=(Y>>>16)+(B>>>16)+((r=(65535&Y)+(65535&B))>>>16))>>>16))>>>16))<<16|65535&o,hh=n<<16|65535&r,t=((W=(a=(U>>>16)+(v>>>16)+((o=(65535&U)+(65535&v)+((n=(S>>>16)+(B>>>16)+((r=(65535&S)+(65535&B))>>>16))>>>16))>>>16))<<16|65535&o)>>>28|(Y=n<<16|65535&r)<<4)^(Y>>>2|W<<30)^(Y>>>7|W<<25),i=(Y>>>28|W<<4)^(W>>>2|Y<<30)^(W>>>7|Y<<25),s=($>>>14|hh<<18)^($>>>18|hh<<14)^(hh>>>9|$<<23),e=(hh>>>14|$<<18)^(hh>>>18|$<<14)^($>>>9|hh<<23),A=(b=W&q)^W&L^p,_=(w=Y&G)^Y&Q^d,g=$&th^~$&sh,k=hh&ih^~hh&eh,v=F[h+6],B=F[h+7],v=(a=((U=u[h+6])>>>16)+(v>>>16)+(g>>>16)+(s>>>16)+(X>>>16)+((o=(65535&U)+(65535&v)+(65535&g)+(65535&s)+(65535&X)+((n=((S=u[h+7])>>>16)+(B>>>16)+(k>>>16)+(e>>>16)+(Z>>>16)+((r=(65535&S)+(65535&B)+(65535&k)+(65535&e)+(65535&Z))>>>16))>>>16))>>>16))<<16|65535&o,B=n<<16|65535&r,U=(a=(A>>>16)+(t>>>16)+((o=(65535&A)+(65535&t)+((n=(_>>>16)+(i>>>16)+((r=(65535&_)+(65535&i))>>>16))>>>16))>>>16))<<16|65535&o,S=n<<16|65535&r,X=(a=(M>>>16)+(v>>>16)+((o=(65535&M)+(65535&v)+((n=(T>>>16)+(B>>>16)+((r=(65535&T)+(65535&B))>>>16))>>>16))>>>16))<<16|65535&o,Z=n<<16|65535&r,M=(a=(U>>>16)+(v>>>16)+((o=(65535&U)+(65535&v)+((n=(S>>>16)+(B>>>16)+((r=(65535&S)+(65535&B))>>>16))>>>16))>>>16))<<16|65535&o,T=n<<16|65535&r;a=(z>>>16)+(M>>>16)+((o=(65535&z)+(65535&M)+((n=(E>>>16)+(T>>>16)+((r=(65535&E)+(65535&T))>>>16))>>>16))>>>16),this.h0h=a<<16|65535&o,this.h0l=n<<16|65535&r,a=(O>>>16)+(W>>>16)+((o=(65535&O)+(65535&W)+((n=(m>>>16)+(Y>>>16)+((r=(65535&m)+(65535&Y))>>>16))>>>16))>>>16),this.h1h=a<<16|65535&o,this.h1l=n<<16|65535&r,a=(x>>>16)+(q>>>16)+((o=(65535&x)+(65535&q)+((n=(N>>>16)+(G>>>16)+((r=(65535&N)+(65535&G))>>>16))>>>16))>>>16),this.h2h=a<<16|65535&o,this.h2l=n<<16|65535&r,a=(j>>>16)+(L>>>16)+((o=(65535&j)+(65535&L)+((n=(J>>>16)+(Q>>>16)+((r=(65535&J)+(65535&Q))>>>16))>>>16))>>>16),this.h3h=a<<16|65535&o,this.h3l=n<<16|65535&r,a=(H>>>16)+(X>>>16)+((o=(65535&H)+(65535&X)+((n=(I>>>16)+(Z>>>16)+((r=(65535&I)+(65535&Z))>>>16))>>>16))>>>16),this.h4h=a<<16|65535&o,this.h4l=n<<16|65535&r,a=(R>>>16)+($>>>16)+((o=(65535&R)+(65535&$)+((n=(V>>>16)+(hh>>>16)+((r=(65535&V)+(65535&hh))>>>16))>>>16))>>>16),this.h5h=a<<16|65535&o,this.h5l=n<<16|65535&r,a=(C>>>16)+(th>>>16)+((o=(65535&C)+(65535&th)+((n=(K>>>16)+(ih>>>16)+((r=(65535&K)+(65535&ih))>>>16))>>>16))>>>16),this.h6h=a<<16|65535&o,this.h6l=n<<16|65535&r,a=(P>>>16)+(sh>>>16)+((o=(65535&P)+(65535&sh)+((n=(D>>>16)+(eh>>>16)+((r=(65535&D)+(65535&eh))>>>16))>>>16))>>>16),this.h7h=a<<16|65535&o,this.h7l=n<<16|65535&r},h.prototype.hex=function(){this.finalize();var h=this.h0h,t=this.h0l,i=this.h1h,s=this.h1l,e=this.h2h,r=this.h2l,n=this.h3h,o=this.h3l,a=this.h4h,f=this.h4l,c=this.h5h,u=this.h5l,y=this.h6h,p=this.h6l,d=this.h7h,b=this.h7l,w=this.bits,A=l[h>>28&15]+l[h>>24&15]+l[h>>20&15]+l[h>>16&15]+l[h>>12&15]+l[h>>8&15]+l[h>>4&15]+l[15&h]+l[t>>28&15]+l[t>>24&15]+l[t>>20&15]+l[t>>16&15]+l[t>>12&15]+l[t>>8&15]+l[t>>4&15]+l[15&t]+l[i>>28&15]+l[i>>24&15]+l[i>>20&15]+l[i>>16&15]+l[i>>12&15]+l[i>>8&15]+l[i>>4&15]+l[15&i]+l[s>>28&15]+l[s>>24&15]+l[s>>20&15]+l[s>>16&15]+l[s>>12&15]+l[s>>8&15]+l[s>>4&15]+l[15&s]+l[e>>28&15]+l[e>>24&15]+l[e>>20&15]+l[e>>16&15]+l[e>>12&15]+l[e>>8&15]+l[e>>4&15]+l[15&e]+l[r>>28&15]+l[r>>24&15]+l[r>>20&15]+l[r>>16&15]+l[r>>12&15]+l[r>>8&15]+l[r>>4&15]+l[15&r]+l[n>>28&15]+l[n>>24&15]+l[n>>20&15]+l[n>>16&15]+l[n>>12&15]+l[n>>8&15]+l[n>>4&15]+l[15&n];return w>=256&&(A+=l[o>>28&15]+l[o>>24&15]+l[o>>20&15]+l[o>>16&15]+l[o>>12&15]+l[o>>8&15]+l[o>>4&15]+l[15&o]),w>=384&&(A+=l[a>>28&15]+l[a>>24&15]+l[a>>20&15]+l[a>>16&15]+l[a>>12&15]+l[a>>8&15]+l[a>>4&15]+l[15&a]+l[f>>28&15]+l[f>>24&15]+l[f>>20&15]+l[f>>16&15]+l[f>>12&15]+l[f>>8&15]+l[f>>4&15]+l[15&f]+l[c>>28&15]+l[c>>24&15]+l[c>>20&15]+l[c>>16&15]+l[c>>12&15]+l[c>>8&15]+l[c>>4&15]+l[15&c]+l[u>>28&15]+l[u>>24&15]+l[u>>20&15]+l[u>>16&15]+l[u>>12&15]+l[u>>8&15]+l[u>>4&15]+l[15&u]),512==w&&(A+=l[y>>28&15]+l[y>>24&15]+l[y>>20&15]+l[y>>16&15]+l[y>>12&15]+l[y>>8&15]+l[y>>4&15]+l[15&y]+l[p>>28&15]+l[p>>24&15]+l[p>>20&15]+l[p>>16&15]+l[p>>12&15]+l[p>>8&15]+l[p>>4&15]+l[15&p]+l[d>>28&15]+l[d>>24&15]+l[d>>20&15]+l[d>>16&15]+l[d>>12&15]+l[d>>8&15]+l[d>>4&15]+l[15&d]+l[b>>28&15]+l[b>>24&15]+l[b>>20&15]+l[b>>16&15]+l[b>>12&15]+l[b>>8&15]+l[b>>4&15]+l[15&b]),A},h.prototype.toString=h.prototype.hex,h.prototype.digest=function(){this.finalize();var h=this.h0h,t=this.h0l,i=this.h1h,s=this.h1l,e=this.h2h,r=this.h2l,n=this.h3h,o=this.h3l,a=this.h4h,l=this.h4l,f=this.h5h,c=this.h5l,u=this.h6h,y=this.h6l,p=this.h7h,d=this.h7l,b=this.bits,w=[h>>24&255,h>>16&255,h>>8&255,255&h,t>>24&255,t>>16&255,t>>8&255,255&t,i>>24&255,i>>16&255,i>>8&255,255&i,s>>24&255,s>>16&255,s>>8&255,255&s,e>>24&255,e>>16&255,e>>8&255,255&e,r>>24&255,r>>16&255,r>>8&255,255&r,n>>24&255,n>>16&255,n>>8&255,255&n];return b>=256&&w.push(o>>24&255,o>>16&255,o>>8&255,255&o),b>=384&&w.push(a>>24&255,a>>16&255,a>>8&255,255&a,l>>24&255,l>>16&255,l>>8&255,255&l,f>>24&255,f>>16&255,f>>8&255,255&f,c>>24&255,c>>16&255,c>>8&255,255&c),512==b&&w.push(u>>24&255,u>>16&255,u>>8&255,255&u,y>>24&255,y>>16&255,y>>8&255,255&y,p>>24&255,p>>16&255,p>>8&255,255&p,d>>24&255,d>>16&255,d>>8&255,255&d),w},h.prototype.array=h.prototype.digest,h.prototype.arrayBuffer=function(){this.finalize();var h=this.bits,t=new ArrayBuffer(h/8),i=new DataView(t);return i.setUint32(0,this.h0h),i.setUint32(4,this.h0l),i.setUint32(8,this.h1h),i.setUint32(12,this.h1l),i.setUint32(16,this.h2h),i.setUint32(20,this.h2l),i.setUint32(24,this.h3h),h>=256&&i.setUint32(28,this.h3l),h>=384&&(i.setUint32(32,this.h4h),i.setUint32(36,this.h4l),i.setUint32(40,this.h5h),i.setUint32(44,this.h5l)),512==h&&(i.setUint32(48,this.h6h),i.setUint32(52,this.h6l),i.setUint32(56,this.h7h),i.setUint32(60,this.h7l)),t},h.prototype.clone=function(){var t=new h(this.bits,!1);return this.copyTo(t),t},h.prototype.copyTo=function(h){var t=0,i=["h0h","h0l","h1h","h1l","h2h","h2l","h3h","h3l","h4h","h4l","h5h","h5l","h6h","h6l","h7h","h7l","start","bytes","hBytes","finalized","hashed","lastByteIndex"];for(t=0;t<i.length;++t)h[i[t]]=this[i[t]];for(t=0;t<this.blocks.length;++t)h.blocks[t]=this.blocks[t]},(t.prototype=new h).finalize=function(){if(h.prototype.finalize.call(this),this.inner){this.inner=!1;var t=this.array();h.call(this,this.bits,this.sharedMemory),this.update(this.oKeyPad),this.update(t),h.prototype.finalize.call(this)}},t.prototype.clone=function(){var h=new t([],this.bits,!1);this.copyTo(h),h.inner=this.inner;for(var i=0;i<this.oKeyPad.length;++i)h.oKeyPad[i]=this.oKeyPad[i];return h};var _=b(512);_.sha512=_,_.sha384=b(384),_.sha512_256=b(256),_.sha512_224=b(224),_.sha512.hmac=A(512),_.sha384.hmac=A(384),_.sha512_256.hmac=A(256),_.sha512_224.hmac=A(224),n?module.exports=_:(e.sha512=_.sha512,e.sha384=_.sha384,e.sha512_256=_.sha512_256,e.sha512_224=_.sha512_224,o&&define(function(){return _}))}();
(function() {
    'use strict';

    angular
        .module('UNIFYPortal')
        .directive('tabMenu', tabMenu);

    function tabMenu () {
        var directive = {
            restrict: 'EA',
            templateUrl:'app/directives/tabMenu/tabMenu.html',
            scope: {
                navs:'=',
                tabindex:'@'
            },
            controller: ['$state','$scope','$rootScope',tabMenuController],
            controllerAs:'vm'
        };

        return directive;

        function tabMenuController($state,$scope,$rootScope) {
            
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .filter('cut', function () {
           return function (value,wordwise,max,tail) {
               if (!value) return '';
               max = parseInt(max, 10);
               if (!max) return value;
               if (value.length <= max) return value;
               value = value.substr(0, max);
               if (wordwise) {
                   var lastspace = value.lastIndexOf(' ');
                   if (lastspace != -1) {
                       value = value.substr(0, lastspace);
                   }
               }
               return value + (tail || ' …');

           }


        })

})();

(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .directive('rightClick', rightClick);
    rightClick.$inject = ['$parse'];

    function rightClick($parse) {
        var directive = {
            restrict: "A",
            link: linkFunc
        };
        return directive;

        function linkFunc(scope, element, attrs) {
            var fn = $parse(attrs.rightClick);
            element.bind('contextmenu', function (event) {
                event.preventDefault();
                scope.$apply(function () {
                    fn(scope, {
                        $event: event
                    });
                });
            });
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .directive('passwordStr', passwordStr);

    function passwordStr() {
        return {
            restrict: "EA",
            replace: true,
            templateUrl: "app/directives/passwordStrength/passwordStrength.html",
            scope: {
                pwd: '=' //密码
            },
			link:function(scope,element,attrs){
                //验证的规则
                var patternArray = [
                    //if length is 8 characters or more, increase strength value
                    /([a-zA-Z0-9!,%,&,@,#,$,^,*,?,_,~]){8,}/,
                    //if password contains both lower and uppercase characters, increase strength value
                    /([a-z].*[A-Z])|([A-Z].*[a-z])/,
                    //if it has numbers and characters, increase strength value
                    /([a-zA-Z])/,
                    //if it has one special character, increase strength value
                    /([!,%,&,@,#,$,^,*,?,_,~])/
                ];
                //验证密码的强度,并返回强度的值
                var checkPwdStrength = function(password) {
                    var strength = 0; //密码强度

                    if (password !== undefined) {
                        //根据正则表达式数组进行判断，满足正则表达式则增加强度
                        for (var i = 0; i < patternArray.length; i++) {
                            //满足要求
                            if (password.match(patternArray[i])) {
                                //强度增加
                                strength += 1;
                            }
                        }
                    }
                    //返回强度
                    return strength;
                };
                //监控输入的密码，如有变化调用验证密码强度的指令
                scope.$watch('pwd', function() {
                    scope.strength = checkPwdStrength(scope.pwd);
                    scope.strengthStr = '';
                    switch (scope.strength) {
                        case 0:
                            scope.weakClass = '';
                            scope.mediumClass = '';
                            scope.strongClass = '';
                            break;
                        case 1:
                            scope.weakClass = 'strength';
                            scope.mediumClass = '';
                            scope.strongClass = '';
                            break;
                        case 2:
                            scope.weakClass = 'strength';
                            scope.mediumClass = 'strength';
                            scope.strongClass = '';
                            break;
                        case 3:
                        case 4:
                            scope.weakClass = 'strength';
                            scope.mediumClass = 'strength';
                            scope.strongClass = 'strength';
                            break;

                    }
                });
			}
        };
    }

})();

/* globals $ */
(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .directive('passwordShow', passwordShow);

    function passwordShow() {
        var directive = {
            restrict: "AE",
            templateUrl: "app/directives/passwordShow/passwordShow.html",
            // scope: {
            //     passwordType: '='
            // },
            link: linkFunc
        };
        return directive;

        function linkFunc(scope, el, attr) {
            // var vm = this;
            scope.passwordType = 'password';

            scope.passwordshow = function () {
                scope.passwordType === 'text' ? scope.passwordType = 'password' : scope.passwordType = 'text';
                // scope.passwordType = 'text';
            };

            // scope.passwordhide = function () {
            //     scope.passwordType = 'password';
            // };
        }

    }

})();

(function() {
    'use strict';

    angular
        .module('UNIFYPortal')
        .directive('ngFocus', function () {
            var FOCUS_CLASS = "ng-focused";
            return{
                restrict:'A',
                require:'ngModel',
                link: function (scope, element, attrs,ctrl) {
                    ctrl.$focused = false;
                    element.bind('focus', function (evt) {
                        element.addClass(FOCUS_CLASS);
                        scope.$apply(function () {
                            ctrl.$focused = true;
                        });
                    }).bind('blur', function () {
                        element.removeClass(FOCUS_CLASS);
                        scope.$apply(function(){
                            ctrl.$focused = false;
                        })
                    })
                }
            }
        })


})();

(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .directive('ngEnter', ngEnter);

    function ngEnter() {
        var directive = {
            restrict: "A",
            link: linkFunc
        };
        return directive;

        function linkFunc(scope, element, attr) {
            element.bind("keydown keypress", function (event) {
                if (event.which === 13) {
                    scope.$apply(function () {
                        scope.$eval(attr.ngEnter);
                    });
                    event.preventDefault();
                }
            });
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .directive('telFormat', telFormat);

    telFormat.$inject = ['$parse'];
    function telFormat($parse) {
        var directive = {
            require: 'ngModel',
            restrict: 'A',
            link: linkFunc
        };
        return directive;

        function linkFunc(scope, element, attrs, ctrl) {
            function limit() {

                var limitV = element[0].value;
                limitV = limitV.replace(/[^0-9-+]/g, "");
                //console.log(limitV);
                element[0].value = limitV;
                $parse(attrs['ngModel']).assign(scope, limitV);
                // format();
                // alert(limitV);

            }
            scope.$watch(attrs.ngModel, function () {
                limit();
            })
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .directive('mailFormat', mailFormat);

    mailFormat.$inject = ['$parse'];
    function mailFormat($parse) {
        var directive = {
            require: 'ngModel',
            restrict: 'A',
            link: linkFunc
        };
        return directive;

        function linkFunc(scope, element, attrs, ctrl) {
            function limit() {

                var limitV = element[0].value;
                limitV = limitV.replace(/[^0-9a-zA-Z.@_-]/g, "");
                //console.log(limitV);
                element[0].value = limitV;
                $parse(attrs['ngModel']).assign(scope, limitV);
                // format();
                // alert(limitV);

            }
            scope.$watch(attrs.ngModel, function () {
                limit();
            })
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .directive('intFormat', intFormat);

    intFormat.$inject = ['$parse'];
    function intFormat($parse) {
        var directive = {
            require: 'ngModel',
            restrict: 'A',
            link: linkFunc
        };
        return directive;

        function linkFunc(scope, element, attrs, ctrl) {
            function limit() {
                // console.log(attrs.intLetter);
                var limitV = element[0].value;
                if(attrs.intLetter){
                    limitV = limitV.replace(/[^0-9;]/g, "");
                }else{
                    limitV = limitV.replace(/[^0-9]/g, "");
                } 
                //console.log(limitV);
                element[0].value = limitV;
                $parse(attrs['ngModel']).assign(scope, limitV);
                // format();
                // alert(limitV);

            }
            scope.$watch(attrs.ngModel, function () {
                limit();
            })
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .directive('idFormat', idFormat);

    idFormat.$inject = ['$parse'];
    function idFormat($parse) {
        var directive = {
            require: 'ngModel',
            restrict: 'A',
            link: linkFunc
        };
        return directive;

        function linkFunc(scope, element, attrs, ctrl) {
            function limit() {

                var limitV = element[0].value;
                limitV = limitV.replace(/[\W]/g, "");
                //console.log(limitV);
                element[0].value = limitV;
                $parse(attrs['ngModel']).assign(scope, limitV);
                // format();
                // alert(limitV);

            }
            scope.$watch(attrs.ngModel, function () {
                limit();
            })
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .directive('doubleFormat', doubleFormat);

    doubleFormat.$inject = ['$parse'];
    function doubleFormat($parse) {
        var directive = {
            require: 'ngModel',
            restrict: 'A',
            link: linkFunc
        };
        return directive;

        function linkFunc(scope, element, attrs, ctrl) {
            $(element).on("keyup",function () {
                limit();
            });
            function limit() {
                var limitV = element[0].value;
                if(attrs.doubleLetter){
                    limitV = limitV.replace(/[^0-9.;]/g, "");
                }else{
                    limitV = limitV.replace(/[^0-9.]/g, "");
                }
                if(attrs.fixed){
                    var reg = new RegExp("^\\d+(?:\.\\d{0,"+ attrs.fixed + "})?")
                    limitV = limitV.match(reg) && limitV.match(reg)[0];
                }
                if(attrs.doubleMax){
                    limitV=limitV*1>attrs.doubleMax?attrs.doubleMax*1:limitV
                }
                if(attrs.evenMax){
                    limitV=limitV*1>attrs.evenMax?attrs.evenMax*1:limitV
                }
                
                //console.log(limitV);
                element[0].value = limitV;
                $parse(attrs['ngModel']).assign(scope, limitV);
                // format();
                // alert(limitV);

            }
            // scope.$watch(attrs.ngModel, function () {
            //     limit();
            // })
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .directive('onReadFile', onReadFile);

    onReadFile.$inject = ['$parse', '$translate', 'toastr'];

    /**
     * onReadFile
     * @memberof UNIFYPortal
     * @function onReadFile
     */
    function onReadFile($parse, $translate, toastr) {
        return {
            restrict: 'A',
            scope: false,
            link: function (scope, element, attrs) {
                var fn = $parse(attrs.onReadFile);
                var limitFileType = attrs.accept;

                element.on('change', function (onChangeEvent) {
                    // console.log(limitFileType);
                    var reader = new FileReader();
                    var file = (onChangeEvent.srcElement || onChangeEvent.target).files[0];

                    var fileType = file.name.substring(file.name.lastIndexOf('.') + 1, file.name.length); //类型
                    if (limitFileType && limitFileType.length !== 0 && limitFileType.indexOf(fileType.toLowerCase()) === -1) {
                        // console.log('文件类型不符合');
                        toastr.warning($translate.instant('toastr.upload.correctCertType'));
                        onChangeEvent.target.value = '';
                        sessionStorage.removeItem('wallet');
                        return;
                    }

                    reader.readAsText(file);
                    reader.onload = function (onLoadEvent) {
                        scope.$apply(function () {
                            fn(scope, {
                                $fileContent: onLoadEvent.target.result
                            });
                        });
                    };
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .directive('fetchLoop', fetchLoop);

    function fetchLoop() {
        var directive = {
            restrict: "E",
            transclude: true,
            replace: true,
            template: "<div ng-transclude></div>",
            scope: {
                params: '=',
                src: '@', //请求地址
                method: '@', //请求方式
                callback: '&' //回调噢
            },
            controller: ['$scope', 'RESTHOST', 'RESTURIS', '$http', 'HttpService', '$interval', controllerFunc]
        };
        return directive;

        function controllerFunc($scope, RESTHOST, RESTURIS, $http, HttpService, $interval) {
            var method = $scope.method || 'GET';
            var flag = true;
            var lastTime = Date.now();
            var currentTime = Date.now();
            var timeOut = 10000;
            var interval = 10000;
            var url;
            if (/RESTURIS/.test($scope.src)) {
                var temp = $scope.src.replace(/RESTURIS\./, '');
                var tempArr = temp.split('.');
                url = tempArr.reduce(function (total, item) {
                    return total[item];
                }, RESTURIS);
            } else {
                url = $scope.src;
            }

            function fetch() {
                flag = false;
                HttpService.request(RESTHOST.ZONE_DATA_HOST, url, $scope.params, method, false).then(function (data) {
                    flag = true;
                    $scope.callback({
                        data: data
                    });
                });
            }
            angular.element('body').on('mousemove', function (e, b) {
                lastTime = Date.now();
            });
            $scope.$watch('params', function (zone) {
                fetch();
            }, true);
            var timer = $interval(function name(params) {
                currentTime = Date.now();
                if (flag && currentTime - lastTime > timeOut) {
                    fetch();
                }
            }, interval);
            $scope.$on('$destroy', function () {
                $interval.cancel(timer);
            });
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .directive('fetchDir', fetchDir);

    function fetchDir() {
        var directive = {
            restrict: "E",
            transclude: true,
            replace: true,
            template: "<div ng-transclude></div>",
            scope: {
                params: '=',
                src: '@', //请求地址
                socket: '@', //socket地址
                method: '@', //请求方式
                callback: '&', //回调噢
                wscallback: '&' //socket回调
            },
            controller: ['$scope', '$rootScope', 'RESTHOST', 'RESTURIS', '$http', 'HttpService', '$interval', controllerFunc]
        };
        return directive;

        function controllerFunc($scope, $rootScope, RESTHOST, RESTURIS, $http, HttpService, $interval) {
            var method = $scope.method || 'GET';
            var flag = true;
            var orgId = sessionStorage.getItem('orgId');
            var url, socket, subscription, sockjs;
            //解析字符串 到对象
            function compilerStr(src) {
                if (/\w+\.\w+/.test(src)) {
                    var api;
                    var temp = src.replace(/RESTURIS\./, '');
                    var tempArr = temp.split('.');
                    api = tempArr.reduce(function (total, item) {
                        return total[item];
                    }, RESTURIS);
                } else {
                    api = src;
                }
                return api;
            }

            url = compilerStr($scope.src);
            socket = compilerStr($scope.socket);

            function fetch() {
                if (flag && url) {
                    flag = false;
                    HttpService.request(RESTHOST.ZONE_DATA_HOST, url, $scope.params, method, false).then(function (data) {
                        flag = true;
                        $scope.callback({
                            data: data
                        });
                    }).catch(function () {
                        flag = true;
                    });
                }
            }
            $scope.$watch('params', function (zone) {
                fetch();
            }, true);
            //socket连接全局保存，不断开。

            sockjs = new SockJS(RESTHOST.ZONE_DATA_HOST + RESTURIS.WEBSOCKET);
            var client = Stomp.over(sockjs);
            client.debug = null;
            client.connect({}, function (frame) {
                addSubscribe();
            });

            //增加socket的订阅
            function addSubscribe() {
                subscription = client.subscribe(socket, function (res) {
                    var flag = $scope.wscallback({
                        data: res
                    });
                    if (angular.isUndefined(flag)) {
                        isRefresh(res) && fetch();
                    } else {
                        flag && fetch();
                    }
                });
            }

            function isRefresh(res) {
                try {
                    var body = angular.fromJson(res.body);
                    var flag = body.some(function (i) {
                        return i.receivers.some(function (j) {
                            return j === orgId;
                        });
                    });
                    return flag;
                } catch (e) {
                    return false;
                }

            }
            //组件摧毁时断开订阅，不断开ws
            $scope.$on('$destroy', function () {
                client && client.disconnect(function () {
                    console.log('断开ws');
                });
                // subscription && subscription.unsubscribe();
            });
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .factory('directivesService', directivesService);

    directivesService.$inject = ['httpService', 'SCFSURLCONFIG'];

    //directives界面service
    function directivesService(http, SCFSURLCONFIG) {

        var service = {
            sendPhoneCodeService: sendPhoneCodeService // 发送短信验证码

        };
        return service;

        function sendPhoneCodeService(txtUrl, params) {
            return http.request(SCFSURLCONFIG.CLOAN, txtUrl, params, 'GET');
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .constant('DIRECTIVESCONFIG', {
            URL: {
                SENDPHONECODESERVICE: 'platform/verification/' //发送短信验证码
            }
        });
})();
(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .directive('dateDir', dateDir);

    function dateDir() {
        var directive = {
            restrict: "AE",
            templateUrl: "app/directives/date/date.html",
            scope: {
                time: '=', //日期
                readonly: '=', //是否只读
                maxTime: '=',
                minTime: '='
            },
            link: linkFunc
        };
        return directive;

        function linkFunc(scope, el, attr) {
            scope.$watch('time', function (time) {
                if (time && isNaN(time)) {
                    var a = time.split(/[^0-9]/);
                    var d = new Date(a[0], a[1] - 1, a[2], a[3], a[4], a[5]);

                    scope.time = d.getTime();
                }
            });
            scope.$watch('maxTime', function (time) {

                scope.datePickerOptions.maxDate = time;

            });
            scope.$watch('minTime', function (time) {

                scope.datePickerOptions.minDate = time;

            });

            /*日期框控制*/
            scope.datePickerOptions = {
                loanStartMinOpened: false,
                loanStartMaxOpened: false,
                showWeeks: false,
                maxDate: scope.maxTime,
                minDate: scope.minTime
            };
            scope.openCalendar = function (id) {
                if (1 === id) {
                    scope.datePickerOptions.startMinOpened = true;
                } else {
                    scope.datePickerOptions.startMaxOpened = true;
                }
            };
        }
    }

})();
'use strict';
angular.module("ngLocale", [], ["$provide", function($provide) {
var PLURAL_CATEGORY = {ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other"};
$provide.value("$locale", {
  "DATETIME_FORMATS": {
    "AMPMS": [
      "\u4e0a\u5348",
      "\u4e0b\u5348"
    ],
    "DAY": [
      "\u661f\u671f\u65e5",
      "\u661f\u671f\u4e00",
      "\u661f\u671f\u4e8c",
      "\u661f\u671f\u4e09",
      "\u661f\u671f\u56db",
      "\u661f\u671f\u4e94",
      "\u661f\u671f\u516d"
    ],
    "ERANAMES": [
      "\u516c\u5143\u524d",
      "\u516c\u5143"
    ],
    "ERAS": [
      "\u516c\u5143\u524d",
      "\u516c\u5143"
    ],
    "FIRSTDAYOFWEEK": 6,
    "MONTH": [
      "\u4e00\u6708",
      "\u4e8c\u6708",
      "\u4e09\u6708",
      "\u56db\u6708",
      "\u4e94\u6708",
      "\u516d\u6708",
      "\u4e03\u6708",
      "\u516b\u6708",
      "\u4e5d\u6708",
      "\u5341\u6708",
      "\u5341\u4e00\u6708",
      "\u5341\u4e8c\u6708"
    ],
    "SHORTDAY": [
      "\u5468\u65e5",
      "\u5468\u4e00",
      "\u5468\u4e8c",
      "\u5468\u4e09",
      "\u5468\u56db",
      "\u5468\u4e94",
      "\u5468\u516d"
    ],
    "SHORTMONTH": [
      "1\u6708",
      "2\u6708",
      "3\u6708",
      "4\u6708",
      "5\u6708",
      "6\u6708",
      "7\u6708",
      "8\u6708",
      "9\u6708",
      "10\u6708",
      "11\u6708",
      "12\u6708"
    ],
    "STANDALONEMONTH": [
      "\u4e00\u6708",
      "\u4e8c\u6708",
      "\u4e09\u6708",
      "\u56db\u6708",
      "\u4e94\u6708",
      "\u516d\u6708",
      "\u4e03\u6708",
      "\u516b\u6708",
      "\u4e5d\u6708",
      "\u5341\u6708",
      "\u5341\u4e00\u6708",
      "\u5341\u4e8c\u6708"
    ],
    "WEEKENDRANGE": [
      5,
      6
    ],
    "fullDate": "y\u5e74M\u6708d\u65e5EEEE",
    "longDate": "y\u5e74M\u6708d\u65e5",
    "medium": "y\u5e74M\u6708d\u65e5 ah:mm:ss",
    "mediumDate": "y\u5e74M\u6708d\u65e5",
    "mediumTime": "ah:mm:ss",
    "short": "y/M/d ah:mm",
    "shortDate": "y/M/d",
    "shortTime": "ah:mm"
  },
  "NUMBER_FORMATS": {
    "CURRENCY_SYM": "\u00a5",
    "DECIMAL_SEP": ".",
    "GROUP_SEP": ",",
    "PATTERNS": [
      {
        "gSize": 3,
        "lgSize": 3,
        "maxFrac": 3,
        "minFrac": 0,
        "minInt": 1,
        "negPre": "-",
        "negSuf": "",
        "posPre": "",
        "posSuf": ""
      },
      {
        "gSize": 3,
        "lgSize": 3,
        "maxFrac": 2,
        "minFrac": 2,
        "minInt": 1,
        "negPre": "-\u00a4",
        "negSuf": "",
        "posPre": "\u00a4",
        "posSuf": ""
      }
    ]
  },
  "id": "zh",
  "localeID": "zh",
  "pluralCat": function(n, opt_precision) {  return PLURAL_CATEGORY.OTHER;}
});
}]);
(function() {
    'use strict';

    angular
        .module('UNIFYPortal')
        .directive('customPattern', customPattern);

    customPattern.$inject = ['ValidationService'];

    /**
     * customPattern指令
     * @memberof UNIFYPortal
     * @function customPattern指令
     */
    function customPattern(ValidationService) {
        var directive = {
            restrict: 'A',
            require: 'ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, el, attr, ctrl) {
            if(!ctrl) return;

            var key;

            attr.$observe('customPattern', function(value) {
                key = value;        // value: identification || phone
                ctrl.$validate();
            });

            ctrl.$validators.customPattern = function(modelValue, viewValue) {
                // Return true/false for valid/invalid
                if(ctrl.$isEmpty(viewValue)) return true;           // 避免与required混淆
                return !ctrl.$isEmpty(viewValue) && ValidationService.validatePattern(key, viewValue);
            };
      }
    }
})();

(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .directive('moneyFormatForSpan', moneyFormat);

    moneyFormat.$inject = ['$filter', '$parse', 'toastr'];

    function moneyFormat($filter, $parse, toastr) {
        var directive = {
            require: 'ngModel',
            restrict: 'A',
            link: linkFunc
        };
        return directive;

        function linkFunc(scope, element, attrs, ctrl) {
            console.log(attrs.ngModel);
            //对输入数字的整数部分插入千位分隔符
            function format() {
                var formatV = element[0].innerText;
                var array = new Array();
                array = formatV.split(".");
                var re = /(-?\d+)(\d{3})/;
                while (re.test(array[0])) {
                    array[0] = array[0].replace(re, "$1,$2")
                }
                var returnV = array[0];
                for (var i = 1; i < array.length; i++) {
                    returnV += "." + array[i];
                }
                element[0].innerText = returnV;
            }

            scope.$watch(attrs.ngModel, function () {
                format();
            });
        }

    }
})();
(function() {
    'use strict';

    angular
        .module('UNIFYPortal')
        .directive('amtInput', amtInput);

    function amtInput() {

        var directive = {
            restrict : 'AE',
            scope: {
                'afield':'='
            },
            templateUrl: 'app/directives/amtInput/amtInput.html',
            controller: AmtInputController,
            controllerAs: 'vm'
        };

        return directive;

        function AmtInputController($scope){
            var vm = this;
            vm.keyUpAmt = keyUpAmt;//按键敲击事件
            vm.blurAmtInput = blurAmtInput;//离开金额域触发事件
            vm.mouseDown = mouseDown;//鼠标进入事件
            var txt = '';
            init();
            function init(){
                $scope.afield="0.00";
            }
            function mouseDown(){
                if ($scope.afield==="0.00") {
                    $scope.afield="";
                }
            }
            function keyUpAmt(){
                //金额去千分符
                var getAmt = ($scope.afield).replace(new RegExp('\,',["g"]),'');
                //校验金额是否合法
                var reg = getAmt.match(/^[0-9]{0,16}\.{0,1}[0-9]{0,2}$/);

                //判断金额是否null
                if (reg !== null) {
                    //判断金额是否大于三位
                    if (reg[0].length > 3){
                        var regN = "";
                        var regX = "";
                        //判断金额里是否有“.”
                        if (reg[0].indexOf(".") >= 0) {
                            regN = reg[0].substr(0, reg[0].indexOf('.'));
                            regX = reg[0].substr(reg[0].indexOf('.'), reg[0].indexOf('.')+2);
                        }else{
                            regN = reg[0];
                        }
                        var mod = regN.length % 3;
                        var output = (mod > 0 ? (regN.substring(0,mod)) : '');
                        for (var i=0 ; i < Math.floor(regN.length / 3); i++) {
                            if ((mod === 0) && (i === 0)){
                                output += regN.substring(mod+ 3 * i, mod + 3 * i + 3);
                            }else{
                                output += ',' + regN.substring(mod + 3 * i, mod + 3 * i + 3);
                            }
                        }
                        txt = output+regX;
                    }else {
                        txt = reg[0];
                    }
                }
                $scope.afield = txt;
            }

            /*
                焦点离开金额域触发事件
             */
            function blurAmtInput(){
                var getAmt = ($scope.afield).replace(new RegExp('\,',["g"]),'');
                if (getAmt === null || getAmt ==='null' || getAmt===''){
                    afield = "0.00";
                }
                var afield = txt;
                if(afield.substring(0, 1)===''){
                    afield = "0"+afield;
                }
                if ( afield.length === 0 ){
                    return "0.00";
                }
                var dotPos = afield.indexOf(".");
                if ( dotPos < 0 ){
                    afield = afield+'.00';
                }
                if ( dotPos === 0 ){
                    afield = '0' + afield;
                    dotPos = afield.indexOf(".");
                }
                if ( dotPos == afield.length-2){
                    afield = afield + '0';
                }
                if ( dotPos == afield.length-1){
                    afield = afield + '00';
                }
                $scope.afield = afield;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('UNIFYPortal')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            
            return input;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .filter('characters', characters);

    function characters() {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length - 1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('UNIFYPortal')
        .filter('titleMap', titleMap);

    function titleMap() {
        return titleMap;

        function titleMap (index, constant) {
            var returnContent = '';
            if (!constant) {
                return '';
            }

            var arr = constant.filter(function(item) {
                return (index == item.value) || (index == item.name);
            });

            if (!arr.length) {
                return '';
            }

            if (arr[0].name) {
                returnContent = arr[0].name;
            } else {
                returnContent = arr[1].label;
            }

            return returnContent;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('UNIFYPortal')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('UNIFYPortal')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('UNIFYPortal')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split('>;');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ">;"');
                }
                var url = section[0].replace(/<(.*)/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil() {

        var service = {
            parseAscending: parseAscending,
            parsePage: parsePage,
            parsePredicate: parsePredicate
        };

        return service;

        function parseAscending(sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1) {
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage(page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate(sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1) {
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .filter('moneyUpcase', moneyUpcase);

    function moneyUpcase() {
        return moneyUpcase;


        function moneyUpcase(input) {
            if (input != '' && input != null && angular.isUndefined(input)) {
                var tmp = input.split(',').join('');
            } else {
                var tmp = input;
            };

            
            var numberValue = new String(Math.round(tmp * 100)); // 数字金额  
            var chineseValue = ""; // 转换后的汉字金额  
            var String1 = "零壹贰叁肆伍陆柒捌玖"; // 汉字数字  
            var String2 = "万仟佰拾亿仟佰拾万仟佰拾元角分"; // 对应单位  
            var len = numberValue.length; // numberValue 的字符串长度  
            var Ch1; // 数字的汉语读法  
            var Ch2; // 数字位的汉字读法  
            var nZero = 0; // 用来计算连续的零值的个数  
            var String3; // 指定位置的数值  
            if (len > 15) {
                alert("超出计算范围");
                return "";
            }

            if (numberValue == 0) {
                chineseValue = "零元整";
                return chineseValue;
            }

            String2 = String2.substr(String2.length - len, len); // 取出对应位数的STRING2的值  
            for (var i = 0; i < len; i++) {
                String3 = parseInt(numberValue.substr(i, 1), 10); // 取出需转换的某一位的值  
                if (i != (len - 3) && i != (len - 7) && i != (len - 11) && i != (len - 15)) {
                    if (String3 == 0) {
                        Ch1 = "";
                        Ch2 = "";
                        nZero = nZero + 1;
                    }
                    else if (String3 != 0 && nZero != 0) {
                        Ch1 = "零" + String1.substr(String3, 1);
                        Ch2 = String2.substr(i, 1);
                        nZero = 0;
                    }
                    else {
                        Ch1 = String1.substr(String3, 1);
                        Ch2 = String2.substr(i, 1);
                        nZero = 0;
                    }
                }
                else { // 该位是万亿，亿，万，元位等关键位  
                    if (String3 != 0 && nZero != 0) {
                        Ch1 = "零" + String1.substr(String3, 1);
                        Ch2 = String2.substr(i, 1);
                        nZero = 0;
                    }
                    else if (String3 != 0 && nZero == 0) {
                        Ch1 = String1.substr(String3, 1);
                        Ch2 = String2.substr(i, 1);
                        nZero = 0;
                    }
                    else if (String3 == 0 && nZero >= 3) {
                        Ch1 = "";
                        Ch2 = "";
                        nZero = nZero + 1;
                    }
                    else {
                        Ch1 = "";
                        Ch2 = String2.substr(i, 1);
                        nZero = nZero + 1;
                    }
                    if (i == (len - 11) || i == (len - 3)) { // 如果该位是亿位或元位，则必须写上  
                        Ch2 = String2.substr(i, 1);
                    }
                }
                chineseValue = chineseValue + Ch1 + Ch2;
            }

            if (String3 == 0) { // 最后一位（分）为0时，加上“整”  
                chineseValue = chineseValue + "整";
            }

            return chineseValue;

        };
    }
})();

(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
                    'Showing {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
                    '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
                    'of {{$ctrl.queryCount}} items.' +
                '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('UNIFYPortal')
        .component('jhiItemCount', jhiItemCount);
})();

(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .factory('FileService', FileService);

    FileService.$inject = ['$rootScope', 'showMsgService', '$log', 'Upload', '$window', 'RESTHOST'];

    /**
     * @memberOf directbank
     * @ngdoc service
     * @name FileService
     * @description
     * 处理文件上传相关的服务
     */
    function FileService($rootScope, showMsgService, $log, Upload, $window, RESTHOST) {

        var service = {
            fileUpload: fileUpload,
            fileUploadTo: fileUploadTo, // 文件上传
            fileDowload: fileDowload, // 文件下载
            fileDowload_bid: fileDowload_bid // 标书附件下载
        };

        return service;


        /**
         * 文件上传
        * @memberOf FileService
        // 使用
        <div class="form-group">
        <input type="file" ngf-select ng-model="vm.regForm.file"/>
       </div>
       <div class="progress progress-striped active">
           <div class="progress-bar progress-bar-success" role="progressbar"
              aria-valuenow="60" aria-valuemin="0" aria-valuemax="100"
              ng-style="progressPercentageStyle">
              <span ng-style="sr-only"><p ng-bind="progressPercentagesrOnly"></p></span>
           </div>
        </div>
         *
         */
        function fileUpload(file) {
            fileUploadTo(file, RESTHOST.DATA_HOST + "/api/oos")
        }


        function fileUploadTo(file, destUrl) {
            if (file === null || file === '' || angular.isUndefined(file)) {
                showMsgService.showMsg(1, "请选择上传文件!");
                return;
            }
            var filesize = file.size;
            var maxfilesize = 5 * 1024 * 1024;
            if (filesize > maxfilesize) {
                showMsgService.showMsg(1, '请选择小于5(MB)的文件！');
                return;
            }
            Upload.upload({
                //服务端接收
                url: destUrl,
                file: file
            }).progress(function (evt) {
                //进度条
                var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                var temp = progressPercentage + '%';
                $rootScope.progressPercentageStyle = {
                    "width": temp
                };
                $rootScope.progressPercentagesrOnly = temp + "完成";
                console.log('progess:' + progressPercentage + '%' + evt.config.file.name);
            }).success(function (data, status, headers, config) {
                if (data !== "" && !angular.isUndefined(data) && data !== null) {
                    showMsgService.showMsg(0, "文件上传成功");
                    $rootScope.$broadcast("callback.fileupload", data);

                } else {
                    showMsgService.showMsg(2, data);
                }
                //上传成功
                console.log('file ' + config.file.name + 'uploaded. Response: ' + data);

            }).error(function (data, status, headers, config) {
                //上传失败
                console.log('error status: ' + status);
            });
        }


        function fileDowload(url, name) {
            var xhr = new XMLHttpRequest();
            xhr.responseType = "blob";

            xhr.open("GET", url, true);
            //xhr.setRequestHeader("Authorization", 'Bearer ' + currUser.token);
            xhr.onreadystatechange = function (e) {
                if (this.readyState == 4) {
                    var response = this.response;
                    var URL = window.URL || window.webkitURL || window;
                    var link = document.createElement('a');
                    link.href = URL.createObjectURL(response);
                    //var timecur=(new Date()).Format('yyyy-MM-dd_hh_mm_ss');
                    link.download = name + '.wallet';
                    var event = document.createEvent('MouseEvents');
                    event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
                    link.dispatchEvent(event);
                }
            }
            xhr.send(null);
        }

        function fileDowload_bid(url, name) {
            var xhr = new XMLHttpRequest();
            xhr.responseType = "blob";

            xhr.open("GET", url, true);
            //xhr.setRequestHeader("Authorization", 'Bearer ' + currUser.token);
            xhr.onreadystatechange = function (e) {
                if (this.readyState == 4) {
                    var response = this.response;
                    var URL = window.URL || window.webkitURL || window;
                    var link = document.createElement('a');
                    link.href = URL.createObjectURL(response);
                    //var timecur=(new Date()).Format('yyyy-MM-dd_hh_mm_ss');
                    //link.download = name+'.wallet';
                    var event = document.createEvent('MouseEvents');
                    event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
                    link.dispatchEvent(event);
                }
            }
            xhr.send(null);
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .filter('dateMean', dateMean);
    dateMean.$inject = ['$filter'];

    function dateMean($filter) {
        return dateMean;

        function dateMean(date, formate) {
            var myformate = formate || 'yyyy-MM-dd';

            function convertLocalDateToServer(date) {
                if (date) {
                    return $filter('date')(date, myformate);
                } else {
                    return null;
                }
            }

            var formateDate = convertLocalDateToServer(date);
            var dateName = {
                today: Date.now(),
                yesterday: Date.now() - 24 * 3600 * 1000,
                Beforeyesterday: Date.now() - 2 * 24 * 3600 * 1000,
                tomorrow: Date.now() + 24 * 3600 * 1000,
                acquired: Date.now() + 2 * 24 * 3600 * 1000
            };
            for (var key in dateName) {
                var targetDate = convertLocalDateToServer(dateName[key]);
                if (formateDate === targetDate) {
                    return key;
                }
            }
            return formateDate;

        }
    }
})();
(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .factory('Dateformat', Dateformat);

    Dateformat.$inject = ['$filter'];

    function Dateformat($filter) {

        var service = {
            dateformat: dateformat
        };

        return service;

        /**
         * 
         * @param {Date} date 
         * @param {String} formatStr 支持MM/dd/yyyy hh:mm TT和 yyyy-MM-dd HH:mm:ss
         */
        function dateformat(date, formatStr) {
            Date.proptype.fomat = function (formatStr) {
                var d = this;
                var zeroize = function (value, length) {
                    if (!length) length = 2;
                    value = String(value);
                    for (var i = 0, zeros = ''; i < (length - value.length); i++) {
                        zeros += '0';
                    }
                    return zeros + value;
                };
                return formatStr.replace(/"[^"]*"|'[^']*'|\b(?:d{1,4}|m{1,4}|yy(?:yy)?|([hHMstT])\1?|[lLZ])\b/g, function ($0) {
                    switch ($0) {
                        case 'd':
                            return d.getDate();
                        case 'dd':
                            return zeroize(d.getDate());
                        case 'ddd':
                            return ['Sun', 'Mon', 'Tue', ''];
                    }
                })
            };
            return new Date(date).format(formatStr);
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils($filter) {

        var service = {
            convertDateTimeFromServer: convertDateTimeFromServer,
            convertLocalDateFromServer: convertLocalDateFromServer,
            convertLocalDateToServer: convertLocalDateToServer,
            dateformat: dateformat,
            dateMean: dateMean
        };

        return service;

        function convertDateTimeFromServer(date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer(date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer(date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateMean(date) {
            var formateDate = convertLocalDateToServer(date);
            var nowTime = Date.now();
            var dayTimes = 24 * 3600 * 1000;
            var dateName = {
                today: nowTime,
                yesterday: nowTime - dayTimes,
                Beforeyesterday: nowTime - 2 * dayTimes,
                tomorrow: nowTime + dayTimes,
                acquired: nowTime + 2 * dayTimes
            };
            for (var key in dateName) {
                var targetDate = convertLocalDateToServer(dateName[key]);
                if (formateDate === targetDate) {
                    return key;
                }
            }
            return formateDate;
        }

        function dateformat() {
            return 'yyyy-MM-dd';
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate(text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize(base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile(type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64(file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('UNIFYPortal')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
                input = input.substring(0, 1).toUpperCase() + input.substring(1);
            }
            return input;
        }
    }
})();

(function () {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('UNIFYPortal')
        .factory('Base64', Base64);

    function Base64() {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode: decode,
            encode: encode
        };

        return service;

        function encode(input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
            }

            return output;
        }

        function decode(input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }
            }

            return output;
        }
    }
})();
(function () {
    'use strict';
    angular
        .module('UNIFYPortal')
        .config(['$provide', function ($provide) {
            $provide.decorator('ngClickDirective', ['$delegate', '$timeout', function ($delegate, $timeout) {
                var original = $delegate[0].compile;
                var delay = 500;
                $delegate[0].compile = function (element, attrs, transclude) {
                    var disabled = false;

                    function onClick(evt) {
                        if (disabled) {
                            evt.preventDefault();
                            evt.stopImmediatePropagation();
                        } else {
                            disabled = true;
                            $timeout(function () {
                                disabled = false;
                            }, delay, false);
                        }
                    }
                    element.on('click', onClick);
                    return original(element, attrs, transclude);
                };
                return $delegate;
            }])
        }])
})();
(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal', 'ModalService', '$rootScope'];

    function LoginService($uibModal, ModalService, $rootScope) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open() {
            if (modalInstance !== null) return;
            // modalInstance = $uibModal.open({
            //     animation: true,
            //     templateUrl: 'app/components/login/login.html',
            //     controller: 'LoginController',
            //     controllerAs: 'vm',
            //     resolve: {
            //         translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
            //             $translatePartialLoader.addPart('login');
            //             return $translate.refresh();
            //         }]
            //     }
            // });
            // modalInstance.result.then(
            //     resetModal,
            //     resetModal
            // );

            ModalService.showModal({
                templateUrl: 'app/components/login/login.html',
                size: 'md',
                controller: 'LoginController as vm',
                controllerAs: 'vm',
                modalId: 'login',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                },
                backdrop: 'static',
                callback: {}
            }).result.then(function (data) {
                $rootScope.$broadcast('authenticationSuccess');
            });

        }
    }
})();
(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['ValidationService', '$scope', '$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance', 'showMsgService', 'ModalService', '$translate'];

    function LoginController(ValidationService, $scope, $rootScope, $state, $timeout, Auth, $uibModalInstance, showMsgService, ModalService, $translate) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.closeModal = closeModal;
        vm.username = null;
        vm.loginfailed = {};

        $timeout(function () {
            angular.element('#username').focus();
        });

        function cancel() {
            vm.credentials = {
                username: null,
                password: null,
                keyfile: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function closeModal() {
            var modalId = ModalService.getLastModalId();
            ModalService.closeModal(modalId, '');
        }

        function login(event) {
            vm.rememberMe = false;

            event.preventDefault();
            if (!ValidationService.validatePattern('login', vm.username)) {
                showMsgService.showMsg(1, $translate.instant('login.showMsg.illegal'));
                return;
            }
            if (!vm.username) {
                showMsgService.showMsg(1, $translate.instant('login.showMsg.userAccount'));
                //toastr.warning('请输入用户名称');
                return;
            }
            if (!vm.password) {
                showMsgService.showMsg(1, $translate.instant('login.showMsg.userPassword'));
                //toastr.warning('请输入用户密码');
                return;
            }
            if (!sessionStorage.getItem("wallet")) {
                showMsgService.showMsg(1, $translate.instant('login.showMsg.userKeyFile'));
                //toastr.warning('请选择秘钥文件');
                return;
            }
            Auth.login({
                username: vm.username,
                password: vm.password,
                keyfile: sessionStorage.getItem("wallet"),
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                // $uibModalInstance.close();
                vm.closeModal();
                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    $state.go('home');
                }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is succesful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function (error) {
                vm.authenticationError = true;
                if (error) {
                    if (!error.data.code && error.status === 401) {
                        vm.loginfailed.type = '8';
                        // showMsgService.showMsg(2, '证书或用户名错误');
                    } else if (error.data.code === '1401') {
                        vm.loginfailed.type = '1';
                        //vm.loginfailed.times = error.msg;
                        // showMsgService.showMsg(2, '用户名或密码错误，你还有'+vm.loginfailed.times+'次机会');
                    } else if (error.data.code === '1402') {
                        vm.loginfailed.type = '2';
                        //vm.loginfailed.time = error.msg;
                        // showMsgService.showMsg(2, '账号被锁定，请在'+vm.loginfailed.time+'后登录');
                    } else if (error.data.code === '1403') {
                        vm.loginfailed.type = '3';
                        // showMsgService.showMsg(2, '账户已被删除');
                    } else if (error.data.code === '1405') {
                        vm.loginfailed.type = '4';
                        // showMsgService.showMsg(2, '账户已被禁用');
                    } else if (error.data.code === '1406') {
                        vm.loginfailed.type = '5';
                        // showMsgService.showMsg(2, '用户证书被吊销');
                    } else if (error.data.code === '1400') {
                        vm.loginfailed.type = '6';
                        // showMsgService.showMsg(2, '账户未绑定证书');
                    } else if (error.data.code === '1407') {
                        vm.loginfailed.type = '7';
                        // showMsgService.showMsg(2, '账户未未激活');
                    }
                    vm.privateKey = null;
                    sessionStorage.removeItem("wallet");

                    // vm.closeModal();

                }
            });
        }



        vm.showContent = function ($fileContent) {
            sessionStorage.setItem("wallet", $fileContent);
        };

        function register() {
            $uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function requestResetPassword() {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$http', '$translate', 'LANGUAGES','$timeout'];

    function JhiLanguageService($q, $http, $translate, LANGUAGES,$timeout) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent
        };

        return service;

        function getAll() {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent() {
            var deferred = $q.defer();
            $timeout(function () {
                var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');
                // console.log('*****getCurrent****' + language + '****' + new Date().getTime());
                deferred.resolve(language);
            }, 0);
            return deferred.promise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('UNIFYPortal')
        .filter('findLanguageFromKey', findLanguageFromKey);

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return {
                'ca': 'Català',
                'cs': 'Český',
                'da': 'Dansk',
                'de': 'Deutsch',
                'el': 'Ελληνικά',
                'en': 'English',
                'es': 'Español',
                'fr': 'Français',
                'gl': 'Galego',
                'hu': 'Magyar',
                'hi': 'हिंदी',
                'it': 'Italiano',
                'ja': '日本語',
                'ko': '한국어',
                'mr': 'मराठी',
                'nl': 'Nederlands',
                'pl': 'Polski',
                'pt-br': 'Português (Brasil)',
                'pt-pt': 'Português',
                'ro': 'Română',
                'ru': 'Русский',
                'sk': 'Slovenský',
                'sv': 'Svenska',
                'ta': 'தமிழ்',
                'tr': 'Türkçe',
                'zh-cn': '中文简体',
                'zh-tw': '繁體中文'
            }[lang];
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale', '$rootScope', '$ngBootbox'];

    function JhiLanguageController($translate, JhiLanguageService, tmhDynamicLocale, $rootScope, $ngBootbox) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;

        JhiLanguageService.getAll().then(function (languages) {
            if ("zh-cn" === tmhDynamicLocale.get()) {
                vm.languages = ["zh-cn", "en"];
            }
            else {
                vm.languages = languages;
            }

        });

        function changeLanguage(languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
            $rootScope.languageKey = languageKey;
            sessionStorage.setItem('LA', languageKey);
            $rootScope.$broadcast("globallanguagechange", languageKey);


            if (languageKey === 'en') {
                $ngBootbox.setLocale('en')
            } else {
                $ngBootbox.setLocale('zh_CN')
            }



        }
    }
})();

(function () {
    'use strict';

    angular
        .module('UNIFYPortal')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            'en',
            'zh-cn'
            // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
        ]
    );
})();

(function() {
    'use strict';

    angular
        .module('UNIFYPortal')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, formCtrl) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        var inputName = $input.attr('name');
                        scope.$watch(function() {
                            return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('UNIFYPortal')
        .directive('sectionShow', sectionShow);

    function sectionShow () {
        var directive = {
            restrict: 'AE',
            templateUrl:'app/components/form/sectionShow/sectionShow.html',
            scope: {
                mvalue:'@'
            },
            controller:['$scope',sectionShowController],
            controllerAs:'vm',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs) {
            attrs.$observe('mvalue',function(value){
                if (value) {
                    changeClass1(value);
                }
            });


            function changeClass1(newValue) {
               if (element[0].firstChild.innerText) {
               }
            }
        
        }

        function sectionShowController($scope) {
            var vm = this;
            vm.collapse = collapse;
            vm.showmore = showmore;
            vm.hasOverflow = false;
            vm.isShowSection = false;

            function collapse(event) {
                $(event.target.parentElement).removeClass('p-phase');
                $(event.target.parentElement.nextElementSibling).show();
                $(event.target).hide();
                vm.hasOverflow = true;
            }

            function showmore(event) {
                $(event.target.previousElementSibling).addClass('p-phase');
                $(event.target).hide();
                $(event.target.previousElementSibling.firstElementChild).show();
                vm.hasOverflow = false;
            }

            function changeClass(newValue) {
                var tlength = newValue.length;
                vm.hasOverflow = tlength > 204 ? true : false;
                vm.isShowSection = tlength > 204 ? true : false;
                
            }
            $scope.$watch('mvalue',function(nv,ov){
                if (nv) {
                    changeClass(nv);
                }
            });
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('UNIFYPortal')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();

(function() {
    'use strict';

    angular
        .module('UNIFYPortal')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('UNIFYPortal')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('UNIFYPortal')
        .directive('inputshow', inputshow);
    
    function inputshow () {
        var directive = {
            restrict: 'EA',
            templateUrl:'app/components/form/hInput/hInput.html',
            scope: {
                mvalue:'@',
                maxlength:'@',
                mtype:'@',
                mclass:'@',
                inclass:'@'
            },
            controller:['$scope',hInputController],
            controllerAs:'vm',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs) {
            attrs.$observe('mvalue',function(value){
                if (value) {
                }
            });


            function changeClass(newValue) {
                if (newValue.length > attrs.maxlength) {
                    $(element[0].firstChild).addClass('maxellipsis');
                } else {
                    $(element[0].firstChild).removeClass('maxellipsis');
                }
            }
        
        }

        function hInputController($scope) {
            var vm = this;
            $scope.dynamicPopover = {
                templateUrl:'popover.html',
                trigger:'hover'
            };
            vm.isShow = false;
            vm.inputmouseOver = inputmouseOver;
            vm.inputmouseOut = inputmouseOut;


            function inputmouseOver(event) {
                if (event.target.className.indexOf('maxellipsis') > -1) {
                     vm.isShow = true;
                } else {
                    vm.isShow = false;
                }
            }

            function inputmouseOut() {
                vm.isShow = false;
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('UNIFYPortal')
        .directive('uploadIcon', uploadIcon);

    function uploadIcon () {
        var directive = {
            restrict: 'EA',
            templateUrl:'app/components/bizUI/uploadIcon/uploadIcon.html',
            // template: '<i class="iconfont icon-file"></i>',
            scope: {
                filename:'='
            },
            // controller: ['$state','$scope','$rootScope',uploadIconController],
            // controllerAs:'vm',
            link:linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var acceptFileType = ['gif', 'jpg', 'jpeg', 'png'];
            scope.$watch('filename',function(nv,ov){
                if (nv) {
                    var fileFix = nv.slice(nv.indexOf('.')+1);
                    var iconClass = '';
                    var iconCode = '';
                    if (acceptFileType.indexOf(fileFix.toLocaleLowerCase())>-1) {
                        iconClass = 'text-warning';
                        iconCode = '&#xe815;';
                    } else if (['doc','docx'].indexOf(fileFix)>-1) {
                        iconClass = 'text-primary';
                        iconCode = '&#xe816;';
                    } else if (fileFix === 'txt') {
                        iconClass = 'text-success';
                        iconCode = '&#xe814;';
                    } else if (['ppt','pptx'].indexOf(fileFix)>-1) {
                        iconClass = 'text-danger';
                        iconCode = '&#xe813;';
                    } else if (fileFix === 'pdf') {
                        iconClass = 'text-danger';
                        iconCode = '&#xe812;';
                    } else {
                        iconClass = 'text-muted';
                        iconCode = '&#xe814;';
                    }
                    element[0].children[0].innerHTML = iconCode;
                    element[0].children[0].className = "iconfont icon-file " + iconClass;
                }
            });
            
            attrs.$observe('filename',function(value){
                if (value) {
                    // console.log(value);

                }
            });
        }

        // function uploadIconController($state,$scope,$rootScope) {
        //     $scope.$watch('filename',function(nv,ov){
        //         console.log(nv);
        //     });
        // }
    }
})();

(function() {
    'use strict';

    angular
        .module('UNIFYPortal')
        .directive('compare', compare);

    function compare () {
        var directive = {
            restrict: 'AE',
            link: linkFunc,
            scope: {
                otherDate:'=compare'
            },
            require:"ngModel"
        };

        return directive;

        function linkFunc(scope,element,attrs,con) {
            con.$validators.compare = function(v) {
                return v > scope.otherDate;
            }
            scope.$watch('otherDate',function() {
                con.$validate();
            })
        }

    }
})();

(function () {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="">' +
            '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
            '</div>' +
            '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('UNIFYPortal')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate'];

    function jhiAlertErrorController($scope, AlertService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert(message, key, data) {
            key = key ? key : message;
            vm.alerts.push(
                AlertService.add({
                        type: 'danger',
                        msg: key,
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('UNIFYPortal.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
                // connection refused, server not reachable
                case 0:
                    addErrorAlert('Server not reachable', 'error.server.not.reachable');
                    break;

                case 400:
                    var errorHeader = httpResponse.headers('X-UNIFYPortal-error');
                    var entityKey = httpResponse.headers('X-UNIFYPortal-params');
                    if (errorHeader) {
                        var entityName = $translate.instant('global.menu.entities.' + entityKey);
                        addErrorAlert(errorHeader, errorHeader, {
                            entityName: entityName
                        });
                    } else if (httpResponse && httpResponse.fieldErrors) {
                        for (i = 0; i < httpResponse.fieldErrors.length; i++) {
                            var fieldError = httpResponse.fieldErrors[i];
                            // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                            var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                            var fieldName = $translate.instant('UNIFYPortal.' + fieldError.objectName + '.' + convertedField);
                            addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {
                                fieldName: fieldName
                            });
                        }
                    } else if (httpResponse && httpResponse.message) {
                        addErrorAlert(httpResponse.message, httpResponse.message, httpResponse);
                    } else {
                        addErrorAlert(httpResponse);
                    }
                    break;

                case 404:
                    addErrorAlert('Not found', 'error.url.not.found');
                    break;

                default:
                    if (httpResponse && httpResponse.message) {
                        addErrorAlert(httpResponse.message);
                    } else {
                        addErrorAlert(angular.toJson(httpResponse));
                    }
            }
        });

        $scope.$on('$destroy', function () {
            if (angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null) {
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();
(function() {
    'use strict';

    angular
        .module('UNIFYPortal')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate'];

        function getService ($timeout, $sce,$translate) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('UNIFYPortal')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();

/*
(function() {
    'use strict';

    angular
        .module('UNIFYPortal')
        .factory('urlInterceptor', urlInterceptor);

    urlInterceptor.$inject = ['$q'];

    function urlInterceptor ( $q) {
        var APIGW_URL = "http://10.10.6.30:8081/api/";
        var service = {
            request: request
        };

        return service;
        function request (config) {
            return {
                'request': function (config) {
                    config.url = APIGW_URL+config.url;
					console.log('config.url========================='+config.url);
                    return config || $q.when(config);

                }
            }
        }
    }
})();
*/
(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response(response) {

            console.log("Intercept repsonse data...");
            console.log(response.data);
            console.log(response.headers('X-OAuth2-Redirect'));
           
            var oauthHeader = response.headers('X-OAuth2-Redirect');

            if(oauthHeader) {
                window.location = oauthHeader;
            }

            return response;

            // var alertKey = response.headers('X-UNIFYPortal-alert');
            // if (angular.isString(alertKey)) {
            //     AlertService.success(alertKey, {
            //         param: response.headers('X-UNIFYPortal-params')
            //     });
            // }
            // return response;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor($q, $rootScope) {
        
        var service = {
            responseError: responseError
        };

        return service;
        
        function responseError(response) {
            
            console.log("Handle error response!");
            console.log(response);

            if (!(response.status === 401 && (response === '' || (response.path && response.path.indexOf('/api/account') === 0)))) {
                $rootScope.$emit('UNIFYPortal.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .factory('authExpiredInterceptor', authExpiredInterceptor);


    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$localStorage', '$sessionStorage', '$timeout', 'ErrorCode'];

    function authExpiredInterceptor($rootScope, $q, $injector, $localStorage, $sessionStorage, $timeout, ErrorCode) {
        var service = {
            responseError: responseError
        };
        var flag = true;

        return service;

        function responseError(response) {
            // console.log(response);
            var Auth;
            // if (response.status === 401) {
            //     delete $localStorage.authenticationToken;
            //     delete $sessionStorage.authenticationToken;
            //     var Principal = $injector.get('Principal');
            //     if (Principal.isAuthenticated()) {
            //         var Auth = $injector.get('Auth');
            //         Auth.authorize(true);
            //     }
            //     $rootScope.$broadcast('authorizeFailed');
            // }
            if (response.status === 504) {
                if (flag === true && sessionStorage.getItem('judgeLogin')) {
                    delete $localStorage.authenticationToken;
                    delete $sessionStorage.authenticationToken;
                    Auth = $injector.get('Auth');
                    Auth.logout();
                    $timeout(function () {
                        $rootScope.$broadcast('sessionTimeout');
                    }, 500);
                    flag = false;
                    $timeout(function () {
                        flag = true;
                    }, 2000);
                }

            }
            if (response.status === 888 || response.status === 1431) {
                if (flag === true && sessionStorage.getItem('judgeLogin')) {
                    delete $localStorage.authenticationToken;
                    delete $sessionStorage.authenticationToken;
                    Auth = $injector.get('Auth');
                    Auth.logout();
                    $timeout(function () {
                        $rootScope.$broadcast('otherLogin');
                    }, 500);
                    flag = false;
                    $timeout(function () {
                        flag = true;
                    }, 2000);
                }
            }

            if (response.data && response.data.code) {
                ErrorCode.findError(response.data.code);
            }
            return $q.reject(response);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .factory('authInterceptor', authInterceptor);

    authInterceptor.$inject = ['$rootScope', '$q', '$location', '$localStorage', '$sessionStorage'];

    function authInterceptor($rootScope, $q, $location, $localStorage, $sessionStorage) {
        var service = {
            'request': request
        };

        return service;

        function request(config) {
            
            /*jshint camelcase: false */
            config.headers = config.headers || {};
            var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;

            if (token) {
                config.headers.Authorization = 'Bearer ' + token;
            }
            return config;
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate'];

    function translationHandler($rootScope, $window, $state, $translate) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function () {

                // updateTitle();
            });

            $rootScope.$on('$destroy', function () {
                if (angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null) {
                    translateChangeSuccess();
                }
            });
        }

        // update the window title using params in the following
        // precendence
        // 1. titleKey parameter
        // 2. $state.$current.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current && $state.$current.pageTitle) {
                titleKey = $state.$current.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                $window.document.title = title;
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage', '$translate', 'JhiLanguageService', 'translationHandler', '$window',
        'Auth', 'Principal', 'VERSION', 'tmhDynamicLocale'];

    function stateHandler($rootScope, $state, $sessionStorage, $translate, JhiLanguageService, translationHandler, $window,
        Auth, Principal, VERSION, tmhDynamicLocale) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;
            if (!sessionStorage.getItem('LA')) {
                var la = '';
                la = "zh-cn";
                $translate.use("zh-cn");
                tmhDynamicLocale.set("zh-cn");
                $rootScope.languageKey = 'zh-cn';
                if (window.navigator.language === 'zh-CN' || window.navigator.language === 'zh') {
                    la = "zh-cn";
                    $translate.use("zh-cn");
                    tmhDynamicLocale.set("zh-cn");
                    $rootScope.languageKey = 'zh-cn';
                } else {
                    $translate.use("en");
                    tmhDynamicLocale.set("en");
                    $rootScope.languageKey = 'en';
                    la = "en";
                }
                sessionStorage.setItem('LA', la);
                $rootScope.$broadcast('changeKey');
            }

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                Auth.authorize(null, event);

                // Update the language
                JhiLanguageService.getCurrent().then(function (language) {
                    $translate.use(language);
                    $rootScope.languageKey = language;
                });

            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
                var titleKey = 'global.title';

                // Set the page title key to the one configured in state or use default one
                if (toState.pageTitle) {
                    titleKey = toState.pageTitle;
                }
                //translationHandler.updateTitle(titleKey);
            });

            $rootScope.$on('$destroy', function () {
                if (angular.isDefined(stateChangeStart) && stateChangeStart !== null) {
                    stateChangeStart();
                }
                if (angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null) {
                    stateChangeSuccess();
                }
            });
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('UNIFYPortal')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('UNIFYPortal')
        .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$cookies', '$log', 'LANGUAGES'];

    function translationStorageProvider($cookies, $log, LANGUAGES) {
        return {
            get: get,
            put: put
        };

        function get(name) {
            if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
                $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to prefered language "en"');
                $cookies.putObject(name, 'zh-cn');
            }
            return $cookies.getObject(name);
        }

        function put(name, value) {
            $cookies.putObject(name, value);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('UNIFYPortal')
        .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider'];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json?t='+new Date().getTime()
        });

        $translateProvider.preferredLanguage('zh-cn');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    }
})();

(function() {
    'use strict';

    angular
        .module('UNIFYPortal')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('hrrdc-');
        $sessionStorageProvider.setKeyPrefix('hrrdc-');
    }
})();

(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {

        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');
        //多数据源时不灵活，放开，个数据源自己配置，见app.constants.js
        /**$httpProvider.interceptors.push(function () {
            var APIGW_URL = "http://10.10.6.30:8081/";
            return {
                'request': function (config) {
                    if(config.url.indexOf("api/")>-1){
                        config.url = APIGW_URL+config.url ;
                        console.log("url.host.changed==="+config.url);
                    }else{
                        console.log("will not delegating ==="+config.url);
                    }

                    return config;

                }

            }
        });**/
        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
    
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here
        //$httpProvider.interceptors.push('urlInterceptor');


        $urlMatcherFactoryProvider.type('boolean', {
            name: 'boolean',
            decode: function (val) {
                return val === true || val === 'true';
            },
            encode: function (val) {
                return val ? 1 : 0;
            },
            equals: function (a, b) {
                return this.is(a) && a === b;
            },
            is: function (val) {
                return [true, false, 0, 1].indexOf(val) >= 0;
            },
            pattern: /bool|true|0|1/
        });
    }
})();
(function() {
    'use strict';

    angular
        .module('UNIFYPortal')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);
        
      
    }
})();

(function() {
    'use strict';

    angular
        .module('UNIFYPortal')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        AlertServiceProvider.showAsToast(false);
    }
})();

(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('toastr');
                    $translatePartialLoader.addPart('common');
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('nav');
                    $translatePartialLoader.addPart('home');
                    // $translatePartialLoader.addPart('conpanyInfo');
                    $translatePartialLoader.addPart('protocol');
                    $translatePartialLoader.addPart('button');
                    $translatePartialLoader.addPart('account');
                    return $translate.refresh();
                }]
            }
        });
    }
    // function testeslint() {
    //     if (x == 42) { }

    //     if ("" == text) { }

    //     if (obj.getStuff() != undefined) {
    //         alert(11111);
    //     }
    // }

})();

(function () {
    'use strict';

    angular
        .module('UNIFYPortal')
        .controller('AppController', AppController);

    AppController.$inject = ['$scope', 'Principal', '$state', '$uibModal', '$uibModalInstance', 'toastr', '$filter', '$translate'];

    function AppController($scope, Principal, $state, $uibModal, $uibModalInstance, toastr, $filte, $translate) {
        var vm = this;
        $scope.$on('authenticationSuccess', function (event, data) {
                alert('authenticationSuccess');
        })
    }
})();

(function () {
    'use strict';
    angular
        .module('UNIFYPortal')
        .constant('RESTURIS', {
            "WEBSOCKET": "/api/websocker-server",
            "ACCOUNT": {
                "RESOURCE": "/api/account",
                "AUTH": "/api/authenticate",
                //"AUTH": "/api/portal/authenticate",
                "LOGINOUT": "/api/loginOut",
                "PUBLICKEY": "/api/getPublicKey",
                "SSO": "/api/ugm/checkjwt",
                "GETSSOJWT": "/api/portal/getSSOJwt"
            },
            "COMMON": {
                "QYERYLOCAL": "/api/orginfos/local/likeFromPortal",
                "DEVENV": "/api/devEnv",
                "ORGINFOS": "/api/orginfos",
                "FINDORGLIKENAME": "/api/orginfo/like",//查询组织机构带名片
                "FINDORGLIKENAMEOLD": "/api/orginfo/like",//只查组织机构
                "FINDORGBYLEVELLIKENAME": "/api/orginfo/level/likeFromPortal",
                "COUNTRYLIKE": "/api/country/like",
                "COUNTRYCODE": "/api/country/code",
                "FINDORGBYNAME": "/api/orginfo/one",
                "MODULES": "/api/portal/module/modules",
                "MYPHYSICAL": "/api/physicalNode/queryMyPhysical",
                "UPDATEMYPHYSICAL": "/api/physicalNode/updatePhysicalAddress",
                "QUERYNEWPHYSICAL": "/api/physicalNode/queryAllPhysical",
                "DOWNLOADPHYSICAL": "/api/physicalNode/downPhysical",
                "GETIMAGE": "/api/notice/queryByIds",
                "LOADLOGO": "/api/upLoadLogo",

                "VERIFY_CODE": "/api/authenticate/verify-code",
                "VERIFY_CODE_SM": "/api/authenticate/verify-code/sm",
                "FORGET_PWD_VERIFY_CODE_SM": "/api/authenticate/verify-code/pwd/recover",
                "RESET_PWD": "/api/authenticate/verify-code/pwd/recover/modify"
            },
            "LOGINWELCOME": {
                "MYMODULES": "/api/portal/module/myModules",
                "WAITINSTALLMODULES": "/api/portal/module/waitInstallModules",
                "ONEWAITINSTALLMODULES": "/api/portal/module",
                "INSTALLAPP": "/api/app/installApp",
                "UNINSTALLAPP": "/api/app/uninstallApp",
                "ACTIVEAPP": "/api/app/activeApp",
                "REACTIVEAPP": "/api/app/reActiveApp",
                "ACTIVATE": "/api/app/validLicence",
                "SUBSCRIPTION": "/api/app/getTemporayToken"
            },
            "ZONE": {
                "CREATEZONE": "/api/friendsZone",
                "SEARCHZONE": "/api/friendsZone/list",
                "JOINZONE": "/api/fzMessage/jion",
                "VOTEJOINZONE": "/api/fzMessage/vote/joinZone",
                "VOTEINVITEJOINZONE": "/api/fzMessage/vote/inviteJoinZone",
                "VOTEUPMEMBER": "/api/fzMessage/vote/upMember",
                "VOTEDELETEZONE": "/api/fzMessage/vote/deleteZone",
                "ZONELIST": "/api/friendsZone/inZone/list",
                "ZONELISTWEBSOCKET": "/api/client/advice",
                "QUERYJOINZONE": "/api/fzMessage/message/list",
                "AUDITJOINZONE": "/api/friendsZone/audit/join",
                "UPDATEZONEMEMBER": "/api/friendsZone/updateMember",
                "INVITEZONEMEMBER": "/api/friendsZone/inviteMembers",
                "UPADTENICKNAME": "/api/friendsZone/nickName"
            },
            "USERMANAGE": {
                "CREATEUSER": "/api/orguser",
                "MODEFY": "/api/orgUser",
                "DELETEUSER": "/api/OrgUser",
                "USESTATE": "/api/startStopStatus",
                "MODIFYPASSWORD": "/api/orguser/info",
                "QUERY": "/api/orguser",
                "FETCH": "/api/user",
                "CHANGEPW": "/api/account/change_password",
                "MODEFYPWD": "/api/orguser/updatePwd",
                "MCASTATUS": "/api/OrgUser/cer",
                "USERSTATUS": "/api/startStopStatus",
                "UPGRADEDUSER": "/api/upGradedUser"
            },
            "ROLEMANAGE": {
                "CREATEROLE": "/api/saveRole",
                "MODIFY": "/api/modify",
                "DELETEROLE": "/api/delRole",
                "QUERY": "/api/rolePage",
                "QUERYLIST": "/api/roleList",
                "FINDONE": "/api/getRole",
                "MODIFYFUNCTION": "/api/modifyRoleFunction"
            },
            "FUNCTIONMANAGER": {
                "QUERY": "/api/functionlist"
            },
            "ORGLIST": {
                "QUERY": "/api/orgInfo/tree",
                "SELECT": "/api/orgInfo/showSelect"
            },
            "UPLOAD": { //上传文件
                "UPLOADFILE": "/api/ugm/file/upload",
                "DOWNLOADFILE": "/api/app/file/download"
            },
            "BUSCODE": {
                "FINDBYBUSCODE": "/api/factoring/creditCover/findByBusCode"
            },
            "ADDRMANAGE": {
                "QUERY": "/api/orgAddress",
                "CREATE": "/api/orgAddress",
                "DEL": "/api/orgAddress/_deteleAddress",
                "MODIFY": "/api/orgAddress/_updateAddress",
                "FIND": "/api/orgAddress/_getByAddressId",
                "UPGRADED": "/api/orgAddress/_updateDefault",
                "PUSH": "/api/orgAddress/_pushAddress",
                "QUERYPHY": "/api/physicalNode"
            },
            "CARDS": {
                "QUERY": "/api/orgCard",
                "CREATE": "/api/orgCard",
                "DEL": "/api/orgCard/_deleteCards",
                "MODIFY": "/api/orgCard",
                "FIND": "/api/orgCard/_search",
                "UPGRADED": "/api/orgCard/_updateDefault",
                "PUSH": "/api/orgCard/_pushAddress",
                "INPUT": "/api/orgCard/_importCard",
                "UPLOAD": "/api/orgCard/_uploadCard",
                "UNGROUPCARDS": "/api/orgCard/unGroupCards"
            },
            "REMOTECARDS": {
                "QUERY": "/api/orgCard/remote",
                "CREATE": "/api/orgCard/remote",
                "DEL": "/api/orgCard/remote/_deleteCards",
                "MODIFY": "/api/orgCard/remote",
                "FIND": "/api/orgCard/remote/_search",
                "UPGRADED": "/api/orgCard/remote/_updateDefault",
                "PUSH": "/api/orgCard/remote/_pushAddress",
                "INPUT": "/api/orgCard/remote/_importCard",
                "UPLOAD": "/api/orgCard/remote/_uploadCard",
                "UNGROUPCARDS": "/api/orgCard/remote/unGroupCards"
            },
            "REFACTTRANSFER": {
                "ADD": "/api/refact/InvoiceCreditNote/addInvoiceCreditNote",//新建发票
                "LIST": "/api/refact/InvoiceCreditNote/list",//票据列表
                "DETAIL": "/api/refact/InvoiceCreditNote/oneInvoiceCreditNote",//发票详情
                "AUDIT": "/api/refact/InvoiceCreditNote/audit",//发票审核
                "SNAPSHOTLIST": "/api/refact/InvoiceCreditNote/listTrf",//快照列表
                "SNAPSHOTDETAIL": "/api/refact/InvoiceCreditNote/oneTrfInvoiceCreditNote"
            },
            "TRANSF": {
                "LIST": "/api/refactoring/Transf/list",//转让列表
                "ADD": "/api/refactoring/Transf/addTransf",//转让新增
                "DETAIL": "/api/refactoring/Transf/oneTransf",//转让详情
                "AUDIT": "/api/refactoring/Transf/audit"//转让审核
            },
            "TRANSFAPPLY": {
                "ADD": "/api/refactoring/transfApply/addOrUpdateTransfAppy",//新建转让申请
                "LIST": "/api/refactoring/transfApply/list",
                "DETAIL": "/api/refactoring/transfApply/oneTransfApply",
                "AUDIT": "/api/refactoring/transfApply/audit",
                "BLOCK": "/api/refactoring/transfApply/blockchain"
            },
            // 预转让回复
            "TRANSFRESP": {
                "ADD": "/api/refactoring/transfResp/addOrUpdateTransfResp",
                "AUDIT": "/api/refactoring/transfResp/audit"
            },
            // 正式转让
            "FORMALTRANSF": {
                "ADD": "/api/refactoring/formalTransf/addOrUpdateFormalTransf",
                "AUDIT": "/api/refactoring/formalTransf/audit"
            },
            // 受让
            "TRANSFEREE": {
                "ADD": "/api/refactoring/farmInTransf/addOrUpdateFarmIn",
                "AUDIT": "/api/refactoring/farmInTransf/audit"
            },

            //单据需要
            "INVOICESNDREDITTES": {
                "ADD": "/api/factoring/InvoiceCreditNote/addInvoiceCreditNote",//新建票据
                "LIST": "/api/factoring/InvoiceCreditNote/list",//票据列表
                "AUDIT": "/api/factoring/InvoiceCreditNote/audit",//票据审批
                "DETAIL": "/api/factoring/InvoiceCreditNote/oneInvoiceCreditNote",//票据详情
                "RESPONSE": "/api/factoring/InvoiceCreditNote/response",//票据买入保理行确认
                "DELETE": "/api/factoring/InvoiceCreditNote/delete"//票据删除
            },
            "RECEIVABLE": {
                "QUERY": "/api/factoring/invoicesCreditNotes/invoicesCreditNotes/all"
            },
            "RECEIVABLECONFIRM": {
                "ONE": "/api/refactoring/confirmApply/oneConfirmApply",
                "ADD": "/api/refactoring/confirmApply",
                "AUDIT": "/api/refactoring/confirmApply/audit",
                "LIST": "/api/refactoring/confirmApply/list",
                "BLOCK": "/api/refactoring/confirmApply/blockchain"
            },

            "CONFIRMRESP": {
                "ONE": "/api/refactoring/confirmResp/oneConfirmResp",
                "ADD": "/api/refactoring/confirmResp",
                "AUDIT": "/api/refactoring/confirmResp/audit",
                "LIST": "/api/refactoring/confirmResp/list",
                "BLOCK": "/api/refactoring/confirmResp/blockchain"
            },
            "GROUPS": {
                "LIST": "/api/group/list",
                "SAVE": "/api/group",
                "ONE": "/api/group/findOne",
                "DEL": "/api/group"
            }
        })
        ;
})();(function(){angular.module('UNIFYPortal').run(['$templateCache', function($templateCache) {$templateCache.put('app/directives/amtInput/amtInput.html','<input type="txt" class="form-control" ng-keyup="vm.keyUpAmt();" ng-blur="vm.blurAmtInput();" ng-mousedown="vm.mouseDown();" ng-model="afield">\n');
$templateCache.put('app/directives/date/date.html','<div class="input-group" style="position: static;">\n    <input type="text" class="form-control" uib-datepicker-popup="yyyy-MM-dd"\n           alt-input-formats="[\'yyyy-M!-d!\']"\n           close-text="{{\'button.datePicker.close\'|translate}}" clear-text="{{\'button.datePicker.clear\'|translate}}" current-text="{{\'button.datePicker.today\'|translate}}"\n           ng-model="time" ng-click="openCalendar(1)" ng-disabled="readonly"\n           is-open="datePickerOptions.startMinOpened" datepicker-options="datePickerOptions"/>\n    <span class="input-group-addon"><i class="glyphicon glyphicon-calendar" ng-click="openCalendar(1)"></i> </span>\n</div>');
$templateCache.put('app/directives/passwordShow/passwordShow.html','<!DOCTYPE html>\n<style>\n    .form-control-feedback-passwordshow {\n        position: absolute;\n        top: 0%;\n        right: 0;\n        z-index: 3;\n        display: block;\n        width: 34px;\n        height: 34px;\n        line-height: 34px;\n        text-align: center;\n        pointer-events: auto;\n        cursor: pointer;\n    }\n</style>\n\n<div class="form-group">\n    <div class="col-xs-12">\n        <div class="input-group">\n            <span class="input-group-addon">\n                <i class="glyphicon glyphicon-lock"></i>\n            </span>\n            <input type="{{passwordType}}" class="form-control" id="password"\n                placeholder="{{\'login.form.password.placeholder\' | translate}}" ng-model="vm.password">\n            <span>\n                <i ng-click="passwordshow()"\n                    ng-class="{\'glyphicon-eye-open\':passwordType !== \'password\',\'glyphicon-eye-close\':passwordType == \'password\'}"\n                    class="glyphicon form-control-feedback-passwordshow"></i>\n                <!-- <i ng-mousedown="vm.passwordshow()" ng-mouseup="vm.passwordhide()" ng-class="{\'glyphicon-eye-open\':vm.passwordType == \'password\',\'glyphicon-eye-close\':vm.passwordType == \'text\'}" class="glyphicon form-control-feedback-passwordshow"></i> -->\n            </span>\n        </div>\n    </div>\n</div>');
$templateCache.put('app/directives/passwordStrength/passwordStrength.html','<p class="help-block password-strength clearfix">\n\t<span ng-class="weakClass">\u4F4E</span>\n\t<span ng-class="mediumClass">\u4E2D</span>\n\t<span ng-class="strongClass">\u5F3A</span>\n</p>');
$templateCache.put('app/directives/tabMenu/tabMenu.html','<ul id="myTab" class="nav-tabs meun-tabs clearfix">\n    <li ng-repeat="nav in navs" ng-class="{\'active\':nav.active===\'true\'}">\n        <a href="javascript:void(0)" has-any-authority="{{nav.uisref}}" ui-sref="{{nav.uisref}}">{{nav.title |translate}}</a>\n    </li>\n</ul>');
$templateCache.put('app/components/login/login.html','<div class="modal-header">\n    <button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button>\n    <h4 class="modal-title" data-translate="login.title">Sign in</h4>\n</div>\n<div class="modal-body">\n    <div class="row">\n        <div class="col-md-4 col-md-offset-4">\n            <h1 data-translate="login.title">Sign in</h1>\n        </div>\n        <div class="col-md-8 col-md-offset-2">\n            <div class="alert alert-danger" ng-show="vm.authenticationError && vm.loginfailed.type===\'1\'" data-translate="login.messages.error.authentication"\n                translate-values="{times: \'{{vm.loginfailed.times}}\'}">\n            </div>\n            <div class="alert alert-danger" ng-show="vm.authenticationError && vm.loginfailed.type===\'2\'" data-translate="login.messages.error.userlocked"\n                translate-values="{time: \'{{vm.loginfailed.time}}\'}">\n            </div>\n            <div class="alert alert-danger" ng-show="vm.authenticationError && vm.loginfailed.type===\'3\'" data-translate="login.messages.error.userdelete">\n            </div>\n            <div class="alert alert-danger" ng-show="vm.authenticationError && vm.loginfailed.type===\'4\'" data-translate="login.messages.error.userforbid">\n            </div>\n            <div class="alert alert-danger" ng-show="vm.authenticationError && vm.loginfailed.type===\'5\'" data-translate="login.messages.error.usercapause">\n            </div>\n            <div class="alert alert-danger" ng-show="vm.authenticationError && vm.loginfailed.type===\'6\'" data-translate="login.messages.error.usercabind">\n            </div>\n            <div class="alert alert-danger" ng-show="vm.authenticationError && vm.loginfailed.type===\'7\'" data-translate="login.messages.error.usernotactive">\n            </div>\n            <div class="alert alert-danger" ng-show="vm.authenticationError && vm.loginfailed.type===\'8\'" data-translate="login.messages.error.caError">\n            </div>\n        </div>\n        <div class="col-md-8 col-md-offset-2">\n            <form novalidate class="form" role="form" ng-submit="vm.login($event)">\n                <div class="form-group">\n                    <label for="username" data-translate="global.form.username">Login</label>\n                    <input type="text" class="form-control" id="username" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.username">\n                </div>\n                <div class="form-group">\n                    <label for="password" data-translate="login.form.password">Password</label>\n                    <input type="password" class="form-control" id="password" placeholder="{{\'login.form.password.placeholder\' | translate}}"\n                        ng-model="vm.password">\n                </div>\n                <!--<div class="form-group row">\n                    <label class="col-sm-4">{{\'login.showMsg.userKeyFile\'|translate}}</label>\n                    <div  class="col-sm-5">\n                    <input type="file" id="privateKey" ng-model="vm.privateKey" on-read-file="vm.showContent($fileContent)" ng-change="vm.showFile()"/>\n                    <div ng-if="false">\n                        <h2>File content is:</h2>\n                        <pre>{{ content }}</pre>\n                    </div>\n                    </div>\n                </div>-->\n                <div class="form-group">\n                    <div class="input-group">\n                        <input type="text" class="form-control" readonly="readonly" ng-model="vm.privateKey.name">\n                        <span class="input-group-btn">\n                            <button class="btn btn-default" type="button">{{\'login.showMsg.userKeyFile\'|translate}}</button>\n                            <input type="file" id="privateKey" class="upload" ng-model="vm.privateKey" on-read-file="vm.showContent($fileContent)" ngf-select\n                            />\n                        </span>\n                    </div>\n                </div>\n\n                <!--<div class="form-group">\n                    <label for="password" data-translate="login.form.privatekey">Privatekey</label>\n                    <div class="form-group">\n\t\t\t\t\t\t<textarea  ng-model="vm.privateKey" style="min-height:100px;width:100%;"></textarea>\n\t\t\t\t\t</div>\n                </div>-->\n\n                <!--<div class="checkbox">\n                    <label for="rememberMe">\n                        <input type="checkbox" name="rememberMe" ng-model="vm.rememberMe" ng-true-value="true" ng-false-value="false">\n                        <span data-translate="login.form.rememberme">Remember me</span>\n                    </label>\n                </div>-->\n                <div class="form-group">\n                    <button type="submit" class="btn btn-warning pull-right" data-translate="login.form.button">Sign in</button>\n                </div>\n            </form>\n            <p></p>\n            <!--<div class="alert alert-warning">\n                <a class="alert-link" href="" ng-click="vm.requestResetPassword()" data-translate="login.password.forgot">Did you forget your password?</a>\n            </div>\n            <div class="alert alert-warning" data-translate="global.messages.info.register" translate-compile>\n                You don\'t have an account yet? <a class="alert-link" href="" ng-click="vm.register()">Register a new account</a>\n            </div>-->\n        </div>\n    </div>\n</div>');
$templateCache.put('app/layouts/error/accessdenied.html','<div ng-cloak>\n        <div class="container-1200 bg-white accessdenied-bg">\n            <h3 class="accessdenied-title" data-translate="error.403">\u60A8\u6682\u65E0\u8BBF\u95EE\u6743\u9650</h3>\n            <button class="accessdenied-btn" data-translate="error.returnHome" ui-sref="home">\u8FD4\u56DE\u9996\u9875</button>\n        </div>\n</div>\n');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak>\n    <div class="row">\n        <div class="col-md-4">\n            <span class="hipster img-responsive img-rounded"></span>\n        </div>\n        <div class="col-md-8">\n            <h1 data-translate="error.title">Error Page!</h1>\n\n            <div ng-show="errorMessage">\n                <div class="alert alert-danger">{{errorMessage}}\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n');
$templateCache.put('app/layouts/footer/footer.html','<!--footer start-->\n<div class="bg-white footer">\n    <div class="container-1170">\n        <div class="row">\n            <p>Copyright\xA92022 \u8D63ICP\u59072022007422\u53F7</p>\n            <!-- <p>{{\'common.footer.reserved\'|translate}}\n                <span>|</span>\n                {{vm.ICP}}\n                <a style="color: #666;" target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32011402010360">\n                    <img ng-src="/content/images/icp.png" alt="">{{vm.PUBLICSECURITYRECORDNUMBER}}\n                </a>\n            </p>\n            <p>{{\'common.footer.copyright\'|translate}}</p>\n            <p>{{\'common.footer.backStageVersion\'|translate}}:{{vm.version}}</p> -->\n        </div>\n    </div>\n</div>\n<!--footer end-->');
$templateCache.put('app/layouts/navbar/navbar.html','<style>\n    .header-top-logo span {\n        font-size: 24px;\n        line-height: 50px;\n        color: #337ab7;\n        display: inline-block;\n        vertical-align: middle;\n    }\n</style>\n<!-- <div ng-if="vm.env !==\'prod\'" class="env">\n    <span ng-class="{\'prod\':vm.env ===\'dev\'}">{{\'global.menu.\' + vm.env | translate}}</span>\n</div> -->\n<!-- \u7B2C\u4E00\u884Cnavbar -->\n<div class="head-fixed" ng-switch="vm.isAuthenticated()" ng-controller="JhiLanguageController as languageVm">\n    <div class="header-top">\n        <div class="container">\n            <div class="row">\n                <div class="header-top-logo">\n                    <!-- <img src="content/images/logo.png"> -->\n                    <!-- <img src="/content/images/runchain.png" alt=""> -->\n                    <span ng-if="$root.languageKey== \'zh-cn\'">{{vm.logo.comment}}</span>\n                    <span style="font-size: 20px;" ng-if="$root.languageKey== \'en\'">{{vm.logo.commentEn}}</span>\n                    <!-- <i ng-if="$root.languageKey== \'zh-cn\'" class="iconfont icon-maoyijinrongqukuailianlianmeng"></i>\n                    <i ng-if="$root.languageKey== \'en\'" style="font-size: 16px;" class="iconfont icon-Tradefinance-logo"></i> -->\n                </div>\n                <ul class="clearfix language">\n                    <li ui-sref-active="active" uib-dropdown class="dropdown pointer" ng-controller="JhiLanguageController as languageVm">\n                        <a class="dropdown-toggle" uib-dropdown-toggle href="" ng-if="languageVm.languages.length > 1">\n                            <span>\n                                <span style="display:inline;top:0px" class="glyphicon glyphicon-flag"></span>\n                                <span style="display:inline" class="hidden-sm" data-translate="global.menu.language">\u8BED\u8A00</span>\n                                <span class="caret"></span>\n                            </span>\n                        </a>\n                        <ul class="dropdown-menu" uib-dropdown-menu ng-if="languageVm.languages.length > 1">\n                            <li active-menu="{{language}}" ng-repeat="language in languageVm.languages">\n                                <a href="" ng-click="languageVm.changeLanguage(language)">{{language | findLanguageFromKey}}</a>\n                            </li>\n                        </ul>\n                    </li>\n                </ul>\n                <!-- <div class="setting" style="z-index: 2;" ng-if="isLogin" has-any-authority="account">\n                    <a class="flip" data-translate="portal.bread.unitinfo">\u5355\u4F4D\u7BA1\u7406</a>\n                    <div class="setting-list" ng-class="{\'en\':$root.languageKey== \'en\'}">\n                        <a href="javascript:void(0); " has-any-authority="password" ui-sref="password" data-translate="portal.bread.changePwd">\u4FEE\u6539\u5BC6\u7801</a>\n                        <a href="javascript:void(0);" has-any-authority="usermanager" id="usermanager" ng-click="vm.showBlSelectModal($event)" data-translate="portal.bread.userManager">\u7528\u6237\u7BA1\u7406</a>\n                        <a href="javascript:void(0);" has-any-authority="rolemanager" id="rolemanager" ng-click="vm.showBlSelectModal($event)" data-translate="portal.bread.roleManager">\u89D2\u8272\u7BA1\u7406</a>\n                        <a href="javascript:void(0);" has-any-authority="orgmanager" id="orgmanager" ng-click="vm.showBlSelectModal($event)" data-translate="portal.bread.orgManager">\u673A\u6784\u7BA1\u7406</a>\n                        <a href="javascript:void(0);" has-any-authority="cardManagement" id="cardManagement" ng-click="vm.showBlSelectModal($event)"\n                            data-translate="portal.bread.cardManagement">\u597D\u53CB\u7BA1\u7406</a>\n                    </div>\n                    <i class="iconfont">&#xe602;</i>\n                </div> -->\n\n                <!-- <div class="navbar-account pull-right" ng-if="$root.isLogin">\n                    <ul class="clearfix" style="padding-left: 0">\n                        <li>\n                            <a data-translate="global.org" style="font-size: 12px;">\u91D1\u878D\u673A\u6784:</a>\n                        </li>\n                        <li>\n                            <inputshow ng-if="vm.languageFlag==\'zh-cn\'" mtype="a" mclass="mw100" mvalue="{{$root.orgName}}" maxlength="3"></inputshow>\n                            <inputshow ng-if="vm.languageFlag==\'en\'" mtype="a" mclass="mw100" mvalue="{{$root.orgNameEn}}" maxlength="5"></inputshow>\n                        </li>\n                        <li>\n                            <inputshow mtype="a" mclass="mw100" mvalue="{{$root.login}}" maxlength="2"></inputshow>\n                        </li>\n                        <li>\n                            <inputshow mtype="a" mclass="mw100" mvalue="{{$root.uRole}}" maxlength="3"></inputshow>\n                        </li>\n                        <li>\n                            <a ng-click="vm.logout()" data-translate="global.menu.layout">[\u9000\u51FA]</a>\n                        </li>\n                    </ul>\n                </div> -->\n                <!--\n                <ul class="header-nav" style="padding: 0">\n                    <li ng-class="{\'active\':$root.myDirection===\'login\'}" ng-if="!$root.isLogin">\n                        <a href="javascript:void(0);" data-translate="global.menu.home" ng-click="vm.goLogin()">\u9996\u9875</a>\n                    </li>\n                    <li ng-class="{\'active\':$root.myDirection===\'welcome\'}" ng-if="$root.isLogin">\n                        <a href="javascript:void(0);" ng-click="vm.goWelcome()" data-translate="global.menu.ecosphere">\u751F\u6001\u5708</a>\n                    </li>\n                    <li ng-class="{\'active\':$root.myDirection===\'welcome\'}" ng-if="$root.isLogin">\n                        <a href="javascript:void(0);" ng-click="vm.goWelcome()" data-translate="global.menu.welcome">\u6B22\u8FCE\u9875</a>\n                    </li>\n                    <li ng-if="!$root.isLogin">\n                        <a href="javascript:void(0)" ng-click="vm.activate()" data-translate="global.menu.account.activate">\u6FC0\u6D3B</a>\n                    </li>\n                    <li ng-class="{\'active\':vm.currentState===\'apply\'}" ng-if="!$root.isLogin">\n                        <a href="javascript:void(0)" ng-click="vm.adduser()" data-translate="home.regiest.joinblock">\u4EE3\u7406\u52A0\u76DF</a>\n                    </li>\n                </ul>\n                 -->\n            </div>\n        </div>\n    </div>\n    <div class="bg-white" ng-if="$root.isLogin">\n        <div class="container-1170">\n            <div class="row">\n                <div class="header clearfix">\n                    <ul class="nav clearfix" style="margin-left: 200px;">\n                        <li ng-class="{\'active\':$root.myDirection===\'login-welcome\'}">\n                            <a href="javascript:void(0);" ng-click="vm.direction(\'login-welcome\')" data-translate="global.menu.welcome">\u6B22\u8FCE\u9875</a>\n                        </li>\n                        <li ng-class="{\'active\':$root.myDirection===\'ecosphere\'}">\n                            <a href="javascript:void(0);" ng-click="vm.direction(\'ecosphere\')" data-translate="global.menu.ecosphere">\u751F\u6001\u5708</a>\n                        </li>\n                    </ul>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>');
$templateCache.put('app/pages/login/login.html','<!--\u7126\u70B9\u56FE start-->\n<!DOCTYPE html>\n<style>\n    ul,\n    li {\n        list-style: none;\n        padding: 0;\n        margin: 0;\n    }\n\n    .grid_cl {\n        margin: 20px auto;\n        text-align: center;\n    }\n\n    .title {\n        display: inline-block;\n        margin-top: 20px;\n        position: relative;\n        margin: 0 auto;\n        font-size: 28px;\n        text-align: center;\n        color: #222;\n        /* width: 250px; */\n        padding: 0 50px;\n    }\n\n    .title::before,\n    .title::after {\n        content: \'\';\n        position: absolute;\n        width: 50px;\n        height: 3px;\n        display: block;\n        background: #222;\n        top: 15px;\n    }\n\n    .title::before {\n        left: -20px;\n    }\n\n    .title::after {\n        right: -20px;\n    }\n\n    #myCarouselInstallAPP {\n        /* height: 500px; */\n        height: calc(100% - 133px);\n\n        overflow: hidden;\n    }\n\n    .carousel-inner>.item>img {\n        width: 100%;\n    }\n\n    .loginBg {\n        height: 100vh;\n        width: 100%;\n        overflow: hidden;\n        background: url(\'/content/images/login_bg.png\') center center no-repeat;\n        background-size: cover;\n    }\n</style>\n\n<div class="loginBg">\n    <!-- <div class="loginBg">&nbsp;111</div> -->\n    <div class="login_box">\n        <h3 data-translate="login.title" style="text-align: center;color:#fff">\u767B\u5F55</h3>\n        <p class="login_box_danger" ng-show="vm.authenticationError && vm.loginfailed.type===\'1\'"\n            data-translate="login.messages.error.authentication"></p>\n        <p class="login_box_danger" ng-show="vm.authenticationError && vm.loginfailed.type===\'2\'"\n            data-translate="login.messages.error.userlocked"></p>\n        <p class="login_box_danger" ng-show="vm.authenticationError && vm.loginfailed.type===\'3\'"\n            data-translate="login.messages.error.userdelete"></p>\n        <p class="login_box_danger" ng-show="vm.authenticationError && vm.loginfailed.type===\'4\'"\n            data-translate="login.messages.error.userforbid"></p>\n        <p class="login_box_danger" ng-show="vm.authenticationError && vm.loginfailed.type===\'5\'"\n            data-translate="login.messages.error.usercapause"></p>\n        <p class="login_box_danger" ng-show="vm.authenticationError && vm.loginfailed.type===\'6\'"\n            data-translate="login.messages.error.usercabind"></p>\n        <p class="login_box_danger" ng-show="vm.authenticationError && vm.loginfailed.type===\'7\'"\n            data-translate="login.messages.error.usernotactive"></p>\n        <p class="login_box_danger" ng-show="vm.authenticationError && vm.loginfailed.type===\'8\'"\n            data-translate="login.messages.error.caError"></p>\n\n        <form novalidate class="form-horizontal" ng-submit="vm.login($event)">\n            <div class="form-group">\n                <div class="col-xs-12">\n                    <div class="input-group">\n                        <span class="input-group-addon">\n                            <i class="glyphicon glyphicon-user"></i>\n                        </span>\n                        <input type="text" class="form-control" id="username"\n                            placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.username">\n                    </div>\n                </div>\n            </div>\n            <!--===================\u5BC6\u7801-->\n            <!-- <div class="form-group">\n                    <div class="col-xs-12">\n                        <div class="input-group">\n                            <span class="input-group-addon">\n                                <i class="glyphicon glyphicon-lock"></i>\n                            </span>\n                            <input type="{{vm.passwordType}}" class="form-control" id="password" placeholder="{{\'login.form.password.placeholder\' | translate}}"\n                                ng-model="vm.password">\n                        </div>\n                    </div>\n                </div> -->\n            <password-show></password-show>\n\n            <div class="form-group">\n                <div class="col-xs-5">\n                    <div class="input-group">\n                        <input type="text" class="form-control" placeholder="{{\'login.showMsg.verifyCode\'|translate}}"\n                            ng-model="vm.verifyCode">\n                    </div>\n                </div>\n                <!--ng-click="vm.refreshVerifyCode();"-->\n                <div class="col-xs-7" style="padding-left: 0;">\n                    <!--<img src="{{vm.verifyCodeSrc}}" id="verifyCodeId">-->\n                    <!--<button class="btn btn-default" style="outline:none">\u83B7\u53D6\u9A8C\u8BC1\u7801</button>-->\n                    <input id="sendSmVerifyCodeBtn" type="button" class="btn btn-default"\n                        style="outline:none; width: 100%; background-color:#f5f5f5;" value="\u83B7\u53D6\u624B\u673A\u9A8C\u8BC1\u7801"\n                        ng-click="vm.sendSm()"></input>\n                </div>\n            </div>\n            <p style="color: #fff; letter-spacing: 1px" ng-show="vm.showSmTip">\n                \u9A8C\u8BC1\u7801\u5DF2\u53D1\u9001\u81F3\u60A8\u7684\u624B\u673A\u3002\n            </p>\n            <div class="form-group">\n                <div class="col-xs-12">\n                    <button type="submit" class="btn btn-primary btn-block" data-translate="login.form.button"\n                        ng-style="vm.myBtnStyle">\n                        \u767B\u5F55\n                    </button>\n                </div>\n            </div>\n\n            <div class="form-group">\n                <div class="col-xs-12" style="text-align: right;">\n                    <a ng-click="vm.showResetPwdModal()" ng-style="vm.myLinkStyle">\n                        \u5FD8\u8BB0\u5BC6\u7801\n                    </a>\n                </div>\n            </div>\n        </form>\n    </div>\n    <div\n        style="width: 100%;position: fixed;bottom: 0;text-align: center;color: #fff;padding:10px;text-shadow: 1px 1px #000;">\n        {{vm.ICP}}\n    </div>\n</div>\n<div class="container">\n    <div class="row">\n        <div class="grid_cl" ng-if="vm.organizations">\n            <h3 class="title" data-translate="login.appList">\u5E94\u7528\u5217\u8868</h3>\n        </div>\n        <!-- <div class="index-title" style="margin-top: 45px;">\n            <h2>\u53EF\u7528\u5E94\u7528</h2>\n        </div> -->\n        <ul class="login_application row">\n            <li ng-repeat="item in vm.usableApp" ng-click="vm.usableAppDetail(item)">\n                <p>\n                    <img ng-src="{{vm.downloadSrc}}{{item.appIcon}}">\n                    <span ng-if="$root.languageKey== \'zh-cn\'">{{item.moduleName}}</span>\n                    <span ng-if="$root.languageKey== \'en\'">{{item.moduleEnName}}</span>\n                </p>\n                <div class="review-wrapper">\n                    <span ng-if="$root.languageKey== \'zh-cn\'">{{item.describeCN}}</span>\n                    <span ng-if="$root.languageKey== \'en\'">{{item.describeEN}}</span>\n                </div>\n            </li>\n        </ul>\n    </div>\n</div>\n<div class="grid_cl" ng-if="vm.organizations">\n    <h3 class="title" data-translate="login.leagueOrganization">\u52A0\u76DF\u673A\u6784</h3>\n</div>\n\n<div class="franchisor container-1200" style="padding: -5px;">\n    <ul class="clearfix">\n        <li ng-repeat="item in vm.organizations">\n            <a>\n                <img ng-src="{{vm.downloadSrc}}{{item}}">\n            </a>\n        </li>\n    </ul>\n</div>');
$templateCache.put('app/pages/modalPage/activate.html','<div class="modal-header">\n\t<button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button>\n\t<h4 class="modal-title" data-translate="activate.title">\u6FC0\u6D3B</h4>\n</div>\n<div class="modal-body">\n\t<div class="row">\n\t\t<div class="col-sm-12">\n\t\t\t<form novalidate class="form-horizontal" name="vm.applyForm" id="applyForm">\n\t\t\t\t<div class="form-group" ng-if="vm.type == 1">\n\t\t\t\t\t<label class="col-sm-3 control-label" data-translate="activate.endorseOrg">\u63A5\u5165\u70B9(\u673A\u6784)</label>\n\t\t\t\t\t<div class="col-sm-7">\n\t\t\t\t\t\t<input type="text" ng-model="vm.endorseOrgObj" autocomplete="off" ng-model-options="vm.modelOptions" ng-change="vm.deleteEndorseOrg()"\n\t\t\t\t\t\t    uib-typeahead="org as org.orgName for org in vm.queryLocalOrgList($viewValue)" class="form-control" name="eOrgCode"\n\t\t\t\t\t\t    placeholder="{{\'global.pleaseChoose\'|translate}}{{\'home.regiest.orgName\'|translate}}">\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<!-- licence -->\n\t\t\t\t<div class="form-group" ng-if="vm.type !== 4 && vm.activeApp.price != 0">\n\n\t\t\t\t\t<label class="col-sm-3 control-label">Licence</label>\n\t\t\t\t\t<div class="col-sm-7">\n\t\t\t\t\t\t<textarea ng-model="vm.privateKey" style="min-height:200px;width:100%;resize:none;border: 1px solid #ccc;" required></textarea>\n\t\t\t\t\t</div>\n\t\t\t\t\t<label class="col-sm-offset-4 text" style="color: #cccccc;" ng-if="$root.languageKey== \'zh-cn\'"> \u83B7\u53D6licence\u8BF7\u8054\u7CFB {{vm.contact}}</label>\n\t\t\t\t\t<label class="col-sm-offset-4 text" style="color: #cccccc;" ng-if="$root.languageKey== \'en\'">Contact {{vm.contact}} for Licence</label>\n\n\t\t\t\t\t<div class="col-sm-offset-2 col-sm-9 text-right" style="text-align: center"g-if="vm.type == 1 || vm.type == 2">\n\t\t\t\t\t\t<p>{{\'home.regiest.3DaysLicenceTrail\'|translate}}\n\t\t\t\t\t\t\t<a ng-click="vm.downLicence()" data-translate="home.regiest.downLicence">\u4E0B\u8F7DLicence</a>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="form-group" ng-if="vm.type !== 3">\n\t\t\t\t\t<label class="control-label" data-translate="home.regiest.pchooserole" ng-class="{\'col-sm-8\': $root.languageKey == \'en\',\'col-sm-3\': $root.languageKey == \'zh-cn\' }">\u8BF7\u9009\u62E9\u89D2\u8272(\u53EF\u591A\u9009)</label>\n\n\n\t\t\t\t\t<div ng-class="{\'col-sm-offset-1 col-sm-10\': $root.languageKey == \'en\',\'col-sm-7\': $root.languageKey == \'zh-cn\' }">\n\t\t\t\t\t\t<div class="row">\n\t\t\t\t\t\t\t<div class="col-sm-6" ng-repeat="item in vm.roleList">\n\t\t\t\t\t\t\t\t<div class="checkbox">\n\t\t\t\t\t\t\t\t\t<label>\n\t\t\t\t\t\t\t\t\t\t<input type="checkbox" ng-model="vm.checkList[item.id]" ng-click="vm.checkRole($event,item.roleSelectSta);" ng-checked="item.selected"\n\t\t\t\t\t\t\t\t\t\t    ng-disabled="(item.roleSelectSta !== vm.flagDisable) && (vm.flagDisable !== null) || vm.specialFlag" class="text"\n\t\t\t\t\t\t\t\t\t\t    value="{{item.id}}">\n\t\t\t\t\t\t\t\t\t\t<span class="text" ng-if="$root.languageKey== \'zh-cn\'">{{item.roleName}}</span>\n\t\t\t\t\t\t\t\t\t\t<span class="text" ng-if="$root.languageKey== \'en\'">{{item.roleEnName}}</span>\n\t\t\t\t\t\t\t\t\t</label>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-group" ng-if="vm.showBankNumber">\n\t\t\t\t\t<label class="col-sm-3 control-label" data-translate="activate.bankNumber">\u884C\u53F7</label>\n\t\t\t\t\t<div class="col-sm-7">\n\t\t\t\t\t\t<input type="text" class="form-control" ng-model="vm.activeApp.blExtendAttributes.orgCode">\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-group" ng-if="vm.type !== 3">\n\t\t\t\t\t<label class="col-sm-3 control-label" data-translate="activate.uscc">\u7EDF\u4E00\u793E\u4F1A\u4FE1\u7528\u7801</label>\n\t\t\t\t\t<div class="col-sm-7">\n\t\t\t\t\t\t<input type="text" class="form-control" ng-model="vm.activeApp.blExtendAttributes.uscc">\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t</form>\n\t\t\t<div class="form-group" style="text-align: center">\n\t\t\t\t<div ng-if="vm.activeApp.from ===\'ecosphere\'" class="col-sm-offset-5">\n\t\t\t\t\t<div class="col-sm-4">\n\t\t\t\t\t\t<button type="button" class="btn btn-warning" ng-disabled="vm.applyForm.$invalid" ng-click="vm.createuser()" data-translate="home.regiest.apply">Join</button>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div ng-if="vm.activeApp.from !==\'ecosphere\'" class="col-sm-offset-3 col-sm-7">\n\t\t\t\t\t<div class="col-sm-4">\n\t\t\t\t\t\t<button type="button" class="btn btn-warning" ng-disabled="vm.applyForm.$invalid" ng-click="vm.createuser()" data-translate="home.regiest.apply">\u7533\u8BF7\u52A0\u5165</button>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div ng-if="!$root.isPhysical && vm.activeApp.from !==\'ecosphere\'" class="col-sm-offset-2 col-sm-4">\n\t\t\t\t\t\t<button type="button" class="btn btn-danger" ng-click="vm.uninstallApp()" data-translate="home.regiest.uninstallApp">\u5378\u8F7D\u5E94\u7528</button>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>');
$templateCache.put('app/pages/modalPage/forgetPwd.html','<div class="modal-header">\n\t<button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button>\n\t<h4 class="modal-title" style="text-align: center;font-weight: bold;">\u91CD\u7F6E\u5BC6\u7801</h4>\n</div>\n<div class="modal-body" style="padding:30px;">\n\t<div class="row">\n\t\t<div class="col-sm-12">\n\t\t\t<div class="alert alert-danger" ng-show="vm.errorMsg">\n\t\t\t\t{{vm.errorMsg}}\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class="col-sm-12">\n\t\t\t<form novalidate class="form-horizontal" ng-submit="vm.hanldeSave($event)" name="vm.myform">\n\t\t\t\t<div class="form-group">\n\t\t\t\t\t<div class="col-xs-12">\n\t\t\t\t\t\t<div class="input-group">\n\t\t\t\t\t\t\t<span class="input-group-addon">\n\t\t\t\t\t\t\t\t<i class="glyphicon glyphicon-user"></i>\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t<input type="text" class="form-control" id="username" placeholder="\u8BF7\u8F93\u5165\u767B\u5F55\u540D"\n\t\t\t\t\t\t\t\tng-model="vm.username">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-group">\n\t\t\t\t\t<div class="col-xs-12">\n\t\t\t\t\t\t<div class="input-group">\n\t\t\t\t\t\t\t<span class="input-group-addon">\n\t\t\t\t\t\t\t\t<i class="glyphicon glyphicon-phone"></i>\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t<input type="text" class="form-control" id="phone" placeholder="\u8BF7\u8F93\u5165\u624B\u673A\u53F7" ng-model="vm.phone">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class="form-group">\n\t\t\t\t\t<div class="col-xs-5">\n\t\t\t\t\t\t<input type="text" class="form-control" placeholder="\u8BF7\u8F93\u5165\u9A8C\u8BC1\u7801" ng-model="vm.verifyCode">\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class="col-xs-7" style="padding-left: 0;">\n\t\t\t\t\t\t<input id="sendSmVerifyCodeBtn" type="button" class="btn btn-default"\n\t\t\t\t\t\t\tstyle="outline:none; width: 100%; background-color:#f5f5f5;" value="\u83B7\u53D6\u624B\u673A\u9A8C\u8BC1\u7801"\n\t\t\t\t\t\t\tng-click="vm.sendSm()"></input>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<p style="color: \'#aaa\'; letter-spacing: 1px" ng-show="vm.showSmTip">\n\t\t\t\t\t\u9A8C\u8BC1\u7801\u5DF2\u53D1\u9001\u81F3\u60A8\u7684\u624B\u673A\u3002\n\t\t\t\t</p>\n\n\t\t\t\t<password-show></password-show>\n\n\t\t\t\t<div class="form-group">\n\t\t\t\t\t<div class="col-xs-12">\n\t\t\t\t\t\t<div class="input-group" style="border:1px solid #91d5ff;\n\t\t\t\t\t\tbackground-color: #e6f7ff;\n\t\t\t\t\t\tbox-sizing: border-box;\n\t\t\t\t\t\tmargin: 0;\n\t\t\t\t\t\tpadding: 0;\n\t\t\t\t\t\tcolor: rgba(0, 0, 0, 0.85);\n\t\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\t\tfont-variant: tabular-nums;\n\t\t\t\t\t\tline-height: 1.5715;\n\t\t\t\t\t\tlist-style: none;\n\t\t\t\t\t\tposition: relative;\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\tpadding: 8px 15px;\n\t\t\t\t\t\tword-wrap: break-word;\n\t\t\t\t\t\tborder-radius: 2px;\n\t\t\t\t\t  ">\n\t\t\t\t\t\t\t\u5BC6\u7801\u5FC5\u987B\u662F8-20\u4E2A\u82F1\u6587\u5B57\u6BCD\u3001\u6570\u5B57\u3001\u7279\u6B8A\u5B57\u7B26\u7684\u7EC4\u5408\uFF0C\u4E14\u5FC5\u987B\u540C\u65F6\u5305\u542B\u5927\u5C0F\u5199\u5B57\u6BCD\u3002\uFF08\u7279\u6B8A\u5B57\u7B26\u6709@#$%*&?!_\uFF09\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t<div class="form-group">\n\t\t\t\t\t<div class="col-xs-12">\n\t\t\t\t\t\t<div class="input-group">\n\t\t\t\t\t\t\t<span class="input-group-addon">\n\t\t\t\t\t\t\t\t<i class="glyphicon glyphicon-lock"></i>\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t<input type="{{vm.passwordshow?\'text\':\'password\'}}" class="form-control" id="passwordRepeat"\n\t\t\t\t\t\t\t\tplaceholder="\u8BF7\u518D\u6B21\u8F93\u5165\u5BC6\u7801" ng-model="vm.passwordRepeat">\n\n\t\t\t\t\t\t\t<span>\n\t\t\t\t\t\t\t\t<i ng-click="vm.passwordshow=!vm.passwordshow"\n\t\t\t\t\t\t\t\t\tclass="glyphicon form-control-feedback-passwordshow"\n\t\t\t\t\t\t\t\t\tng-class="{\'glyphicon-eye-open\':vm.passwordshow,\'glyphicon-eye-close\':!vm.passwordshow}"></i>\n\t\t\t\t\t\t\t</span>\n\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\n\n\t\t\t\t<div class="form-group">\n\t\t\t\t\t<div class="col-xs-12">\n\t\t\t\t\t\t<button type="submit" class="btn btn-primary btn-block"\n\t\t\t\t\t\t\tstyle="margin-top: 20px;font-size: 16px;" ng-style="vm.myBtnStyle">\n\t\t\t\t\t\t\t\u786E\u5B9A\n\t\t\t\t\t\t</button>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</form>\n\t\t</div>\n\t</div>\n</div>');
$templateCache.put('app/components/bizUI/uploadIcon/uploadIcon.html','<i class="iconfont icon-file text-warning">&#xe815;</i>');
$templateCache.put('app/components/form/hInput/hInput.html','<p ng-if="mvalue.length > maxlength && mtype==\'p\'" class="col-sm-4 span-border maxellipsis" ng-bind="mvalue" uib-popover-template="dynamicPopover.templateUrl" popover-trigger="mouseover" ng-mouseover="vm.inputmouseOver($event)" ng-mouseout="vm.inputmouseOut($event)" popover-placement="top" popover-is-open="vm.isShow"></p>\n<p ng-if="mvalue.length <= maxlength && mtype==\'p\'" class="col-sm-4 span-border" ng-bind="mvalue"></p>\n\n<p ng-if="mvalue.length > maxlength && mtype==\'p0\'" ng-bind="mvalue" class="maxellipsis {{mclass}}" uib-popover-template="dynamicPopover.templateUrl" popover-trigger="mouseover" ng-mouseover="vm.inputmouseOver($event)" ng-mouseout="vm.inputmouseOut($event)" popover-placement="top" popover-is-open="vm.isShow"></p>\n<p ng-if="mvalue.length <= maxlength && mtype==\'p0\'" ng-bind="mvalue" class="maxellipsis {{mclass}}"></p>\n\n<font ng-if="mvalue.length > maxlength && mtype==\'font\'"  class="maxellipsis {{mclass}}" ng-bind="mvalue" uib-popover-template="dynamicPopover.templateUrl" popover-trigger="mouseover" ng-mouseover="vm.inputmouseOver($event)" ng-mouseout="vm.inputmouseOut($event)" popover-placement="top" popover-is-open="vm.isShow"></font>\n<font ng-if="mvalue.length <= maxlength && mtype==\'font\'" class="{{mclass}}" ng-bind="mvalue"></font>\n\n<h5 ng-if="mvalue.length > maxlength && mtype==\'h5\'"  class="maxellipsis {{mclass}}"  ng-bind="mvalue" uib-popover-template="dynamicPopover.templateUrl" popover-trigger="mouseover" ng-mouseover="vm.inputmouseOver($event)" ng-mouseout="vm.inputmouseOut($event)" popover-placement="top" popover-is-open="vm.isShow"></h5>\n<h5 ng-if="mvalue.length <= maxlength && mtype==\'h5\'" class="{{mclass}}" ng-bind="mvalue"></h5>\n\n<a ng-if="mvalue.length > maxlength && mtype==\'a\'"  class="maxellipsis {{mclass}}"  ng-bind="mvalue" uib-popover-template="dynamicPopover.templateUrl" popover-trigger="mouseover" ng-mouseover="vm.inputmouseOver($event)" ng-mouseout="vm.inputmouseOut($event)" popover-placement="bottom" popover-is-open="vm.isShow"></a>\n<a ng-if="mvalue.length <= maxlength && mtype==\'a\'" class="{{mclass}}" ng-bind="mvalue"></a>\n\n<h3 ng-if="mvalue.length > maxlength && mtype==\'h3\'"  class="maxellipsis {{mclass}}"  ng-bind="mvalue" uib-popover-template="dynamicPopover.templateUrl" popover-trigger="mouseover" ng-mouseover="vm.inputmouseOver($event)" ng-mouseout="vm.inputmouseOut($event)" popover-placement="bottom" popover-is-open="vm.isShow"></h3>\n<h3 ng-if="mvalue.length <= maxlength && mtype==\'h3\'" class="{{mclass}}" ng-bind="mvalue"></h3>\n<script type="text/ng-template" id="popover.html">\n\t<div style="max-width:250px;"  ng-class="{\'miw250\':\'miw250\'}[inclass]" style="max-width:250px;">\n\t\t<p style="word-wrap:break-word;margin:0 0 10px;">{{mvalue}}</p>\n\t</div>\n</script>\n');
$templateCache.put('app/components/form/sectionShow/sectionShow.html','<b class="col-sm-10 span-phase" ng-class="{\'overhidden\':vm.hasOverflow}">{{mvalue}}\n    <a href="javascript:void(0);" ng-if="vm.isShowSection"  class="collapse" ng-click="vm.collapse($event)">\u6298\u53E0</a>\n</b>\n<a href="javascript:void(0);" ng-if="vm.isShowSection"class="showmore" ng-click="vm.showmore($event)">\u66F4\u591A</a>');}]);})();